function us(X) {
  return X && X.__esModule && Object.prototype.hasOwnProperty.call(X, "default") ? X.default : X;
}
var ql = { exports: {} }, ve = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ts;
function cs() {
  if (ts) return ve;
  ts = 1;
  var X = Symbol.for("react.element"), R = Symbol.for("react.portal"), Q = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), v = Symbol.for("react.profiler"), ue = Symbol.for("react.provider"), pt = Symbol.for("react.context"), xe = Symbol.for("react.forward_ref"), _ = Symbol.for("react.suspense"), F = Symbol.for("react.memo"), et = Symbol.for("react.lazy"), B = Symbol.iterator;
  function pe(b) {
    return b === null || typeof b != "object" ? null : (b = B && b[B] || b["@@iterator"], typeof b == "function" ? b : null);
  }
  var ct = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, ae = Object.assign, Ue = {};
  function z(b, O, ie) {
    this.props = b, this.context = O, this.refs = Ue, this.updater = ie || ct;
  }
  z.prototype.isReactComponent = {}, z.prototype.setState = function(b, O) {
    if (typeof b != "object" && typeof b != "function" && b != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, b, O, "setState");
  }, z.prototype.forceUpdate = function(b) {
    this.updater.enqueueForceUpdate(this, b, "forceUpdate");
  };
  function M() {
  }
  M.prototype = z.prototype;
  function Ie(b, O, ie) {
    this.props = b, this.context = O, this.refs = Ue, this.updater = ie || ct;
  }
  var tt = Ie.prototype = new M();
  tt.constructor = Ie, ae(tt, z.prototype), tt.isPureReactComponent = !0;
  var Pe = Array.isArray, ne = Object.prototype.hasOwnProperty, he = { current: null }, de = { key: !0, ref: !0, __self: !0, __source: !0 };
  function Je(b, O, ie) {
    var oe, J = {}, re = null, ye = null;
    if (O != null) for (oe in O.ref !== void 0 && (ye = O.ref), O.key !== void 0 && (re = "" + O.key), O) ne.call(O, oe) && !de.hasOwnProperty(oe) && (J[oe] = O[oe]);
    var Se = arguments.length - 2;
    if (Se === 1) J.children = ie;
    else if (1 < Se) {
      for (var ce = Array(Se), Fe = 0; Fe < Se; Fe++) ce[Fe] = arguments[Fe + 2];
      J.children = ce;
    }
    if (b && b.defaultProps) for (oe in Se = b.defaultProps, Se) J[oe] === void 0 && (J[oe] = Se[oe]);
    return { $$typeof: X, type: b, key: re, ref: ye, props: J, _owner: he.current };
  }
  function Ce(b, O) {
    return { $$typeof: X, type: b.type, key: O, ref: b.ref, props: b.props, _owner: b._owner };
  }
  function ht(b) {
    return typeof b == "object" && b !== null && b.$$typeof === X;
  }
  function vt(b) {
    var O = { "=": "=0", ":": "=2" };
    return "$" + b.replace(/[=:]/g, function(ie) {
      return O[ie];
    });
  }
  var Ye = /\/+/g;
  function kt(b, O) {
    return typeof b == "object" && b !== null && b.key != null ? vt("" + b.key) : O.toString(36);
  }
  function rt(b, O, ie, oe, J) {
    var re = typeof b;
    (re === "undefined" || re === "boolean") && (b = null);
    var ye = !1;
    if (b === null) ye = !0;
    else switch (re) {
      case "string":
      case "number":
        ye = !0;
        break;
      case "object":
        switch (b.$$typeof) {
          case X:
          case R:
            ye = !0;
        }
    }
    if (ye) return ye = b, J = J(ye), b = oe === "" ? "." + kt(ye, 0) : oe, Pe(J) ? (ie = "", b != null && (ie = b.replace(Ye, "$&/") + "/"), rt(J, O, ie, "", function(Fe) {
      return Fe;
    })) : J != null && (ht(J) && (J = Ce(J, ie + (!J.key || ye && ye.key === J.key ? "" : ("" + J.key).replace(Ye, "$&/") + "/") + b)), O.push(J)), 1;
    if (ye = 0, oe = oe === "" ? "." : oe + ":", Pe(b)) for (var Se = 0; Se < b.length; Se++) {
      re = b[Se];
      var ce = oe + kt(re, Se);
      ye += rt(re, O, ie, ce, J);
    }
    else if (ce = pe(b), typeof ce == "function") for (b = ce.call(b), Se = 0; !(re = b.next()).done; ) re = re.value, ce = oe + kt(re, Se++), ye += rt(re, O, ie, ce, J);
    else if (re === "object") throw O = String(b), Error("Objects are not valid as a React child (found: " + (O === "[object Object]" ? "object with keys {" + Object.keys(b).join(", ") + "}" : O) + "). If you meant to render a collection of children, use an array instead.");
    return ye;
  }
  function nt(b, O, ie) {
    if (b == null) return b;
    var oe = [], J = 0;
    return rt(b, oe, "", "", function(re) {
      return O.call(ie, re, J++);
    }), oe;
  }
  function xt(b) {
    if (b._status === -1) {
      var O = b._result;
      O = O(), O.then(function(ie) {
        (b._status === 0 || b._status === -1) && (b._status = 1, b._result = ie);
      }, function(ie) {
        (b._status === 0 || b._status === -1) && (b._status = 2, b._result = ie);
      }), b._status === -1 && (b._status = 0, b._result = O);
    }
    if (b._status === 1) return b._result.default;
    throw b._result;
  }
  var G = { current: null }, Qe = { transition: null }, Ke = { ReactCurrentDispatcher: G, ReactCurrentBatchConfig: Qe, ReactCurrentOwner: he };
  function Rt() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return ve.Children = { map: nt, forEach: function(b, O, ie) {
    nt(b, function() {
      O.apply(this, arguments);
    }, ie);
  }, count: function(b) {
    var O = 0;
    return nt(b, function() {
      O++;
    }), O;
  }, toArray: function(b) {
    return nt(b, function(O) {
      return O;
    }) || [];
  }, only: function(b) {
    if (!ht(b)) throw Error("React.Children.only expected to receive a single React element child.");
    return b;
  } }, ve.Component = z, ve.Fragment = Q, ve.Profiler = v, ve.PureComponent = Ie, ve.StrictMode = q, ve.Suspense = _, ve.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ke, ve.act = Rt, ve.cloneElement = function(b, O, ie) {
    if (b == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + b + ".");
    var oe = ae({}, b.props), J = b.key, re = b.ref, ye = b._owner;
    if (O != null) {
      if (O.ref !== void 0 && (re = O.ref, ye = he.current), O.key !== void 0 && (J = "" + O.key), b.type && b.type.defaultProps) var Se = b.type.defaultProps;
      for (ce in O) ne.call(O, ce) && !de.hasOwnProperty(ce) && (oe[ce] = O[ce] === void 0 && Se !== void 0 ? Se[ce] : O[ce]);
    }
    var ce = arguments.length - 2;
    if (ce === 1) oe.children = ie;
    else if (1 < ce) {
      Se = Array(ce);
      for (var Fe = 0; Fe < ce; Fe++) Se[Fe] = arguments[Fe + 2];
      oe.children = Se;
    }
    return { $$typeof: X, type: b.type, key: J, ref: re, props: oe, _owner: ye };
  }, ve.createContext = function(b) {
    return b = { $$typeof: pt, _currentValue: b, _currentValue2: b, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, b.Provider = { $$typeof: ue, _context: b }, b.Consumer = b;
  }, ve.createElement = Je, ve.createFactory = function(b) {
    var O = Je.bind(null, b);
    return O.type = b, O;
  }, ve.createRef = function() {
    return { current: null };
  }, ve.forwardRef = function(b) {
    return { $$typeof: xe, render: b };
  }, ve.isValidElement = ht, ve.lazy = function(b) {
    return { $$typeof: et, _payload: { _status: -1, _result: b }, _init: xt };
  }, ve.memo = function(b, O) {
    return { $$typeof: F, type: b, compare: O === void 0 ? null : O };
  }, ve.startTransition = function(b) {
    var O = Qe.transition;
    Qe.transition = {};
    try {
      b();
    } finally {
      Qe.transition = O;
    }
  }, ve.unstable_act = Rt, ve.useCallback = function(b, O) {
    return G.current.useCallback(b, O);
  }, ve.useContext = function(b) {
    return G.current.useContext(b);
  }, ve.useDebugValue = function() {
  }, ve.useDeferredValue = function(b) {
    return G.current.useDeferredValue(b);
  }, ve.useEffect = function(b, O) {
    return G.current.useEffect(b, O);
  }, ve.useId = function() {
    return G.current.useId();
  }, ve.useImperativeHandle = function(b, O, ie) {
    return G.current.useImperativeHandle(b, O, ie);
  }, ve.useInsertionEffect = function(b, O) {
    return G.current.useInsertionEffect(b, O);
  }, ve.useLayoutEffect = function(b, O) {
    return G.current.useLayoutEffect(b, O);
  }, ve.useMemo = function(b, O) {
    return G.current.useMemo(b, O);
  }, ve.useReducer = function(b, O, ie) {
    return G.current.useReducer(b, O, ie);
  }, ve.useRef = function(b) {
    return G.current.useRef(b);
  }, ve.useState = function(b) {
    return G.current.useState(b);
  }, ve.useSyncExternalStore = function(b, O, ie) {
    return G.current.useSyncExternalStore(b, O, ie);
  }, ve.useTransition = function() {
    return G.current.useTransition();
  }, ve.version = "18.3.1", ve;
}
var di = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
di.exports;
var rs;
function fs() {
  return rs || (rs = 1, function(X, R) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var Q = "18.3.1", q = Symbol.for("react.element"), v = Symbol.for("react.portal"), ue = Symbol.for("react.fragment"), pt = Symbol.for("react.strict_mode"), xe = Symbol.for("react.profiler"), _ = Symbol.for("react.provider"), F = Symbol.for("react.context"), et = Symbol.for("react.forward_ref"), B = Symbol.for("react.suspense"), pe = Symbol.for("react.suspense_list"), ct = Symbol.for("react.memo"), ae = Symbol.for("react.lazy"), Ue = Symbol.for("react.offscreen"), z = Symbol.iterator, M = "@@iterator";
      function Ie(f) {
        if (f === null || typeof f != "object")
          return null;
        var S = z && f[z] || f[M];
        return typeof S == "function" ? S : null;
      }
      var tt = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, Pe = {
        transition: null
      }, ne = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, he = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, de = {}, Je = null;
      function Ce(f) {
        Je = f;
      }
      de.setExtraStackFrame = function(f) {
        Je = f;
      }, de.getCurrentStack = null, de.getStackAddendum = function() {
        var f = "";
        Je && (f += Je);
        var S = de.getCurrentStack;
        return S && (f += S() || ""), f;
      };
      var ht = !1, vt = !1, Ye = !1, kt = !1, rt = !1, nt = {
        ReactCurrentDispatcher: tt,
        ReactCurrentBatchConfig: Pe,
        ReactCurrentOwner: he
      };
      nt.ReactDebugCurrentFrame = de, nt.ReactCurrentActQueue = ne;
      function xt(f) {
        {
          for (var S = arguments.length, T = new Array(S > 1 ? S - 1 : 0), P = 1; P < S; P++)
            T[P - 1] = arguments[P];
          Qe("warn", f, T);
        }
      }
      function G(f) {
        {
          for (var S = arguments.length, T = new Array(S > 1 ? S - 1 : 0), P = 1; P < S; P++)
            T[P - 1] = arguments[P];
          Qe("error", f, T);
        }
      }
      function Qe(f, S, T) {
        {
          var P = nt.ReactDebugCurrentFrame, H = P.getStackAddendum();
          H !== "" && (S += "%s", T = T.concat([H]));
          var Y = T.map(function($) {
            return String($);
          });
          Y.unshift("Warning: " + S), Function.prototype.apply.call(console[f], console, Y);
        }
      }
      var Ke = {};
      function Rt(f, S) {
        {
          var T = f.constructor, P = T && (T.displayName || T.name) || "ReactClass", H = P + "." + S;
          if (Ke[H])
            return;
          G("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", S, P), Ke[H] = !0;
        }
      }
      var b = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(f) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(f, S, T) {
          Rt(f, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(f, S, T, P) {
          Rt(f, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(f, S, T, P) {
          Rt(f, "setState");
        }
      }, O = Object.assign, ie = {};
      Object.freeze(ie);
      function oe(f, S, T) {
        this.props = f, this.context = S, this.refs = ie, this.updater = T || b;
      }
      oe.prototype.isReactComponent = {}, oe.prototype.setState = function(f, S) {
        if (typeof f != "object" && typeof f != "function" && f != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, f, S, "setState");
      }, oe.prototype.forceUpdate = function(f) {
        this.updater.enqueueForceUpdate(this, f, "forceUpdate");
      };
      {
        var J = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, re = function(f, S) {
          Object.defineProperty(oe.prototype, f, {
            get: function() {
              xt("%s(...) is deprecated in plain JavaScript React classes. %s", S[0], S[1]);
            }
          });
        };
        for (var ye in J)
          J.hasOwnProperty(ye) && re(ye, J[ye]);
      }
      function Se() {
      }
      Se.prototype = oe.prototype;
      function ce(f, S, T) {
        this.props = f, this.context = S, this.refs = ie, this.updater = T || b;
      }
      var Fe = ce.prototype = new Se();
      Fe.constructor = ce, O(Fe, oe.prototype), Fe.isPureReactComponent = !0;
      function ot() {
        var f = {
          current: null
        };
        return Object.seal(f), f;
      }
      var Ar = Array.isArray;
      function Le(f) {
        return Ar(f);
      }
      function at(f) {
        {
          var S = typeof Symbol == "function" && Symbol.toStringTag, T = S && f[Symbol.toStringTag] || f.constructor.name || "Object";
          return T;
        }
      }
      function Dr(f) {
        try {
          return cr(f), !1;
        } catch {
          return !0;
        }
      }
      function cr(f) {
        return "" + f;
      }
      function xr(f) {
        if (Dr(f))
          return G("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", at(f)), cr(f);
      }
      function _t(f, S, T) {
        var P = f.displayName;
        if (P)
          return P;
        var H = S.displayName || S.name || "";
        return H !== "" ? T + "(" + H + ")" : T;
      }
      function fr(f) {
        return f.displayName || "Context";
      }
      function ft(f) {
        if (f == null)
          return null;
        if (typeof f.tag == "number" && G("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof f == "function")
          return f.displayName || f.name || null;
        if (typeof f == "string")
          return f;
        switch (f) {
          case ue:
            return "Fragment";
          case v:
            return "Portal";
          case xe:
            return "Profiler";
          case pt:
            return "StrictMode";
          case B:
            return "Suspense";
          case pe:
            return "SuspenseList";
        }
        if (typeof f == "object")
          switch (f.$$typeof) {
            case F:
              var S = f;
              return fr(S) + ".Consumer";
            case _:
              var T = f;
              return fr(T._context) + ".Provider";
            case et:
              return _t(f, f.render, "ForwardRef");
            case ct:
              var P = f.displayName || null;
              return P !== null ? P : ft(f.type) || "Memo";
            case ae: {
              var H = f, Y = H._payload, $ = H._init;
              try {
                return ft($(Y));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var dr = Object.prototype.hasOwnProperty, Ct = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ze, je, Cr;
      Cr = {};
      function Or(f) {
        if (dr.call(f, "ref")) {
          var S = Object.getOwnPropertyDescriptor(f, "ref").get;
          if (S && S.isReactWarning)
            return !1;
        }
        return f.ref !== void 0;
      }
      function Mr(f) {
        if (dr.call(f, "key")) {
          var S = Object.getOwnPropertyDescriptor(f, "key").get;
          if (S && S.isReactWarning)
            return !1;
        }
        return f.key !== void 0;
      }
      function He(f, S) {
        var T = function() {
          Ze || (Ze = !0, G("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        T.isReactWarning = !0, Object.defineProperty(f, "key", {
          get: T,
          configurable: !0
        });
      }
      function Yr(f, S) {
        var T = function() {
          je || (je = !0, G("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        T.isReactWarning = !0, Object.defineProperty(f, "ref", {
          get: T,
          configurable: !0
        });
      }
      function sn(f) {
        if (typeof f.ref == "string" && he.current && f.__self && he.current.stateNode !== f.__self) {
          var S = ft(he.current.type);
          Cr[S] || (G('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', S, f.ref), Cr[S] = !0);
        }
      }
      var Lr = function(f, S, T, P, H, Y, $) {
        var ee = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: q,
          // Built-in properties that belong on the element
          type: f,
          key: S,
          ref: T,
          props: $,
          // Record the component responsible for creating this element.
          _owner: Y
        };
        return ee._store = {}, Object.defineProperty(ee._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(ee, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: P
        }), Object.defineProperty(ee, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: H
        }), Object.freeze && (Object.freeze(ee.props), Object.freeze(ee)), ee;
      };
      function Gr(f, S, T) {
        var P, H = {}, Y = null, $ = null, ee = null, le = null;
        if (S != null) {
          Or(S) && ($ = S.ref, sn(S)), Mr(S) && (xr(S.key), Y = "" + S.key), ee = S.__self === void 0 ? null : S.__self, le = S.__source === void 0 ? null : S.__source;
          for (P in S)
            dr.call(S, P) && !Ct.hasOwnProperty(P) && (H[P] = S[P]);
        }
        var be = arguments.length - 2;
        if (be === 1)
          H.children = T;
        else if (be > 1) {
          for (var _e = Array(be), we = 0; we < be; we++)
            _e[we] = arguments[we + 2];
          Object.freeze && Object.freeze(_e), H.children = _e;
        }
        if (f && f.defaultProps) {
          var Te = f.defaultProps;
          for (P in Te)
            H[P] === void 0 && (H[P] = Te[P]);
        }
        if (Y || $) {
          var Ae = typeof f == "function" ? f.displayName || f.name || "Unknown" : f;
          Y && He(H, Ae), $ && Yr(H, Ae);
        }
        return Lr(f, Y, $, ee, le, he.current, H);
      }
      function Br(f, S) {
        var T = Lr(f.type, S, f.ref, f._self, f._source, f._owner, f.props);
        return T;
      }
      function wn(f, S, T) {
        if (f == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + f + ".");
        var P, H = O({}, f.props), Y = f.key, $ = f.ref, ee = f._self, le = f._source, be = f._owner;
        if (S != null) {
          Or(S) && ($ = S.ref, be = he.current), Mr(S) && (xr(S.key), Y = "" + S.key);
          var _e;
          f.type && f.type.defaultProps && (_e = f.type.defaultProps);
          for (P in S)
            dr.call(S, P) && !Ct.hasOwnProperty(P) && (S[P] === void 0 && _e !== void 0 ? H[P] = _e[P] : H[P] = S[P]);
        }
        var we = arguments.length - 2;
        if (we === 1)
          H.children = T;
        else if (we > 1) {
          for (var Te = Array(we), Ae = 0; Ae < we; Ae++)
            Te[Ae] = arguments[Ae + 2];
          H.children = Te;
        }
        return Lr(f.type, Y, $, ee, le, be, H);
      }
      function Lt(f) {
        return typeof f == "object" && f !== null && f.$$typeof === q;
      }
      var Zt = ".", Xr = ":";
      function un(f) {
        var S = /[=:]/g, T = {
          "=": "=0",
          ":": "=2"
        }, P = f.replace(S, function(H) {
          return T[H];
        });
        return "$" + P;
      }
      var it = !1, Bt = /\/+/g;
      function Jt(f) {
        return f.replace(Bt, "$&/");
      }
      function ge(f, S) {
        return typeof f == "object" && f !== null && f.key != null ? (xr(f.key), un("" + f.key)) : S.toString(36);
      }
      function It(f, S, T, P, H) {
        var Y = typeof f;
        (Y === "undefined" || Y === "boolean") && (f = null);
        var $ = !1;
        if (f === null)
          $ = !0;
        else
          switch (Y) {
            case "string":
            case "number":
              $ = !0;
              break;
            case "object":
              switch (f.$$typeof) {
                case q:
                case v:
                  $ = !0;
              }
          }
        if ($) {
          var ee = f, le = H(ee), be = P === "" ? Zt + ge(ee, 0) : P;
          if (Le(le)) {
            var _e = "";
            be != null && (_e = Jt(be) + "/"), It(le, S, _e, "", function(zn) {
              return zn;
            });
          } else le != null && (Lt(le) && (le.key && (!ee || ee.key !== le.key) && xr(le.key), le = Br(
            le,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            T + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (le.key && (!ee || ee.key !== le.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              Jt("" + le.key) + "/"
            ) : "") + be
          )), S.push(le));
          return 1;
        }
        var we, Te, Ae = 0, Xe = P === "" ? Zt : P + Xr;
        if (Le(f))
          for (var en = 0; en < f.length; en++)
            we = f[en], Te = Xe + ge(we, en), Ae += It(we, S, T, Te, H);
        else {
          var hn = Ie(f);
          if (typeof hn == "function") {
            var tn = f;
            hn === tn.entries && (it || xt("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), it = !0);
            for (var bt = hn.call(tn), En, vn = 0; !(En = bt.next()).done; )
              we = En.value, Te = Xe + ge(we, vn++), Ae += It(we, S, T, Te, H);
          } else if (Y === "object") {
            var Hn = String(f);
            throw new Error("Objects are not valid as a React child (found: " + (Hn === "[object Object]" ? "object with keys {" + Object.keys(f).join(", ") + "}" : Hn) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return Ae;
      }
      function Qt(f, S, T) {
        if (f == null)
          return f;
        var P = [], H = 0;
        return It(f, P, "", "", function(Y) {
          return S.call(T, Y, H++);
        }), P;
      }
      function Er(f) {
        var S = 0;
        return Qt(f, function() {
          S++;
        }), S;
      }
      function Ut(f, S, T) {
        Qt(f, function() {
          S.apply(this, arguments);
        }, T);
      }
      function Ur(f) {
        return Qt(f, function(S) {
          return S;
        }) || [];
      }
      function Kt(f) {
        if (!Lt(f))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return f;
      }
      function Ge(f) {
        var S = {
          $$typeof: F,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: f,
          _currentValue2: f,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        S.Provider = {
          $$typeof: _,
          _context: S
        };
        var T = !1, P = !1, H = !1;
        {
          var Y = {
            $$typeof: F,
            _context: S
          };
          Object.defineProperties(Y, {
            Provider: {
              get: function() {
                return P || (P = !0, G("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), S.Provider;
              },
              set: function($) {
                S.Provider = $;
              }
            },
            _currentValue: {
              get: function() {
                return S._currentValue;
              },
              set: function($) {
                S._currentValue = $;
              }
            },
            _currentValue2: {
              get: function() {
                return S._currentValue2;
              },
              set: function($) {
                S._currentValue2 = $;
              }
            },
            _threadCount: {
              get: function() {
                return S._threadCount;
              },
              set: function($) {
                S._threadCount = $;
              }
            },
            Consumer: {
              get: function() {
                return T || (T = !0, G("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), S.Consumer;
              }
            },
            displayName: {
              get: function() {
                return S.displayName;
              },
              set: function($) {
                H || (xt("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", $), H = !0);
              }
            }
          }), S.Consumer = Y;
        }
        return S._currentRenderer = null, S._currentRenderer2 = null, S;
      }
      var qt = -1, Tr = 0, Zr = 1, ze = 2;
      function Jr(f) {
        if (f._status === qt) {
          var S = f._result, T = S();
          if (T.then(function(Y) {
            if (f._status === Tr || f._status === qt) {
              var $ = f;
              $._status = Zr, $._result = Y;
            }
          }, function(Y) {
            if (f._status === Tr || f._status === qt) {
              var $ = f;
              $._status = ze, $._result = Y;
            }
          }), f._status === qt) {
            var P = f;
            P._status = Tr, P._result = T;
          }
        }
        if (f._status === Zr) {
          var H = f._result;
          return H === void 0 && G(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, H), "default" in H || G(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, H), H.default;
        } else
          throw f._result;
      }
      function kn(f) {
        var S = {
          // We use these fields to store the result.
          _status: qt,
          _result: f
        }, T = {
          $$typeof: ae,
          _payload: S,
          _init: Jr
        };
        {
          var P, H;
          Object.defineProperties(T, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return P;
              },
              set: function(Y) {
                G("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), P = Y, Object.defineProperty(T, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return H;
              },
              set: function(Y) {
                G("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), H = Y, Object.defineProperty(T, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return T;
      }
      function xn(f) {
        f != null && f.$$typeof === ct ? G("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof f != "function" ? G("forwardRef requires a render function but was given %s.", f === null ? "null" : typeof f) : f.length !== 0 && f.length !== 2 && G("forwardRef render functions accept exactly two parameters: props and ref. %s", f.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), f != null && (f.defaultProps != null || f.propTypes != null) && G("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var S = {
          $$typeof: et,
          render: f
        };
        {
          var T;
          Object.defineProperty(S, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return T;
            },
            set: function(P) {
              T = P, !f.name && !f.displayName && (f.displayName = P);
            }
          });
        }
        return S;
      }
      var Pt;
      Pt = Symbol.for("react.module.reference");
      function jr(f) {
        return !!(typeof f == "string" || typeof f == "function" || f === ue || f === xe || rt || f === pt || f === B || f === pe || kt || f === Ue || ht || vt || Ye || typeof f == "object" && f !== null && (f.$$typeof === ae || f.$$typeof === ct || f.$$typeof === _ || f.$$typeof === F || f.$$typeof === et || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        f.$$typeof === Pt || f.getModuleId !== void 0));
      }
      function Hr(f, S) {
        jr(f) || G("memo: The first argument must be a component. Instead received: %s", f === null ? "null" : typeof f);
        var T = {
          $$typeof: ct,
          type: f,
          compare: S === void 0 ? null : S
        };
        {
          var P;
          Object.defineProperty(T, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return P;
            },
            set: function(H) {
              P = H, !f.name && !f.displayName && (f.displayName = H);
            }
          });
        }
        return T;
      }
      function Oe() {
        var f = tt.current;
        return f === null && G(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), f;
      }
      function gt(f) {
        var S = Oe();
        if (f._context !== void 0) {
          var T = f._context;
          T.Consumer === f ? G("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : T.Provider === f && G("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return S.useContext(f);
      }
      function jt(f) {
        var S = Oe();
        return S.useState(f);
      }
      function zr(f, S, T) {
        var P = Oe();
        return P.useReducer(f, S, T);
      }
      function pr(f) {
        var S = Oe();
        return S.useRef(f);
      }
      function hr(f, S) {
        var T = Oe();
        return T.useEffect(f, S);
      }
      function Ht(f, S) {
        var T = Oe();
        return T.useInsertionEffect(f, S);
      }
      function vr(f, S) {
        var T = Oe();
        return T.useLayoutEffect(f, S);
      }
      function mt(f, S) {
        var T = Oe();
        return T.useCallback(f, S);
      }
      function cn(f, S) {
        var T = Oe();
        return T.useMemo(f, S);
      }
      function fn(f, S, T) {
        var P = Oe();
        return P.useImperativeHandle(f, S, T);
      }
      function er(f, S) {
        {
          var T = Oe();
          return T.useDebugValue(f, S);
        }
      }
      function We() {
        var f = Oe();
        return f.useTransition();
      }
      function zt(f) {
        var S = Oe();
        return S.useDeferredValue(f);
      }
      function Wt() {
        var f = Oe();
        return f.useId();
      }
      function gr(f, S, T) {
        var P = Oe();
        return P.useSyncExternalStore(f, S, T);
      }
      var $t = 0, Et, Ft, lt, tr, mr, Rr, yt;
      function At() {
      }
      At.__reactDisabledLog = !0;
      function dt() {
        {
          if ($t === 0) {
            Et = console.log, Ft = console.info, lt = console.warn, tr = console.error, mr = console.group, Rr = console.groupCollapsed, yt = console.groupEnd;
            var f = {
              configurable: !0,
              enumerable: !0,
              value: At,
              writable: !0
            };
            Object.defineProperties(console, {
              info: f,
              log: f,
              warn: f,
              error: f,
              group: f,
              groupCollapsed: f,
              groupEnd: f
            });
          }
          $t++;
        }
      }
      function Wr() {
        {
          if ($t--, $t === 0) {
            var f = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: O({}, f, {
                value: Et
              }),
              info: O({}, f, {
                value: Ft
              }),
              warn: O({}, f, {
                value: lt
              }),
              error: O({}, f, {
                value: tr
              }),
              group: O({}, f, {
                value: mr
              }),
              groupCollapsed: O({}, f, {
                value: Rr
              }),
              groupEnd: O({}, f, {
                value: yt
              })
            });
          }
          $t < 0 && G("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Ne = nt.ReactCurrentDispatcher, st;
      function a(f, S, T) {
        {
          if (st === void 0)
            try {
              throw Error();
            } catch (H) {
              var P = H.stack.trim().match(/\n( *(at )?)/);
              st = P && P[1] || "";
            }
          return `
` + st + f;
        }
      }
      var s = !1, h;
      {
        var m = typeof WeakMap == "function" ? WeakMap : Map;
        h = new m();
      }
      function C(f, S) {
        if (!f || s)
          return "";
        {
          var T = h.get(f);
          if (T !== void 0)
            return T;
        }
        var P;
        s = !0;
        var H = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Y;
        Y = Ne.current, Ne.current = null, dt();
        try {
          if (S) {
            var $ = function() {
              throw Error();
            };
            if (Object.defineProperty($.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct($, []);
              } catch (Xe) {
                P = Xe;
              }
              Reflect.construct(f, [], $);
            } else {
              try {
                $.call();
              } catch (Xe) {
                P = Xe;
              }
              f.call($.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Xe) {
              P = Xe;
            }
            f();
          }
        } catch (Xe) {
          if (Xe && P && typeof Xe.stack == "string") {
            for (var ee = Xe.stack.split(`
`), le = P.stack.split(`
`), be = ee.length - 1, _e = le.length - 1; be >= 1 && _e >= 0 && ee[be] !== le[_e]; )
              _e--;
            for (; be >= 1 && _e >= 0; be--, _e--)
              if (ee[be] !== le[_e]) {
                if (be !== 1 || _e !== 1)
                  do
                    if (be--, _e--, _e < 0 || ee[be] !== le[_e]) {
                      var we = `
` + ee[be].replace(" at new ", " at ");
                      return f.displayName && we.includes("<anonymous>") && (we = we.replace("<anonymous>", f.displayName)), typeof f == "function" && h.set(f, we), we;
                    }
                  while (be >= 1 && _e >= 0);
                break;
              }
          }
        } finally {
          s = !1, Ne.current = Y, Wr(), Error.prepareStackTrace = H;
        }
        var Te = f ? f.displayName || f.name : "", Ae = Te ? a(Te) : "";
        return typeof f == "function" && h.set(f, Ae), Ae;
      }
      function w(f, S, T) {
        return C(f, !1);
      }
      function I(f) {
        var S = f.prototype;
        return !!(S && S.isReactComponent);
      }
      function U(f, S, T) {
        if (f == null)
          return "";
        if (typeof f == "function")
          return C(f, I(f));
        if (typeof f == "string")
          return a(f);
        switch (f) {
          case B:
            return a("Suspense");
          case pe:
            return a("SuspenseList");
        }
        if (typeof f == "object")
          switch (f.$$typeof) {
            case et:
              return w(f.render);
            case ct:
              return U(f.type, S, T);
            case ae: {
              var P = f, H = P._payload, Y = P._init;
              try {
                return U(Y(H), S, T);
              } catch {
              }
            }
          }
        return "";
      }
      var N = {}, Z = nt.ReactDebugCurrentFrame;
      function V(f) {
        if (f) {
          var S = f._owner, T = U(f.type, f._source, S ? S.type : null);
          Z.setExtraStackFrame(T);
        } else
          Z.setExtraStackFrame(null);
      }
      function me(f, S, T, P, H) {
        {
          var Y = Function.call.bind(dr);
          for (var $ in f)
            if (Y(f, $)) {
              var ee = void 0;
              try {
                if (typeof f[$] != "function") {
                  var le = Error((P || "React class") + ": " + T + " type `" + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[$] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw le.name = "Invariant Violation", le;
                }
                ee = f[$](S, $, P, T, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (be) {
                ee = be;
              }
              ee && !(ee instanceof Error) && (V(H), G("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", P || "React class", T, $, typeof ee), V(null)), ee instanceof Error && !(ee.message in N) && (N[ee.message] = !0, V(H), G("Failed %s type: %s", T, ee.message), V(null));
            }
        }
      }
      function Ve(f) {
        if (f) {
          var S = f._owner, T = U(f.type, f._source, S ? S.type : null);
          Ce(T);
        } else
          Ce(null);
      }
      var qe;
      qe = !1;
      function ut() {
        if (he.current) {
          var f = ft(he.current.type);
          if (f)
            return `

Check the render method of \`` + f + "`.";
        }
        return "";
      }
      function yr(f) {
        if (f !== void 0) {
          var S = f.fileName.replace(/^.*[\\\/]/, ""), T = f.lineNumber;
          return `

Check your code at ` + S + ":" + T + ".";
        }
        return "";
      }
      function Nt(f) {
        return f != null ? yr(f.__source) : "";
      }
      var _r = {};
      function Sr(f) {
        var S = ut();
        if (!S) {
          var T = typeof f == "string" ? f : f.displayName || f.name;
          T && (S = `

Check the top-level render call using <` + T + ">.");
        }
        return S;
      }
      function br(f, S) {
        if (!(!f._store || f._store.validated || f.key != null)) {
          f._store.validated = !0;
          var T = Sr(S);
          if (!_r[T]) {
            _r[T] = !0;
            var P = "";
            f && f._owner && f._owner !== he.current && (P = " It was passed a child from " + ft(f._owner.type) + "."), Ve(f), G('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', T, P), Ve(null);
          }
        }
      }
      function Vt(f, S) {
        if (typeof f == "object") {
          if (Le(f))
            for (var T = 0; T < f.length; T++) {
              var P = f[T];
              Lt(P) && br(P, S);
            }
          else if (Lt(f))
            f._store && (f._store.validated = !0);
          else if (f) {
            var H = Ie(f);
            if (typeof H == "function" && H !== f.entries)
              for (var Y = H.call(f), $; !($ = Y.next()).done; )
                Lt($.value) && br($.value, S);
          }
        }
      }
      function wr(f) {
        {
          var S = f.type;
          if (S == null || typeof S == "string")
            return;
          var T;
          if (typeof S == "function")
            T = S.propTypes;
          else if (typeof S == "object" && (S.$$typeof === et || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          S.$$typeof === ct))
            T = S.propTypes;
          else
            return;
          if (T) {
            var P = ft(S);
            me(T, f.props, "prop", P, f);
          } else if (S.PropTypes !== void 0 && !qe) {
            qe = !0;
            var H = ft(S);
            G("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", H || "Unknown");
          }
          typeof S.getDefaultProps == "function" && !S.getDefaultProps.isReactClassApproved && G("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function oo(f) {
        {
          for (var S = Object.keys(f.props), T = 0; T < S.length; T++) {
            var P = S[T];
            if (P !== "children" && P !== "key") {
              Ve(f), G("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", P), Ve(null);
              break;
            }
          }
          f.ref !== null && (Ve(f), G("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
        }
      }
      function Un(f, S, T) {
        var P = jr(f);
        if (!P) {
          var H = "";
          (f === void 0 || typeof f == "object" && f !== null && Object.keys(f).length === 0) && (H += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Y = Nt(S);
          Y ? H += Y : H += ut();
          var $;
          f === null ? $ = "null" : Le(f) ? $ = "array" : f !== void 0 && f.$$typeof === q ? ($ = "<" + (ft(f.type) || "Unknown") + " />", H = " Did you accidentally export a JSX literal instead of a component?") : $ = typeof f, G("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", $, H);
        }
        var ee = Gr.apply(this, arguments);
        if (ee == null)
          return ee;
        if (P)
          for (var le = 2; le < arguments.length; le++)
            Vt(arguments[le], f);
        return f === ue ? oo(ee) : wr(ee), ee;
      }
      var Qr = !1;
      function Yt(f) {
        var S = Un.bind(null, f);
        return S.type = f, Qr || (Qr = !0, xt("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(S, "type", {
          enumerable: !1,
          get: function() {
            return xt("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: f
            }), f;
          }
        }), S;
      }
      function ao(f, S, T) {
        for (var P = wn.apply(this, arguments), H = 2; H < arguments.length; H++)
          Vt(arguments[H], P.type);
        return wr(P), P;
      }
      function rr(f, S) {
        var T = Pe.transition;
        Pe.transition = {};
        var P = Pe.transition;
        Pe.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          f();
        } finally {
          if (Pe.transition = T, T === null && P._updatedFibers) {
            var H = P._updatedFibers.size;
            H > 10 && xt("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), P._updatedFibers.clear();
          }
        }
      }
      var dn = !1, Ir = null;
      function Re(f) {
        if (Ir === null)
          try {
            var S = ("require" + Math.random()).slice(0, 7), T = X && X[S];
            Ir = T.call(X, "timers").setImmediate;
          } catch {
            Ir = function(H) {
              dn === !1 && (dn = !0, typeof MessageChannel > "u" && G("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var Y = new MessageChannel();
              Y.port1.onmessage = H, Y.port2.postMessage(void 0);
            };
          }
        return Ir(f);
      }
      var Tt = 0, Kr = !1;
      function kr(f) {
        {
          var S = Tt;
          Tt++, ne.current === null && (ne.current = []);
          var T = ne.isBatchingLegacy, P;
          try {
            if (ne.isBatchingLegacy = !0, P = f(), !T && ne.didScheduleLegacyUpdate) {
              var H = ne.current;
              H !== null && (ne.didScheduleLegacyUpdate = !1, St(H));
            }
          } catch (Te) {
            throw Dt(S), Te;
          } finally {
            ne.isBatchingLegacy = T;
          }
          if (P !== null && typeof P == "object" && typeof P.then == "function") {
            var Y = P, $ = !1, ee = {
              then: function(Te, Ae) {
                $ = !0, Y.then(function(Xe) {
                  Dt(S), Tt === 0 ? $r(Xe, Te, Ae) : Te(Xe);
                }, function(Xe) {
                  Dt(S), Ae(Xe);
                });
              }
            };
            return !Kr && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              $ || (Kr = !0, G("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), ee;
          } else {
            var le = P;
            if (Dt(S), Tt === 0) {
              var be = ne.current;
              be !== null && (St(be), ne.current = null);
              var _e = {
                then: function(Te, Ae) {
                  ne.current === null ? (ne.current = [], $r(le, Te, Ae)) : Te(le);
                }
              };
              return _e;
            } else {
              var we = {
                then: function(Te, Ae) {
                  Te(le);
                }
              };
              return we;
            }
          }
        }
      }
      function Dt(f) {
        f !== Tt - 1 && G("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Tt = f;
      }
      function $r(f, S, T) {
        {
          var P = ne.current;
          if (P !== null)
            try {
              St(P), Re(function() {
                P.length === 0 ? (ne.current = null, S(f)) : $r(f, S, T);
              });
            } catch (H) {
              T(H);
            }
          else
            S(f);
        }
      }
      var Gt = !1;
      function St(f) {
        if (!Gt) {
          Gt = !0;
          var S = 0;
          try {
            for (; S < f.length; S++) {
              var T = f[S];
              do
                T = T(!0);
              while (T !== null);
            }
            f.length = 0;
          } catch (P) {
            throw f = f.slice(S + 1), P;
          } finally {
            Gt = !1;
          }
        }
      }
      var Cn = Un, qr = ao, jn = Yt, pn = {
        map: Qt,
        forEach: Ut,
        count: Er,
        toArray: Ur,
        only: Kt
      };
      R.Children = pn, R.Component = oe, R.Fragment = ue, R.Profiler = xe, R.PureComponent = ce, R.StrictMode = pt, R.Suspense = B, R.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = nt, R.act = kr, R.cloneElement = qr, R.createContext = Ge, R.createElement = Cn, R.createFactory = jn, R.createRef = ot, R.forwardRef = xn, R.isValidElement = Lt, R.lazy = kn, R.memo = Hr, R.startTransition = rr, R.unstable_act = kr, R.useCallback = mt, R.useContext = gt, R.useDebugValue = er, R.useDeferredValue = zt, R.useEffect = hr, R.useId = Wt, R.useImperativeHandle = fn, R.useInsertionEffect = Ht, R.useLayoutEffect = vr, R.useMemo = cn, R.useReducer = zr, R.useRef = pr, R.useState = jt, R.useSyncExternalStore = gr, R.useTransition = We, R.version = Q, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(di, di.exports)), di.exports;
}
process.env.NODE_ENV === "production" ? ql.exports = cs() : ql.exports = fs();
var pi = ql.exports;
const el = /* @__PURE__ */ us(pi);
var Bo = {}, Oo = {};
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ns;
function ds() {
  if (ns) return Oo;
  ns = 1;
  var X = pi;
  function R(a) {
    for (var s = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, h = 1; h < arguments.length; h++) s += "&args[]=" + encodeURIComponent(arguments[h]);
    return "Minified React error #" + a + "; visit " + s + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var Q = Object.prototype.hasOwnProperty, q = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, v = {}, ue = {};
  function pt(a) {
    return Q.call(ue, a) ? !0 : Q.call(v, a) ? !1 : q.test(a) ? ue[a] = !0 : (v[a] = !0, !1);
  }
  function xe(a, s, h, m, C, w, I) {
    this.acceptsBooleans = s === 2 || s === 3 || s === 4, this.attributeName = m, this.attributeNamespace = C, this.mustUseProperty = h, this.propertyName = a, this.type = s, this.sanitizeURL = w, this.removeEmptyString = I;
  }
  var _ = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    _[a] = new xe(a, 0, !1, a, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
    var s = a[0];
    _[s] = new xe(s, 1, !1, a[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
    _[a] = new xe(a, 2, !1, a.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
    _[a] = new xe(a, 2, !1, a, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    _[a] = new xe(a, 3, !1, a.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(a) {
    _[a] = new xe(a, 3, !0, a, null, !1, !1);
  }), ["capture", "download"].forEach(function(a) {
    _[a] = new xe(a, 4, !1, a, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(a) {
    _[a] = new xe(a, 6, !1, a, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(a) {
    _[a] = new xe(a, 5, !1, a.toLowerCase(), null, !1, !1);
  });
  var F = /[\-:]([a-z])/g;
  function et(a) {
    return a[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var s = a.replace(
      F,
      et
    );
    _[s] = new xe(s, 1, !1, a, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var s = a.replace(F, et);
    _[s] = new xe(s, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(a) {
    var s = a.replace(F, et);
    _[s] = new xe(s, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(a) {
    _[a] = new xe(a, 1, !1, a.toLowerCase(), null, !1, !1);
  }), _.xlinkHref = new xe("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(a) {
    _[a] = new xe(a, 1, !1, a.toLowerCase(), null, !0, !0);
  });
  var B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, pe = ["Webkit", "ms", "Moz", "O"];
  Object.keys(B).forEach(function(a) {
    pe.forEach(function(s) {
      s = s + a.charAt(0).toUpperCase() + a.substring(1), B[s] = B[a];
    });
  });
  var ct = /["'&<>]/;
  function ae(a) {
    if (typeof a == "boolean" || typeof a == "number") return "" + a;
    a = "" + a;
    var s = ct.exec(a);
    if (s) {
      var h = "", m, C = 0;
      for (m = s.index; m < a.length; m++) {
        switch (a.charCodeAt(m)) {
          case 34:
            s = "&quot;";
            break;
          case 38:
            s = "&amp;";
            break;
          case 39:
            s = "&#x27;";
            break;
          case 60:
            s = "&lt;";
            break;
          case 62:
            s = "&gt;";
            break;
          default:
            continue;
        }
        C !== m && (h += a.substring(C, m)), C = m + 1, h += s;
      }
      a = C !== m ? h + a.substring(C, m) : h;
    }
    return a;
  }
  var Ue = /([A-Z])/g, z = /^ms-/, M = Array.isArray;
  function Ie(a, s) {
    return { insertionMode: a, selectedValue: s };
  }
  function tt(a, s, h) {
    switch (s) {
      case "select":
        return Ie(1, h.value != null ? h.value : h.defaultValue);
      case "svg":
        return Ie(2, null);
      case "math":
        return Ie(3, null);
      case "foreignObject":
        return Ie(1, null);
      case "table":
        return Ie(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return Ie(5, null);
      case "colgroup":
        return Ie(7, null);
      case "tr":
        return Ie(6, null);
    }
    return 4 <= a.insertionMode || a.insertionMode === 0 ? Ie(1, null) : a;
  }
  var Pe = /* @__PURE__ */ new Map();
  function ne(a, s, h) {
    if (typeof h != "object") throw Error(R(62));
    s = !0;
    for (var m in h) if (Q.call(h, m)) {
      var C = h[m];
      if (C != null && typeof C != "boolean" && C !== "") {
        if (m.indexOf("--") === 0) {
          var w = ae(m);
          C = ae(("" + C).trim());
        } else {
          w = m;
          var I = Pe.get(w);
          I !== void 0 || (I = ae(w.replace(Ue, "-$1").toLowerCase().replace(z, "-ms-")), Pe.set(w, I)), w = I, C = typeof C == "number" ? C === 0 || Q.call(B, m) ? "" + C : C + "px" : ae(("" + C).trim());
        }
        s ? (s = !1, a.push(' style="', w, ":", C)) : a.push(";", w, ":", C);
      }
    }
    s || a.push('"');
  }
  function he(a, s, h, m) {
    switch (h) {
      case "style":
        ne(a, s, m);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < h.length) || h[0] !== "o" && h[0] !== "O" || h[1] !== "n" && h[1] !== "N") {
      if (s = _.hasOwnProperty(h) ? _[h] : null, s !== null) {
        switch (typeof m) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!s.acceptsBooleans) return;
        }
        switch (h = s.attributeName, s.type) {
          case 3:
            m && a.push(" ", h, '=""');
            break;
          case 4:
            m === !0 ? a.push(" ", h, '=""') : m !== !1 && a.push(" ", h, '="', ae(m), '"');
            break;
          case 5:
            isNaN(m) || a.push(" ", h, '="', ae(m), '"');
            break;
          case 6:
            !isNaN(m) && 1 <= m && a.push(" ", h, '="', ae(m), '"');
            break;
          default:
            s.sanitizeURL && (m = "" + m), a.push(" ", h, '="', ae(m), '"');
        }
      } else if (pt(h)) {
        switch (typeof m) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (s = h.toLowerCase().slice(0, 5), s !== "data-" && s !== "aria-") return;
        }
        a.push(" ", h, '="', ae(m), '"');
      }
    }
  }
  function de(a, s, h) {
    if (s != null) {
      if (h != null) throw Error(R(60));
      if (typeof s != "object" || !("__html" in s)) throw Error(R(61));
      s = s.__html, s != null && a.push("" + s);
    }
  }
  function Je(a) {
    var s = "";
    return X.Children.forEach(a, function(h) {
      h != null && (s += h);
    }), s;
  }
  function Ce(a, s, h, m) {
    a.push(Ye(h));
    var C = h = null, w;
    for (w in s) if (Q.call(s, w)) {
      var I = s[w];
      if (I != null) switch (w) {
        case "children":
          h = I;
          break;
        case "dangerouslySetInnerHTML":
          C = I;
          break;
        default:
          he(a, m, w, I);
      }
    }
    return a.push(">"), de(a, C, h), typeof h == "string" ? (a.push(ae(h)), null) : h;
  }
  var ht = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, vt = /* @__PURE__ */ new Map();
  function Ye(a) {
    var s = vt.get(a);
    if (s === void 0) {
      if (!ht.test(a)) throw Error(R(65, a));
      s = "<" + a, vt.set(a, s);
    }
    return s;
  }
  function kt(a, s, h, m, C) {
    switch (s) {
      case "select":
        a.push(Ye("select"));
        var w = null, I = null;
        for (V in h) if (Q.call(h, V)) {
          var U = h[V];
          if (U != null) switch (V) {
            case "children":
              w = U;
              break;
            case "dangerouslySetInnerHTML":
              I = U;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              he(a, m, V, U);
          }
        }
        return a.push(">"), de(a, I, w), w;
      case "option":
        I = C.selectedValue, a.push(Ye("option"));
        var N = U = null, Z = null, V = null;
        for (w in h) if (Q.call(h, w)) {
          var me = h[w];
          if (me != null) switch (w) {
            case "children":
              U = me;
              break;
            case "selected":
              Z = me;
              break;
            case "dangerouslySetInnerHTML":
              V = me;
              break;
            case "value":
              N = me;
            default:
              he(a, m, w, me);
          }
        }
        if (I != null) if (h = N !== null ? "" + N : Je(U), M(I)) {
          for (m = 0; m < I.length; m++)
            if ("" + I[m] === h) {
              a.push(' selected=""');
              break;
            }
        } else "" + I === h && a.push(' selected=""');
        else Z && a.push(' selected=""');
        return a.push(">"), de(a, V, U), U;
      case "textarea":
        a.push(Ye("textarea")), V = I = w = null;
        for (U in h) if (Q.call(h, U) && (N = h[U], N != null)) switch (U) {
          case "children":
            V = N;
            break;
          case "value":
            w = N;
            break;
          case "defaultValue":
            I = N;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(R(91));
          default:
            he(
              a,
              m,
              U,
              N
            );
        }
        if (w === null && I !== null && (w = I), a.push(">"), V != null) {
          if (w != null) throw Error(R(92));
          if (M(V) && 1 < V.length) throw Error(R(93));
          w = "" + V;
        }
        return typeof w == "string" && w[0] === `
` && a.push(`
`), w !== null && a.push(ae("" + w)), null;
      case "input":
        a.push(Ye("input")), N = V = U = w = null;
        for (I in h) if (Q.call(h, I) && (Z = h[I], Z != null)) switch (I) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(R(399, "input"));
          case "defaultChecked":
            N = Z;
            break;
          case "defaultValue":
            U = Z;
            break;
          case "checked":
            V = Z;
            break;
          case "value":
            w = Z;
            break;
          default:
            he(a, m, I, Z);
        }
        return V !== null ? he(a, m, "checked", V) : N !== null && he(a, m, "checked", N), w !== null ? he(a, m, "value", w) : U !== null && he(a, m, "value", U), a.push("/>"), null;
      case "menuitem":
        a.push(Ye("menuitem"));
        for (var Ve in h) if (Q.call(h, Ve) && (w = h[Ve], w != null)) switch (Ve) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(R(400));
          default:
            he(a, m, Ve, w);
        }
        return a.push(">"), null;
      case "title":
        a.push(Ye("title")), w = null;
        for (me in h) if (Q.call(h, me) && (I = h[me], I != null)) switch (me) {
          case "children":
            w = I;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(R(434));
          default:
            he(a, m, me, I);
        }
        return a.push(">"), w;
      case "listing":
      case "pre":
        a.push(Ye(s)), I = w = null;
        for (N in h) if (Q.call(h, N) && (U = h[N], U != null)) switch (N) {
          case "children":
            w = U;
            break;
          case "dangerouslySetInnerHTML":
            I = U;
            break;
          default:
            he(a, m, N, U);
        }
        if (a.push(">"), I != null) {
          if (w != null) throw Error(R(60));
          if (typeof I != "object" || !("__html" in I)) throw Error(R(61));
          h = I.__html, h != null && (typeof h == "string" && 0 < h.length && h[0] === `
` ? a.push(`
`, h) : a.push("" + h));
        }
        return typeof w == "string" && w[0] === `
` && a.push(`
`), w;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        a.push(Ye(s));
        for (var qe in h) if (Q.call(h, qe) && (w = h[qe], w != null)) switch (qe) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(R(399, s));
          default:
            he(a, m, qe, w);
        }
        return a.push("/>"), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return Ce(
          a,
          h,
          s,
          m
        );
      case "html":
        return C.insertionMode === 0 && a.push("<!DOCTYPE html>"), Ce(a, h, s, m);
      default:
        if (s.indexOf("-") === -1 && typeof h.is != "string") return Ce(a, h, s, m);
        a.push(Ye(s)), I = w = null;
        for (Z in h) if (Q.call(h, Z) && (U = h[Z], U != null)) switch (Z) {
          case "children":
            w = U;
            break;
          case "dangerouslySetInnerHTML":
            I = U;
            break;
          case "style":
            ne(a, m, U);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            pt(Z) && typeof U != "function" && typeof U != "symbol" && a.push(" ", Z, '="', ae(U), '"');
        }
        return a.push(">"), de(a, I, w), w;
    }
  }
  function rt(a, s, h) {
    if (a.push('<!--$?--><template id="'), h === null) throw Error(R(395));
    return a.push(h), a.push('"></template>');
  }
  function nt(a, s, h, m) {
    switch (h.insertionMode) {
      case 0:
      case 1:
        return a.push('<div hidden id="'), a.push(s.segmentPrefix), s = m.toString(16), a.push(s), a.push('">');
      case 2:
        return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(s.segmentPrefix), s = m.toString(16), a.push(s), a.push('">');
      case 3:
        return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(s.segmentPrefix), s = m.toString(16), a.push(s), a.push('">');
      case 4:
        return a.push('<table hidden id="'), a.push(s.segmentPrefix), s = m.toString(16), a.push(s), a.push('">');
      case 5:
        return a.push('<table hidden><tbody id="'), a.push(s.segmentPrefix), s = m.toString(16), a.push(s), a.push('">');
      case 6:
        return a.push('<table hidden><tr id="'), a.push(s.segmentPrefix), s = m.toString(16), a.push(s), a.push('">');
      case 7:
        return a.push('<table hidden><colgroup id="'), a.push(s.segmentPrefix), s = m.toString(16), a.push(s), a.push('">');
      default:
        throw Error(R(397));
    }
  }
  function xt(a, s) {
    switch (s.insertionMode) {
      case 0:
      case 1:
        return a.push("</div>");
      case 2:
        return a.push("</svg>");
      case 3:
        return a.push("</math>");
      case 4:
        return a.push("</table>");
      case 5:
        return a.push("</tbody></table>");
      case 6:
        return a.push("</tr></table>");
      case 7:
        return a.push("</colgroup></table>");
      default:
        throw Error(R(397));
    }
  }
  var G = /[<\u2028\u2029]/g;
  function Qe(a) {
    return JSON.stringify(a).replace(G, function(s) {
      switch (s) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  function Ke(a, s) {
    return s = s === void 0 ? "" : s, { bootstrapChunks: [], startInlineScript: "<script>", placeholderPrefix: s + "P:", segmentPrefix: s + "S:", boundaryPrefix: s + "B:", idPrefix: s, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1, generateStaticMarkup: a };
  }
  function Rt(a, s, h, m) {
    return h.generateStaticMarkup ? (a.push(ae(s)), !1) : (s === "" ? a = m : (m && a.push("<!-- -->"), a.push(ae(s)), a = !0), a);
  }
  var b = Object.assign, O = Symbol.for("react.element"), ie = Symbol.for("react.portal"), oe = Symbol.for("react.fragment"), J = Symbol.for("react.strict_mode"), re = Symbol.for("react.profiler"), ye = Symbol.for("react.provider"), Se = Symbol.for("react.context"), ce = Symbol.for("react.forward_ref"), Fe = Symbol.for("react.suspense"), ot = Symbol.for("react.suspense_list"), Ar = Symbol.for("react.memo"), Le = Symbol.for("react.lazy"), at = Symbol.for("react.scope"), Dr = Symbol.for("react.debug_trace_mode"), cr = Symbol.for("react.legacy_hidden"), xr = Symbol.for("react.default_value"), _t = Symbol.iterator;
  function fr(a) {
    if (a == null) return null;
    if (typeof a == "function") return a.displayName || a.name || null;
    if (typeof a == "string") return a;
    switch (a) {
      case oe:
        return "Fragment";
      case ie:
        return "Portal";
      case re:
        return "Profiler";
      case J:
        return "StrictMode";
      case Fe:
        return "Suspense";
      case ot:
        return "SuspenseList";
    }
    if (typeof a == "object") switch (a.$$typeof) {
      case Se:
        return (a.displayName || "Context") + ".Consumer";
      case ye:
        return (a._context.displayName || "Context") + ".Provider";
      case ce:
        var s = a.render;
        return a = a.displayName, a || (a = s.displayName || s.name || "", a = a !== "" ? "ForwardRef(" + a + ")" : "ForwardRef"), a;
      case Ar:
        return s = a.displayName || null, s !== null ? s : fr(a.type) || "Memo";
      case Le:
        s = a._payload, a = a._init;
        try {
          return fr(a(s));
        } catch {
        }
    }
    return null;
  }
  var ft = {};
  function dr(a, s) {
    if (a = a.contextTypes, !a) return ft;
    var h = {}, m;
    for (m in a) h[m] = s[m];
    return h;
  }
  var Ct = null;
  function Ze(a, s) {
    if (a !== s) {
      a.context._currentValue2 = a.parentValue, a = a.parent;
      var h = s.parent;
      if (a === null) {
        if (h !== null) throw Error(R(401));
      } else {
        if (h === null) throw Error(R(401));
        Ze(a, h);
      }
      s.context._currentValue2 = s.value;
    }
  }
  function je(a) {
    a.context._currentValue2 = a.parentValue, a = a.parent, a !== null && je(a);
  }
  function Cr(a) {
    var s = a.parent;
    s !== null && Cr(s), a.context._currentValue2 = a.value;
  }
  function Or(a, s) {
    if (a.context._currentValue2 = a.parentValue, a = a.parent, a === null) throw Error(R(402));
    a.depth === s.depth ? Ze(a, s) : Or(a, s);
  }
  function Mr(a, s) {
    var h = s.parent;
    if (h === null) throw Error(R(402));
    a.depth === h.depth ? Ze(a, h) : Mr(a, h), s.context._currentValue2 = s.value;
  }
  function He(a) {
    var s = Ct;
    s !== a && (s === null ? Cr(a) : a === null ? je(s) : s.depth === a.depth ? Ze(s, a) : s.depth > a.depth ? Or(s, a) : Mr(s, a), Ct = a);
  }
  var Yr = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(a, s) {
    a = a._reactInternals, a.queue !== null && a.queue.push(s);
  }, enqueueReplaceState: function(a, s) {
    a = a._reactInternals, a.replace = !0, a.queue = [s];
  }, enqueueForceUpdate: function() {
  } };
  function sn(a, s, h, m) {
    var C = a.state !== void 0 ? a.state : null;
    a.updater = Yr, a.props = h, a.state = C;
    var w = { queue: [], replace: !1 };
    a._reactInternals = w;
    var I = s.contextType;
    if (a.context = typeof I == "object" && I !== null ? I._currentValue2 : m, I = s.getDerivedStateFromProps, typeof I == "function" && (I = I(h, C), C = I == null ? C : b({}, C, I), a.state = C), typeof s.getDerivedStateFromProps != "function" && typeof a.getSnapshotBeforeUpdate != "function" && (typeof a.UNSAFE_componentWillMount == "function" || typeof a.componentWillMount == "function")) if (s = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), s !== a.state && Yr.enqueueReplaceState(a, a.state, null), w.queue !== null && 0 < w.queue.length) if (s = w.queue, I = w.replace, w.queue = null, w.replace = !1, I && s.length === 1) a.state = s[0];
    else {
      for (w = I ? s[0] : a.state, C = !0, I = I ? 1 : 0; I < s.length; I++) {
        var U = s[I];
        U = typeof U == "function" ? U.call(a, w, h, m) : U, U != null && (C ? (C = !1, w = b({}, w, U)) : b(w, U));
      }
      a.state = w;
    }
    else w.queue = null;
  }
  var Lr = { id: 1, overflow: "" };
  function Gr(a, s, h) {
    var m = a.id;
    a = a.overflow;
    var C = 32 - Br(m) - 1;
    m &= ~(1 << C), h += 1;
    var w = 32 - Br(s) + C;
    if (30 < w) {
      var I = C - C % 5;
      return w = (m & (1 << I) - 1).toString(32), m >>= I, C -= I, { id: 1 << 32 - Br(s) + C | h << C | m, overflow: w + a };
    }
    return { id: 1 << w | h << C | m, overflow: a };
  }
  var Br = Math.clz32 ? Math.clz32 : Zt, wn = Math.log, Lt = Math.LN2;
  function Zt(a) {
    return a >>>= 0, a === 0 ? 32 : 31 - (wn(a) / Lt | 0) | 0;
  }
  function Xr(a, s) {
    return a === s && (a !== 0 || 1 / a === 1 / s) || a !== a && s !== s;
  }
  var un = typeof Object.is == "function" ? Object.is : Xr, it = null, Bt = null, Jt = null, ge = null, It = !1, Qt = !1, Er = 0, Ut = null, Ur = 0;
  function Kt() {
    if (it === null) throw Error(R(321));
    return it;
  }
  function Ge() {
    if (0 < Ur) throw Error(R(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function qt() {
    return ge === null ? Jt === null ? (It = !1, Jt = ge = Ge()) : (It = !0, ge = Jt) : ge.next === null ? (It = !1, ge = ge.next = Ge()) : (It = !0, ge = ge.next), ge;
  }
  function Tr() {
    Bt = it = null, Qt = !1, Jt = null, Ur = 0, ge = Ut = null;
  }
  function Zr(a, s) {
    return typeof s == "function" ? s(a) : s;
  }
  function ze(a, s, h) {
    if (it = Kt(), ge = qt(), It) {
      var m = ge.queue;
      if (s = m.dispatch, Ut !== null && (h = Ut.get(m), h !== void 0)) {
        Ut.delete(m), m = ge.memoizedState;
        do
          m = a(m, h.action), h = h.next;
        while (h !== null);
        return ge.memoizedState = m, [m, s];
      }
      return [ge.memoizedState, s];
    }
    return a = a === Zr ? typeof s == "function" ? s() : s : h !== void 0 ? h(s) : s, ge.memoizedState = a, a = ge.queue = { last: null, dispatch: null }, a = a.dispatch = kn.bind(null, it, a), [ge.memoizedState, a];
  }
  function Jr(a, s) {
    if (it = Kt(), ge = qt(), s = s === void 0 ? null : s, ge !== null) {
      var h = ge.memoizedState;
      if (h !== null && s !== null) {
        var m = h[1];
        e: if (m === null) m = !1;
        else {
          for (var C = 0; C < m.length && C < s.length; C++) if (!un(s[C], m[C])) {
            m = !1;
            break e;
          }
          m = !0;
        }
        if (m) return h[0];
      }
    }
    return a = a(), ge.memoizedState = [a, s], a;
  }
  function kn(a, s, h) {
    if (25 <= Ur) throw Error(R(301));
    if (a === it) if (Qt = !0, a = { action: h, next: null }, Ut === null && (Ut = /* @__PURE__ */ new Map()), h = Ut.get(s), h === void 0) Ut.set(s, a);
    else {
      for (s = h; s.next !== null; ) s = s.next;
      s.next = a;
    }
  }
  function xn() {
    throw Error(R(394));
  }
  function Pt() {
  }
  var jr = { readContext: function(a) {
    return a._currentValue2;
  }, useContext: function(a) {
    return Kt(), a._currentValue2;
  }, useMemo: Jr, useReducer: ze, useRef: function(a) {
    it = Kt(), ge = qt();
    var s = ge.memoizedState;
    return s === null ? (a = { current: a }, ge.memoizedState = a) : s;
  }, useState: function(a) {
    return ze(Zr, a);
  }, useInsertionEffect: Pt, useLayoutEffect: function() {
  }, useCallback: function(a, s) {
    return Jr(function() {
      return a;
    }, s);
  }, useImperativeHandle: Pt, useEffect: Pt, useDebugValue: Pt, useDeferredValue: function(a) {
    return Kt(), a;
  }, useTransition: function() {
    return Kt(), [
      !1,
      xn
    ];
  }, useId: function() {
    var a = Bt.treeContext, s = a.overflow;
    a = a.id, a = (a & ~(1 << 32 - Br(a) - 1)).toString(32) + s;
    var h = Hr;
    if (h === null) throw Error(R(404));
    return s = Er++, a = ":" + h.idPrefix + "R" + a, 0 < s && (a += "H" + s.toString(32)), a + ":";
  }, useMutableSource: function(a, s) {
    return Kt(), s(a._source);
  }, useSyncExternalStore: function(a, s, h) {
    if (h === void 0) throw Error(R(407));
    return h();
  } }, Hr = null, Oe = X.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function gt(a) {
    return console.error(a), null;
  }
  function jt() {
  }
  function zr(a, s, h, m, C, w, I, U, N) {
    var Z = [], V = /* @__PURE__ */ new Set();
    return s = { destination: null, responseState: s, progressiveChunkSize: m === void 0 ? 12800 : m, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: V, pingedTasks: Z, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: C === void 0 ? gt : C, onAllReady: jt, onShellReady: I === void 0 ? jt : I, onShellError: jt, onFatalError: jt }, h = hr(s, 0, null, h, !1, !1), h.parentFlushed = !0, a = pr(s, a, null, h, V, ft, null, Lr), Z.push(a), s;
  }
  function pr(a, s, h, m, C, w, I, U) {
    a.allPendingTasks++, h === null ? a.pendingRootTasks++ : h.pendingTasks++;
    var N = { node: s, ping: function() {
      var Z = a.pingedTasks;
      Z.push(N), Z.length === 1 && lt(a);
    }, blockedBoundary: h, blockedSegment: m, abortSet: C, legacyContext: w, context: I, treeContext: U };
    return C.add(N), N;
  }
  function hr(a, s, h, m, C, w) {
    return { status: 0, id: -1, index: s, parentFlushed: !1, chunks: [], children: [], formatContext: m, boundary: h, lastPushedText: C, textEmbedded: w };
  }
  function Ht(a, s) {
    if (a = a.onError(s), a != null && typeof a != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
  }
  function vr(a, s) {
    var h = a.onShellError;
    h(s), h = a.onFatalError, h(s), a.destination !== null ? (a.status = 2, a.destination.destroy(s)) : (a.status = 1, a.fatalError = s);
  }
  function mt(a, s, h, m, C) {
    for (it = {}, Bt = s, Er = 0, a = h(m, C); Qt; ) Qt = !1, Er = 0, Ur += 1, ge = null, a = h(m, C);
    return Tr(), a;
  }
  function cn(a, s, h, m) {
    var C = h.render(), w = m.childContextTypes;
    if (w != null) {
      var I = s.legacyContext;
      if (typeof h.getChildContext != "function") m = I;
      else {
        h = h.getChildContext();
        for (var U in h) if (!(U in w)) throw Error(R(108, fr(m) || "Unknown", U));
        m = b({}, I, h);
      }
      s.legacyContext = m, We(a, s, C), s.legacyContext = I;
    } else We(a, s, C);
  }
  function fn(a, s) {
    if (a && a.defaultProps) {
      s = b({}, s), a = a.defaultProps;
      for (var h in a) s[h] === void 0 && (s[h] = a[h]);
      return s;
    }
    return s;
  }
  function er(a, s, h, m, C) {
    if (typeof h == "function") if (h.prototype && h.prototype.isReactComponent) {
      C = dr(h, s.legacyContext);
      var w = h.contextType;
      w = new h(m, typeof w == "object" && w !== null ? w._currentValue2 : C), sn(w, h, m, C), cn(a, s, w, h);
    } else {
      w = dr(h, s.legacyContext), C = mt(a, s, h, m, w);
      var I = Er !== 0;
      if (typeof C == "object" && C !== null && typeof C.render == "function" && C.$$typeof === void 0) sn(C, h, m, w), cn(a, s, C, h);
      else if (I) {
        m = s.treeContext, s.treeContext = Gr(m, 1, 0);
        try {
          We(a, s, C);
        } finally {
          s.treeContext = m;
        }
      } else We(a, s, C);
    }
    else if (typeof h == "string") {
      switch (C = s.blockedSegment, w = kt(C.chunks, h, m, a.responseState, C.formatContext), C.lastPushedText = !1, I = C.formatContext, C.formatContext = tt(I, h, m), Wt(a, s, w), C.formatContext = I, h) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          C.chunks.push("</", h, ">");
      }
      C.lastPushedText = !1;
    } else {
      switch (h) {
        case cr:
        case Dr:
        case J:
        case re:
        case oe:
          We(a, s, m.children);
          return;
        case ot:
          We(a, s, m.children);
          return;
        case at:
          throw Error(R(343));
        case Fe:
          e: {
            h = s.blockedBoundary, C = s.blockedSegment, w = m.fallback, m = m.children, I = /* @__PURE__ */ new Set();
            var U = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: I, errorDigest: null }, N = hr(a, C.chunks.length, U, C.formatContext, !1, !1);
            C.children.push(N), C.lastPushedText = !1;
            var Z = hr(a, 0, null, C.formatContext, !1, !1);
            Z.parentFlushed = !0, s.blockedBoundary = U, s.blockedSegment = Z;
            try {
              if (Wt(
                a,
                s,
                m
              ), a.responseState.generateStaticMarkup || Z.lastPushedText && Z.textEmbedded && Z.chunks.push("<!-- -->"), Z.status = 1, Et(U, Z), U.pendingTasks === 0) break e;
            } catch (V) {
              Z.status = 4, U.forceClientRender = !0, U.errorDigest = Ht(a, V);
            } finally {
              s.blockedBoundary = h, s.blockedSegment = C;
            }
            s = pr(a, w, h, N, I, s.legacyContext, s.context, s.treeContext), a.pingedTasks.push(s);
          }
          return;
      }
      if (typeof h == "object" && h !== null) switch (h.$$typeof) {
        case ce:
          if (m = mt(a, s, h.render, m, C), Er !== 0) {
            h = s.treeContext, s.treeContext = Gr(h, 1, 0);
            try {
              We(a, s, m);
            } finally {
              s.treeContext = h;
            }
          } else We(a, s, m);
          return;
        case Ar:
          h = h.type, m = fn(h, m), er(a, s, h, m, C);
          return;
        case ye:
          if (C = m.children, h = h._context, m = m.value, w = h._currentValue2, h._currentValue2 = m, I = Ct, Ct = m = { parent: I, depth: I === null ? 0 : I.depth + 1, context: h, parentValue: w, value: m }, s.context = m, We(a, s, C), a = Ct, a === null) throw Error(R(403));
          m = a.parentValue, a.context._currentValue2 = m === xr ? a.context._defaultValue : m, a = Ct = a.parent, s.context = a;
          return;
        case Se:
          m = m.children, m = m(h._currentValue2), We(a, s, m);
          return;
        case Le:
          C = h._init, h = C(h._payload), m = fn(h, m), er(
            a,
            s,
            h,
            m,
            void 0
          );
          return;
      }
      throw Error(R(130, h == null ? h : typeof h, ""));
    }
  }
  function We(a, s, h) {
    if (s.node = h, typeof h == "object" && h !== null) {
      switch (h.$$typeof) {
        case O:
          er(a, s, h.type, h.props, h.ref);
          return;
        case ie:
          throw Error(R(257));
        case Le:
          var m = h._init;
          h = m(h._payload), We(a, s, h);
          return;
      }
      if (M(h)) {
        zt(a, s, h);
        return;
      }
      if (h === null || typeof h != "object" ? m = null : (m = _t && h[_t] || h["@@iterator"], m = typeof m == "function" ? m : null), m && (m = m.call(h))) {
        if (h = m.next(), !h.done) {
          var C = [];
          do
            C.push(h.value), h = m.next();
          while (!h.done);
          zt(a, s, C);
        }
        return;
      }
      throw a = Object.prototype.toString.call(h), Error(R(31, a === "[object Object]" ? "object with keys {" + Object.keys(h).join(", ") + "}" : a));
    }
    typeof h == "string" ? (m = s.blockedSegment, m.lastPushedText = Rt(s.blockedSegment.chunks, h, a.responseState, m.lastPushedText)) : typeof h == "number" && (m = s.blockedSegment, m.lastPushedText = Rt(s.blockedSegment.chunks, "" + h, a.responseState, m.lastPushedText));
  }
  function zt(a, s, h) {
    for (var m = h.length, C = 0; C < m; C++) {
      var w = s.treeContext;
      s.treeContext = Gr(w, m, C);
      try {
        Wt(a, s, h[C]);
      } finally {
        s.treeContext = w;
      }
    }
  }
  function Wt(a, s, h) {
    var m = s.blockedSegment.formatContext, C = s.legacyContext, w = s.context;
    try {
      return We(a, s, h);
    } catch (N) {
      if (Tr(), typeof N == "object" && N !== null && typeof N.then == "function") {
        h = N;
        var I = s.blockedSegment, U = hr(a, I.chunks.length, null, I.formatContext, I.lastPushedText, !0);
        I.children.push(U), I.lastPushedText = !1, a = pr(a, s.node, s.blockedBoundary, U, s.abortSet, s.legacyContext, s.context, s.treeContext).ping, h.then(a, a), s.blockedSegment.formatContext = m, s.legacyContext = C, s.context = w, He(w);
      } else throw s.blockedSegment.formatContext = m, s.legacyContext = C, s.context = w, He(w), N;
    }
  }
  function gr(a) {
    var s = a.blockedBoundary;
    a = a.blockedSegment, a.status = 3, Ft(this, s, a);
  }
  function $t(a, s, h) {
    var m = a.blockedBoundary;
    a.blockedSegment.status = 3, m === null ? (s.allPendingTasks--, s.status !== 2 && (s.status = 2, s.destination !== null && s.destination.push(null))) : (m.pendingTasks--, m.forceClientRender || (m.forceClientRender = !0, a = h === void 0 ? Error(R(432)) : h, m.errorDigest = s.onError(a), m.parentFlushed && s.clientRenderedBoundaries.push(m)), m.fallbackAbortableTasks.forEach(function(C) {
      return $t(C, s, h);
    }), m.fallbackAbortableTasks.clear(), s.allPendingTasks--, s.allPendingTasks === 0 && (m = s.onAllReady, m()));
  }
  function Et(a, s) {
    if (s.chunks.length === 0 && s.children.length === 1 && s.children[0].boundary === null) {
      var h = s.children[0];
      h.id = s.id, h.parentFlushed = !0, h.status === 1 && Et(a, h);
    } else a.completedSegments.push(s);
  }
  function Ft(a, s, h) {
    if (s === null) {
      if (h.parentFlushed) {
        if (a.completedRootSegment !== null) throw Error(R(389));
        a.completedRootSegment = h;
      }
      a.pendingRootTasks--, a.pendingRootTasks === 0 && (a.onShellError = jt, s = a.onShellReady, s());
    } else s.pendingTasks--, s.forceClientRender || (s.pendingTasks === 0 ? (h.parentFlushed && h.status === 1 && Et(s, h), s.parentFlushed && a.completedBoundaries.push(s), s.fallbackAbortableTasks.forEach(gr, a), s.fallbackAbortableTasks.clear()) : h.parentFlushed && h.status === 1 && (Et(s, h), s.completedSegments.length === 1 && s.parentFlushed && a.partialBoundaries.push(s)));
    a.allPendingTasks--, a.allPendingTasks === 0 && (a = a.onAllReady, a());
  }
  function lt(a) {
    if (a.status !== 2) {
      var s = Ct, h = Oe.current;
      Oe.current = jr;
      var m = Hr;
      Hr = a.responseState;
      try {
        var C = a.pingedTasks, w;
        for (w = 0; w < C.length; w++) {
          var I = C[w], U = a, N = I.blockedSegment;
          if (N.status === 0) {
            He(I.context);
            try {
              We(U, I, I.node), U.responseState.generateStaticMarkup || N.lastPushedText && N.textEmbedded && N.chunks.push("<!-- -->"), I.abortSet.delete(I), N.status = 1, Ft(U, I.blockedBoundary, N);
            } catch (ut) {
              if (Tr(), typeof ut == "object" && ut !== null && typeof ut.then == "function") {
                var Z = I.ping;
                ut.then(Z, Z);
              } else {
                I.abortSet.delete(I), N.status = 4;
                var V = I.blockedBoundary, me = ut, Ve = Ht(U, me);
                if (V === null ? vr(U, me) : (V.pendingTasks--, V.forceClientRender || (V.forceClientRender = !0, V.errorDigest = Ve, V.parentFlushed && U.clientRenderedBoundaries.push(V))), U.allPendingTasks--, U.allPendingTasks === 0) {
                  var qe = U.onAllReady;
                  qe();
                }
              }
            } finally {
            }
          }
        }
        C.splice(0, w), a.destination !== null && dt(a, a.destination);
      } catch (ut) {
        Ht(a, ut), vr(a, ut);
      } finally {
        Hr = m, Oe.current = h, h === jr && He(s);
      }
    }
  }
  function tr(a, s, h) {
    switch (h.parentFlushed = !0, h.status) {
      case 0:
        var m = h.id = a.nextSegmentId++;
        return h.lastPushedText = !1, h.textEmbedded = !1, a = a.responseState, s.push('<template id="'), s.push(a.placeholderPrefix), a = m.toString(16), s.push(a), s.push('"></template>');
      case 1:
        h.status = 2;
        var C = !0;
        m = h.chunks;
        var w = 0;
        h = h.children;
        for (var I = 0; I < h.length; I++) {
          for (C = h[I]; w < C.index; w++) s.push(m[w]);
          C = mr(a, s, C);
        }
        for (; w < m.length - 1; w++) s.push(m[w]);
        return w < m.length && (C = s.push(m[w])), C;
      default:
        throw Error(R(390));
    }
  }
  function mr(a, s, h) {
    var m = h.boundary;
    if (m === null) return tr(a, s, h);
    if (m.parentFlushed = !0, m.forceClientRender) return a.responseState.generateStaticMarkup || (m = m.errorDigest, s.push("<!--$!-->"), s.push("<template"), m && (s.push(' data-dgst="'), m = ae(m), s.push(m), s.push('"')), s.push("></template>")), tr(a, s, h), a = a.responseState.generateStaticMarkup ? !0 : s.push("<!--/$-->"), a;
    if (0 < m.pendingTasks) {
      m.rootSegmentID = a.nextSegmentId++, 0 < m.completedSegments.length && a.partialBoundaries.push(m);
      var C = a.responseState, w = C.nextSuspenseID++;
      return C = C.boundaryPrefix + w.toString(16), m = m.id = C, rt(s, a.responseState, m), tr(a, s, h), s.push("<!--/$-->");
    }
    if (m.byteSize > a.progressiveChunkSize) return m.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(m), rt(s, a.responseState, m.id), tr(a, s, h), s.push("<!--/$-->");
    if (a.responseState.generateStaticMarkup || s.push("<!--$-->"), h = m.completedSegments, h.length !== 1) throw Error(R(391));
    return mr(a, s, h[0]), a = a.responseState.generateStaticMarkup ? !0 : s.push("<!--/$-->"), a;
  }
  function Rr(a, s, h) {
    return nt(s, a.responseState, h.formatContext, h.id), mr(a, s, h), xt(s, h.formatContext);
  }
  function yt(a, s, h) {
    for (var m = h.completedSegments, C = 0; C < m.length; C++) At(a, s, h, m[C]);
    if (m.length = 0, a = a.responseState, m = h.id, h = h.rootSegmentID, s.push(a.startInlineScript), a.sentCompleteBoundaryFunction ? s.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, s.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("')), m === null) throw Error(R(395));
    return h = h.toString(16), s.push(m), s.push('","'), s.push(a.segmentPrefix), s.push(h), s.push('")<\/script>');
  }
  function At(a, s, h, m) {
    if (m.status === 2) return !0;
    var C = m.id;
    if (C === -1) {
      if ((m.id = h.rootSegmentID) === -1) throw Error(R(392));
      return Rr(a, s, m);
    }
    return Rr(a, s, m), a = a.responseState, s.push(a.startInlineScript), a.sentCompleteSegmentFunction ? s.push('$RS("') : (a.sentCompleteSegmentFunction = !0, s.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')), s.push(a.segmentPrefix), C = C.toString(16), s.push(C), s.push('","'), s.push(a.placeholderPrefix), s.push(C), s.push('")<\/script>');
  }
  function dt(a, s) {
    try {
      var h = a.completedRootSegment;
      if (h !== null && a.pendingRootTasks === 0) {
        mr(a, s, h), a.completedRootSegment = null;
        var m = a.responseState.bootstrapChunks;
        for (h = 0; h < m.length - 1; h++) s.push(m[h]);
        h < m.length && s.push(m[h]);
      }
      var C = a.clientRenderedBoundaries, w;
      for (w = 0; w < C.length; w++) {
        var I = C[w];
        m = s;
        var U = a.responseState, N = I.id, Z = I.errorDigest, V = I.errorMessage, me = I.errorComponentStack;
        if (m.push(U.startInlineScript), U.sentClientRenderFunction ? m.push('$RX("') : (U.sentClientRenderFunction = !0, m.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("')), N === null) throw Error(R(395));
        if (m.push(N), m.push('"'), Z || V || me) {
          m.push(",");
          var Ve = Qe(Z || "");
          m.push(Ve);
        }
        if (V || me) {
          m.push(",");
          var qe = Qe(V || "");
          m.push(qe);
        }
        if (me) {
          m.push(",");
          var ut = Qe(me);
          m.push(ut);
        }
        if (!m.push(")<\/script>")) {
          a.destination = null, w++, C.splice(0, w);
          return;
        }
      }
      C.splice(0, w);
      var yr = a.completedBoundaries;
      for (w = 0; w < yr.length; w++) if (!yt(a, s, yr[w])) {
        a.destination = null, w++, yr.splice(0, w);
        return;
      }
      yr.splice(0, w);
      var Nt = a.partialBoundaries;
      for (w = 0; w < Nt.length; w++) {
        var _r = Nt[w];
        e: {
          C = a, I = s;
          var Sr = _r.completedSegments;
          for (U = 0; U < Sr.length; U++) if (!At(C, I, _r, Sr[U])) {
            U++, Sr.splice(0, U);
            var br = !1;
            break e;
          }
          Sr.splice(0, U), br = !0;
        }
        if (!br) {
          a.destination = null, w++, Nt.splice(0, w);
          return;
        }
      }
      Nt.splice(0, w);
      var Vt = a.completedBoundaries;
      for (w = 0; w < Vt.length; w++) if (!yt(a, s, Vt[w])) {
        a.destination = null, w++, Vt.splice(0, w);
        return;
      }
      Vt.splice(0, w);
    } finally {
      a.allPendingTasks === 0 && a.pingedTasks.length === 0 && a.clientRenderedBoundaries.length === 0 && a.completedBoundaries.length === 0 && s.push(null);
    }
  }
  function Wr(a, s) {
    try {
      var h = a.abortableTasks;
      h.forEach(function(m) {
        return $t(m, a, s);
      }), h.clear(), a.destination !== null && dt(a, a.destination);
    } catch (m) {
      Ht(a, m), vr(a, m);
    }
  }
  function Ne() {
  }
  function st(a, s, h, m) {
    var C = !1, w = null, I = "", U = { push: function(Z) {
      return Z !== null && (I += Z), !0;
    }, destroy: function(Z) {
      C = !0, w = Z;
    } }, N = !1;
    if (a = zr(a, Ke(h, s ? s.identifierPrefix : void 0), { insertionMode: 1, selectedValue: null }, 1 / 0, Ne, void 0, function() {
      N = !0;
    }), lt(a), Wr(a, m), a.status === 1) a.status = 2, U.destroy(a.fatalError);
    else if (a.status !== 2 && a.destination === null) {
      a.destination = U;
      try {
        dt(a, U);
      } catch (Z) {
        Ht(a, Z), vr(a, Z);
      }
    }
    if (C) throw w;
    if (!N) throw Error(R(426));
    return I;
  }
  return Oo.renderToNodeStream = function() {
    throw Error(R(207));
  }, Oo.renderToStaticMarkup = function(a, s) {
    return st(a, s, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Oo.renderToStaticNodeStream = function() {
    throw Error(R(208));
  }, Oo.renderToString = function(a, s) {
    return st(a, s, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
  }, Oo.version = "18.3.1", Oo;
}
var tl = {};
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var os;
function ps() {
  if (os) return tl;
  os = 1;
  var X = pi;
  function R(i) {
    for (var u = "https://reactjs.org/docs/error-decoder.html?invariant=" + i, d = 1; d < arguments.length; d++) u += "&args[]=" + encodeURIComponent(arguments[d]);
    return "Minified React error #" + i + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var Q = null, q = 0;
  function v(i, u) {
    if (u.length !== 0) if (512 < u.length) 0 < q && (i.enqueue(new Uint8Array(Q.buffer, 0, q)), Q = new Uint8Array(512), q = 0), i.enqueue(u);
    else {
      var d = Q.length - q;
      d < u.length && (d === 0 ? i.enqueue(Q) : (Q.set(u.subarray(0, d), q), i.enqueue(Q), u = u.subarray(d)), Q = new Uint8Array(512), q = 0), Q.set(u, q), q += u.length;
    }
  }
  function ue(i, u) {
    return v(i, u), !0;
  }
  function pt(i) {
    Q && 0 < q && (i.enqueue(new Uint8Array(Q.buffer, 0, q)), Q = null, q = 0);
  }
  var xe = new TextEncoder();
  function _(i) {
    return xe.encode(i);
  }
  function F(i) {
    return xe.encode(i);
  }
  function et(i, u) {
    typeof i.error == "function" ? i.error(u) : i.close();
  }
  var B = Object.prototype.hasOwnProperty, pe = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ct = {}, ae = {};
  function Ue(i) {
    return B.call(ae, i) ? !0 : B.call(ct, i) ? !1 : pe.test(i) ? ae[i] = !0 : (ct[i] = !0, !1);
  }
  function z(i, u, d, g, E, x, A) {
    this.acceptsBooleans = u === 2 || u === 3 || u === 4, this.attributeName = g, this.attributeNamespace = E, this.mustUseProperty = d, this.propertyName = i, this.type = u, this.sanitizeURL = x, this.removeEmptyString = A;
  }
  var M = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(i) {
    M[i] = new z(i, 0, !1, i, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
    var u = i[0];
    M[u] = new z(u, 1, !1, i[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
    M[i] = new z(i, 2, !1, i.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
    M[i] = new z(i, 2, !1, i, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(i) {
    M[i] = new z(i, 3, !1, i.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(i) {
    M[i] = new z(i, 3, !0, i, null, !1, !1);
  }), ["capture", "download"].forEach(function(i) {
    M[i] = new z(i, 4, !1, i, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(i) {
    M[i] = new z(i, 6, !1, i, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(i) {
    M[i] = new z(i, 5, !1, i.toLowerCase(), null, !1, !1);
  });
  var Ie = /[\-:]([a-z])/g;
  function tt(i) {
    return i[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(i) {
    var u = i.replace(
      Ie,
      tt
    );
    M[u] = new z(u, 1, !1, i, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(i) {
    var u = i.replace(Ie, tt);
    M[u] = new z(u, 1, !1, i, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(i) {
    var u = i.replace(Ie, tt);
    M[u] = new z(u, 1, !1, i, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(i) {
    M[i] = new z(i, 1, !1, i.toLowerCase(), null, !1, !1);
  }), M.xlinkHref = new z("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(i) {
    M[i] = new z(i, 1, !1, i.toLowerCase(), null, !0, !0);
  });
  var Pe = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, ne = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Pe).forEach(function(i) {
    ne.forEach(function(u) {
      u = u + i.charAt(0).toUpperCase() + i.substring(1), Pe[u] = Pe[i];
    });
  });
  var he = /["'&<>]/;
  function de(i) {
    if (typeof i == "boolean" || typeof i == "number") return "" + i;
    i = "" + i;
    var u = he.exec(i);
    if (u) {
      var d = "", g, E = 0;
      for (g = u.index; g < i.length; g++) {
        switch (i.charCodeAt(g)) {
          case 34:
            u = "&quot;";
            break;
          case 38:
            u = "&amp;";
            break;
          case 39:
            u = "&#x27;";
            break;
          case 60:
            u = "&lt;";
            break;
          case 62:
            u = "&gt;";
            break;
          default:
            continue;
        }
        E !== g && (d += i.substring(E, g)), E = g + 1, d += u;
      }
      i = E !== g ? d + i.substring(E, g) : d;
    }
    return i;
  }
  var Je = /([A-Z])/g, Ce = /^ms-/, ht = Array.isArray, vt = F("<script>"), Ye = F("<\/script>"), kt = F('<script src="'), rt = F('<script type="module" src="'), nt = F('" async=""><\/script>'), xt = /(<\/|<)(s)(cript)/gi;
  function G(i, u, d, g) {
    return "" + u + (d === "s" ? "\\u0073" : "\\u0053") + g;
  }
  function Qe(i, u, d, g, E) {
    i = i === void 0 ? "" : i, u = u === void 0 ? vt : F('<script nonce="' + de(u) + '">');
    var x = [];
    if (d !== void 0 && x.push(u, _(("" + d).replace(xt, G)), Ye), g !== void 0) for (d = 0; d < g.length; d++) x.push(kt, _(de(g[d])), nt);
    if (E !== void 0) for (g = 0; g < E.length; g++) x.push(rt, _(de(E[g])), nt);
    return { bootstrapChunks: x, startInlineScript: u, placeholderPrefix: F(i + "P:"), segmentPrefix: F(i + "S:"), boundaryPrefix: i + "B:", idPrefix: i, nextSuspenseID: 0, sentCompleteSegmentFunction: !1, sentCompleteBoundaryFunction: !1, sentClientRenderFunction: !1 };
  }
  function Ke(i, u) {
    return { insertionMode: i, selectedValue: u };
  }
  function Rt(i) {
    return Ke(i === "http://www.w3.org/2000/svg" ? 2 : i === "http://www.w3.org/1998/Math/MathML" ? 3 : 0, null);
  }
  function b(i, u, d) {
    switch (u) {
      case "select":
        return Ke(1, d.value != null ? d.value : d.defaultValue);
      case "svg":
        return Ke(2, null);
      case "math":
        return Ke(3, null);
      case "foreignObject":
        return Ke(1, null);
      case "table":
        return Ke(4, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return Ke(5, null);
      case "colgroup":
        return Ke(7, null);
      case "tr":
        return Ke(6, null);
    }
    return 4 <= i.insertionMode || i.insertionMode === 0 ? Ke(1, null) : i;
  }
  var O = F("<!-- -->");
  function ie(i, u, d, g) {
    return u === "" ? g : (g && i.push(O), i.push(_(de(u))), !0);
  }
  var oe = /* @__PURE__ */ new Map(), J = F(' style="'), re = F(":"), ye = F(";");
  function Se(i, u, d) {
    if (typeof d != "object") throw Error(R(62));
    u = !0;
    for (var g in d) if (B.call(d, g)) {
      var E = d[g];
      if (E != null && typeof E != "boolean" && E !== "") {
        if (g.indexOf("--") === 0) {
          var x = _(de(g));
          E = _(de(("" + E).trim()));
        } else {
          x = g;
          var A = oe.get(x);
          A !== void 0 || (A = F(de(x.replace(Je, "-$1").toLowerCase().replace(Ce, "-ms-"))), oe.set(x, A)), x = A, E = typeof E == "number" ? E === 0 || B.call(Pe, g) ? _("" + E) : _(E + "px") : _(de(("" + E).trim()));
        }
        u ? (u = !1, i.push(J, x, re, E)) : i.push(ye, x, re, E);
      }
    }
    u || i.push(ot);
  }
  var ce = F(" "), Fe = F('="'), ot = F('"'), Ar = F('=""');
  function Le(i, u, d, g) {
    switch (d) {
      case "style":
        Se(i, u, g);
        return;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
        return;
    }
    if (!(2 < d.length) || d[0] !== "o" && d[0] !== "O" || d[1] !== "n" && d[1] !== "N") {
      if (u = M.hasOwnProperty(d) ? M[d] : null, u !== null) {
        switch (typeof g) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (!u.acceptsBooleans) return;
        }
        switch (d = _(u.attributeName), u.type) {
          case 3:
            g && i.push(ce, d, Ar);
            break;
          case 4:
            g === !0 ? i.push(ce, d, Ar) : g !== !1 && i.push(ce, d, Fe, _(de(g)), ot);
            break;
          case 5:
            isNaN(g) || i.push(ce, d, Fe, _(de(g)), ot);
            break;
          case 6:
            !isNaN(g) && 1 <= g && i.push(ce, d, Fe, _(de(g)), ot);
            break;
          default:
            u.sanitizeURL && (g = "" + g), i.push(ce, d, Fe, _(de(g)), ot);
        }
      } else if (Ue(d)) {
        switch (typeof g) {
          case "function":
          case "symbol":
            return;
          case "boolean":
            if (u = d.toLowerCase().slice(0, 5), u !== "data-" && u !== "aria-") return;
        }
        i.push(ce, _(d), Fe, _(de(g)), ot);
      }
    }
  }
  var at = F(">"), Dr = F("/>");
  function cr(i, u, d) {
    if (u != null) {
      if (d != null) throw Error(R(60));
      if (typeof u != "object" || !("__html" in u)) throw Error(R(61));
      u = u.__html, u != null && i.push(_("" + u));
    }
  }
  function xr(i) {
    var u = "";
    return X.Children.forEach(i, function(d) {
      d != null && (u += d);
    }), u;
  }
  var _t = F(' selected=""');
  function fr(i, u, d, g) {
    i.push(Ze(d));
    var E = d = null, x;
    for (x in u) if (B.call(u, x)) {
      var A = u[x];
      if (A != null) switch (x) {
        case "children":
          d = A;
          break;
        case "dangerouslySetInnerHTML":
          E = A;
          break;
        default:
          Le(i, g, x, A);
      }
    }
    return i.push(at), cr(i, E, d), typeof d == "string" ? (i.push(_(de(d))), null) : d;
  }
  var ft = F(`
`), dr = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ct = /* @__PURE__ */ new Map();
  function Ze(i) {
    var u = Ct.get(i);
    if (u === void 0) {
      if (!dr.test(i)) throw Error(R(65, i));
      u = F("<" + i), Ct.set(i, u);
    }
    return u;
  }
  var je = F("<!DOCTYPE html>");
  function Cr(i, u, d, g, E) {
    switch (u) {
      case "select":
        i.push(Ze("select"));
        var x = null, A = null;
        for (se in d) if (B.call(d, se)) {
          var j = d[se];
          if (j != null) switch (se) {
            case "children":
              x = j;
              break;
            case "dangerouslySetInnerHTML":
              A = j;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              Le(i, g, se, j);
          }
        }
        return i.push(at), cr(i, A, x), x;
      case "option":
        A = E.selectedValue, i.push(Ze("option"));
        var K = j = null, fe = null, se = null;
        for (x in d) if (B.call(d, x)) {
          var De = d[x];
          if (De != null) switch (x) {
            case "children":
              j = De;
              break;
            case "selected":
              fe = De;
              break;
            case "dangerouslySetInnerHTML":
              se = De;
              break;
            case "value":
              K = De;
            default:
              Le(i, g, x, De);
          }
        }
        if (A != null) if (d = K !== null ? "" + K : xr(j), ht(A)) {
          for (g = 0; g < A.length; g++)
            if ("" + A[g] === d) {
              i.push(_t);
              break;
            }
        } else "" + A === d && i.push(_t);
        else fe && i.push(_t);
        return i.push(at), cr(i, se, j), j;
      case "textarea":
        i.push(Ze("textarea")), se = A = x = null;
        for (j in d) if (B.call(d, j) && (K = d[j], K != null)) switch (j) {
          case "children":
            se = K;
            break;
          case "value":
            x = K;
            break;
          case "defaultValue":
            A = K;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(R(91));
          default:
            Le(i, g, j, K);
        }
        if (x === null && A !== null && (x = A), i.push(at), se != null) {
          if (x != null) throw Error(R(92));
          if (ht(se) && 1 < se.length) throw Error(R(93));
          x = "" + se;
        }
        return typeof x == "string" && x[0] === `
` && i.push(ft), x !== null && i.push(_(de("" + x))), null;
      case "input":
        i.push(Ze("input")), K = se = j = x = null;
        for (A in d) if (B.call(d, A) && (fe = d[A], fe != null)) switch (A) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(R(399, "input"));
          case "defaultChecked":
            K = fe;
            break;
          case "defaultValue":
            j = fe;
            break;
          case "checked":
            se = fe;
            break;
          case "value":
            x = fe;
            break;
          default:
            Le(i, g, A, fe);
        }
        return se !== null ? Le(
          i,
          g,
          "checked",
          se
        ) : K !== null && Le(i, g, "checked", K), x !== null ? Le(i, g, "value", x) : j !== null && Le(i, g, "value", j), i.push(Dr), null;
      case "menuitem":
        i.push(Ze("menuitem"));
        for (var Ot in d) if (B.call(d, Ot) && (x = d[Ot], x != null)) switch (Ot) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(R(400));
          default:
            Le(i, g, Ot, x);
        }
        return i.push(at), null;
      case "title":
        i.push(Ze("title")), x = null;
        for (De in d) if (B.call(d, De) && (A = d[De], A != null)) switch (De) {
          case "children":
            x = A;
            break;
          case "dangerouslySetInnerHTML":
            throw Error(R(434));
          default:
            Le(i, g, De, A);
        }
        return i.push(at), x;
      case "listing":
      case "pre":
        i.push(Ze(u)), A = x = null;
        for (K in d) if (B.call(d, K) && (j = d[K], j != null)) switch (K) {
          case "children":
            x = j;
            break;
          case "dangerouslySetInnerHTML":
            A = j;
            break;
          default:
            Le(i, g, K, j);
        }
        if (i.push(at), A != null) {
          if (x != null) throw Error(R(60));
          if (typeof A != "object" || !("__html" in A)) throw Error(R(61));
          d = A.__html, d != null && (typeof d == "string" && 0 < d.length && d[0] === `
` ? i.push(ft, _(d)) : i.push(_("" + d)));
        }
        return typeof x == "string" && x[0] === `
` && i.push(ft), x;
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "img":
      case "keygen":
      case "link":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
        i.push(Ze(u));
        for (var nr in d) if (B.call(d, nr) && (x = d[nr], x != null)) switch (nr) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(R(399, u));
          default:
            Le(i, g, nr, x);
        }
        return i.push(Dr), null;
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return fr(i, d, u, g);
      case "html":
        return E.insertionMode === 0 && i.push(je), fr(i, d, u, g);
      default:
        if (u.indexOf("-") === -1 && typeof d.is != "string") return fr(i, d, u, g);
        i.push(Ze(u)), A = x = null;
        for (fe in d) if (B.call(d, fe) && (j = d[fe], j != null)) switch (fe) {
          case "children":
            x = j;
            break;
          case "dangerouslySetInnerHTML":
            A = j;
            break;
          case "style":
            Se(i, g, j);
            break;
          case "suppressContentEditableWarning":
          case "suppressHydrationWarning":
            break;
          default:
            Ue(fe) && typeof j != "function" && typeof j != "symbol" && i.push(ce, _(fe), Fe, _(de(j)), ot);
        }
        return i.push(at), cr(i, A, x), x;
    }
  }
  var Or = F("</"), Mr = F(">"), He = F('<template id="'), Yr = F('"></template>'), sn = F("<!--$-->"), Lr = F('<!--$?--><template id="'), Gr = F('"></template>'), Br = F("<!--$!-->"), wn = F("<!--/$-->"), Lt = F("<template"), Zt = F('"'), Xr = F(' data-dgst="');
  F(' data-msg="'), F(' data-stck="');
  var un = F("></template>");
  function it(i, u, d) {
    if (v(i, Lr), d === null) throw Error(R(395));
    return v(i, d), ue(i, Gr);
  }
  var Bt = F('<div hidden id="'), Jt = F('">'), ge = F("</div>"), It = F('<svg aria-hidden="true" style="display:none" id="'), Qt = F('">'), Er = F("</svg>"), Ut = F('<math aria-hidden="true" style="display:none" id="'), Ur = F('">'), Kt = F("</math>"), Ge = F('<table hidden id="'), qt = F('">'), Tr = F("</table>"), Zr = F('<table hidden><tbody id="'), ze = F('">'), Jr = F("</tbody></table>"), kn = F('<table hidden><tr id="'), xn = F('">'), Pt = F("</tr></table>"), jr = F('<table hidden><colgroup id="'), Hr = F('">'), Oe = F("</colgroup></table>");
  function gt(i, u, d, g) {
    switch (d.insertionMode) {
      case 0:
      case 1:
        return v(i, Bt), v(i, u.segmentPrefix), v(i, _(g.toString(16))), ue(i, Jt);
      case 2:
        return v(i, It), v(i, u.segmentPrefix), v(i, _(g.toString(16))), ue(i, Qt);
      case 3:
        return v(i, Ut), v(i, u.segmentPrefix), v(i, _(g.toString(16))), ue(i, Ur);
      case 4:
        return v(i, Ge), v(i, u.segmentPrefix), v(i, _(g.toString(16))), ue(i, qt);
      case 5:
        return v(i, Zr), v(i, u.segmentPrefix), v(i, _(g.toString(16))), ue(i, ze);
      case 6:
        return v(i, kn), v(i, u.segmentPrefix), v(i, _(g.toString(16))), ue(i, xn);
      case 7:
        return v(
          i,
          jr
        ), v(i, u.segmentPrefix), v(i, _(g.toString(16))), ue(i, Hr);
      default:
        throw Error(R(397));
    }
  }
  function jt(i, u) {
    switch (u.insertionMode) {
      case 0:
      case 1:
        return ue(i, ge);
      case 2:
        return ue(i, Er);
      case 3:
        return ue(i, Kt);
      case 4:
        return ue(i, Tr);
      case 5:
        return ue(i, Jr);
      case 6:
        return ue(i, Pt);
      case 7:
        return ue(i, Oe);
      default:
        throw Error(R(397));
    }
  }
  var zr = F('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), pr = F('$RS("'), hr = F('","'), Ht = F('")<\/script>'), vr = F('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), mt = F('$RC("'), cn = F('","'), fn = F('")<\/script>'), er = F('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), We = F('$RX("'), zt = F('"'), Wt = F(")<\/script>"), gr = F(","), $t = /[<\u2028\u2029]/g;
  function Et(i) {
    return JSON.stringify(i).replace($t, function(u) {
      switch (u) {
        case "<":
          return "\\u003c";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        default:
          throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
      }
    });
  }
  var Ft = Object.assign, lt = Symbol.for("react.element"), tr = Symbol.for("react.portal"), mr = Symbol.for("react.fragment"), Rr = Symbol.for("react.strict_mode"), yt = Symbol.for("react.profiler"), At = Symbol.for("react.provider"), dt = Symbol.for("react.context"), Wr = Symbol.for("react.forward_ref"), Ne = Symbol.for("react.suspense"), st = Symbol.for("react.suspense_list"), a = Symbol.for("react.memo"), s = Symbol.for("react.lazy"), h = Symbol.for("react.scope"), m = Symbol.for("react.debug_trace_mode"), C = Symbol.for("react.legacy_hidden"), w = Symbol.for("react.default_value"), I = Symbol.iterator;
  function U(i) {
    if (i == null) return null;
    if (typeof i == "function") return i.displayName || i.name || null;
    if (typeof i == "string") return i;
    switch (i) {
      case mr:
        return "Fragment";
      case tr:
        return "Portal";
      case yt:
        return "Profiler";
      case Rr:
        return "StrictMode";
      case Ne:
        return "Suspense";
      case st:
        return "SuspenseList";
    }
    if (typeof i == "object") switch (i.$$typeof) {
      case dt:
        return (i.displayName || "Context") + ".Consumer";
      case At:
        return (i._context.displayName || "Context") + ".Provider";
      case Wr:
        var u = i.render;
        return i = i.displayName, i || (i = u.displayName || u.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
      case a:
        return u = i.displayName || null, u !== null ? u : U(i.type) || "Memo";
      case s:
        u = i._payload, i = i._init;
        try {
          return U(i(u));
        } catch {
        }
    }
    return null;
  }
  var N = {};
  function Z(i, u) {
    if (i = i.contextTypes, !i) return N;
    var d = {}, g;
    for (g in i) d[g] = u[g];
    return d;
  }
  var V = null;
  function me(i, u) {
    if (i !== u) {
      i.context._currentValue = i.parentValue, i = i.parent;
      var d = u.parent;
      if (i === null) {
        if (d !== null) throw Error(R(401));
      } else {
        if (d === null) throw Error(R(401));
        me(i, d);
      }
      u.context._currentValue = u.value;
    }
  }
  function Ve(i) {
    i.context._currentValue = i.parentValue, i = i.parent, i !== null && Ve(i);
  }
  function qe(i) {
    var u = i.parent;
    u !== null && qe(u), i.context._currentValue = i.value;
  }
  function ut(i, u) {
    if (i.context._currentValue = i.parentValue, i = i.parent, i === null) throw Error(R(402));
    i.depth === u.depth ? me(i, u) : ut(i, u);
  }
  function yr(i, u) {
    var d = u.parent;
    if (d === null) throw Error(R(402));
    i.depth === d.depth ? me(i, d) : yr(i, d), u.context._currentValue = u.value;
  }
  function Nt(i) {
    var u = V;
    u !== i && (u === null ? qe(i) : i === null ? Ve(u) : u.depth === i.depth ? me(u, i) : u.depth > i.depth ? ut(u, i) : yr(u, i), V = i);
  }
  var _r = { isMounted: function() {
    return !1;
  }, enqueueSetState: function(i, u) {
    i = i._reactInternals, i.queue !== null && i.queue.push(u);
  }, enqueueReplaceState: function(i, u) {
    i = i._reactInternals, i.replace = !0, i.queue = [u];
  }, enqueueForceUpdate: function() {
  } };
  function Sr(i, u, d, g) {
    var E = i.state !== void 0 ? i.state : null;
    i.updater = _r, i.props = d, i.state = E;
    var x = { queue: [], replace: !1 };
    i._reactInternals = x;
    var A = u.contextType;
    if (i.context = typeof A == "object" && A !== null ? A._currentValue : g, A = u.getDerivedStateFromProps, typeof A == "function" && (A = A(d, E), E = A == null ? E : Ft({}, E, A), i.state = E), typeof u.getDerivedStateFromProps != "function" && typeof i.getSnapshotBeforeUpdate != "function" && (typeof i.UNSAFE_componentWillMount == "function" || typeof i.componentWillMount == "function")) if (u = i.state, typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(), u !== i.state && _r.enqueueReplaceState(i, i.state, null), x.queue !== null && 0 < x.queue.length) if (u = x.queue, A = x.replace, x.queue = null, x.replace = !1, A && u.length === 1) i.state = u[0];
    else {
      for (x = A ? u[0] : i.state, E = !0, A = A ? 1 : 0; A < u.length; A++) {
        var j = u[A];
        j = typeof j == "function" ? j.call(i, x, d, g) : j, j != null && (E ? (E = !1, x = Ft({}, x, j)) : Ft(x, j));
      }
      i.state = x;
    }
    else x.queue = null;
  }
  var br = { id: 1, overflow: "" };
  function Vt(i, u, d) {
    var g = i.id;
    i = i.overflow;
    var E = 32 - wr(g) - 1;
    g &= ~(1 << E), d += 1;
    var x = 32 - wr(u) + E;
    if (30 < x) {
      var A = E - E % 5;
      return x = (g & (1 << A) - 1).toString(32), g >>= A, E -= A, { id: 1 << 32 - wr(u) + E | d << E | g, overflow: x + i };
    }
    return { id: 1 << x | d << E | g, overflow: i };
  }
  var wr = Math.clz32 ? Math.clz32 : Qr, oo = Math.log, Un = Math.LN2;
  function Qr(i) {
    return i >>>= 0, i === 0 ? 32 : 31 - (oo(i) / Un | 0) | 0;
  }
  function Yt(i, u) {
    return i === u && (i !== 0 || 1 / i === 1 / u) || i !== i && u !== u;
  }
  var ao = typeof Object.is == "function" ? Object.is : Yt, rr = null, dn = null, Ir = null, Re = null, Tt = !1, Kr = !1, kr = 0, Dt = null, $r = 0;
  function Gt() {
    if (rr === null) throw Error(R(321));
    return rr;
  }
  function St() {
    if (0 < $r) throw Error(R(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Cn() {
    return Re === null ? Ir === null ? (Tt = !1, Ir = Re = St()) : (Tt = !0, Re = Ir) : Re.next === null ? (Tt = !1, Re = Re.next = St()) : (Tt = !0, Re = Re.next), Re;
  }
  function qr() {
    dn = rr = null, Kr = !1, Ir = null, $r = 0, Re = Dt = null;
  }
  function jn(i, u) {
    return typeof u == "function" ? u(i) : u;
  }
  function pn(i, u, d) {
    if (rr = Gt(), Re = Cn(), Tt) {
      var g = Re.queue;
      if (u = g.dispatch, Dt !== null && (d = Dt.get(g), d !== void 0)) {
        Dt.delete(g), g = Re.memoizedState;
        do
          g = i(g, d.action), d = d.next;
        while (d !== null);
        return Re.memoizedState = g, [g, u];
      }
      return [Re.memoizedState, u];
    }
    return i = i === jn ? typeof u == "function" ? u() : u : d !== void 0 ? d(u) : u, Re.memoizedState = i, i = Re.queue = { last: null, dispatch: null }, i = i.dispatch = S.bind(null, rr, i), [Re.memoizedState, i];
  }
  function f(i, u) {
    if (rr = Gt(), Re = Cn(), u = u === void 0 ? null : u, Re !== null) {
      var d = Re.memoizedState;
      if (d !== null && u !== null) {
        var g = d[1];
        e: if (g === null) g = !1;
        else {
          for (var E = 0; E < g.length && E < u.length; E++) if (!ao(u[E], g[E])) {
            g = !1;
            break e;
          }
          g = !0;
        }
        if (g) return d[0];
      }
    }
    return i = i(), Re.memoizedState = [i, u], i;
  }
  function S(i, u, d) {
    if (25 <= $r) throw Error(R(301));
    if (i === rr) if (Kr = !0, i = { action: d, next: null }, Dt === null && (Dt = /* @__PURE__ */ new Map()), d = Dt.get(u), d === void 0) Dt.set(u, i);
    else {
      for (u = d; u.next !== null; ) u = u.next;
      u.next = i;
    }
  }
  function T() {
    throw Error(R(394));
  }
  function P() {
  }
  var H = { readContext: function(i) {
    return i._currentValue;
  }, useContext: function(i) {
    return Gt(), i._currentValue;
  }, useMemo: f, useReducer: pn, useRef: function(i) {
    rr = Gt(), Re = Cn();
    var u = Re.memoizedState;
    return u === null ? (i = { current: i }, Re.memoizedState = i) : u;
  }, useState: function(i) {
    return pn(jn, i);
  }, useInsertionEffect: P, useLayoutEffect: function() {
  }, useCallback: function(i, u) {
    return f(function() {
      return i;
    }, u);
  }, useImperativeHandle: P, useEffect: P, useDebugValue: P, useDeferredValue: function(i) {
    return Gt(), i;
  }, useTransition: function() {
    return Gt(), [!1, T];
  }, useId: function() {
    var i = dn.treeContext, u = i.overflow;
    i = i.id, i = (i & ~(1 << 32 - wr(i) - 1)).toString(32) + u;
    var d = Y;
    if (d === null) throw Error(R(404));
    return u = kr++, i = ":" + d.idPrefix + "R" + i, 0 < u && (i += "H" + u.toString(32)), i + ":";
  }, useMutableSource: function(i, u) {
    return Gt(), u(i._source);
  }, useSyncExternalStore: function(i, u, d) {
    if (d === void 0) throw Error(R(407));
    return d();
  } }, Y = null, $ = X.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function ee(i) {
    return console.error(i), null;
  }
  function le() {
  }
  function be(i, u, d, g, E, x, A, j, K) {
    var fe = [], se = /* @__PURE__ */ new Set();
    return u = { destination: null, responseState: u, progressiveChunkSize: g === void 0 ? 12800 : g, status: 0, fatalError: null, nextSegmentId: 0, allPendingTasks: 0, pendingRootTasks: 0, completedRootSegment: null, abortableTasks: se, pingedTasks: fe, clientRenderedBoundaries: [], completedBoundaries: [], partialBoundaries: [], onError: E === void 0 ? ee : E, onAllReady: x === void 0 ? le : x, onShellReady: A === void 0 ? le : A, onShellError: j === void 0 ? le : j, onFatalError: K === void 0 ? le : K }, d = we(u, 0, null, d, !1, !1), d.parentFlushed = !0, i = _e(u, i, null, d, se, N, null, br), fe.push(i), u;
  }
  function _e(i, u, d, g, E, x, A, j) {
    i.allPendingTasks++, d === null ? i.pendingRootTasks++ : d.pendingTasks++;
    var K = { node: u, ping: function() {
      var fe = i.pingedTasks;
      fe.push(K), fe.length === 1 && jo(i);
    }, blockedBoundary: d, blockedSegment: g, abortSet: E, legacyContext: x, context: A, treeContext: j };
    return E.add(K), K;
  }
  function we(i, u, d, g, E, x) {
    return { status: 0, id: -1, index: u, parentFlushed: !1, chunks: [], children: [], formatContext: g, boundary: d, lastPushedText: E, textEmbedded: x };
  }
  function Te(i, u) {
    if (i = i.onError(u), i != null && typeof i != "string") throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof i + '" instead');
    return i;
  }
  function Ae(i, u) {
    var d = i.onShellError;
    d(u), d = i.onFatalError, d(u), i.destination !== null ? (i.status = 2, et(i.destination, u)) : (i.status = 1, i.fatalError = u);
  }
  function Xe(i, u, d, g, E) {
    for (rr = {}, dn = u, kr = 0, i = d(g, E); Kr; ) Kr = !1, kr = 0, $r += 1, Re = null, i = d(g, E);
    return qr(), i;
  }
  function en(i, u, d, g) {
    var E = d.render(), x = g.childContextTypes;
    if (x != null) {
      var A = u.legacyContext;
      if (typeof d.getChildContext != "function") g = A;
      else {
        d = d.getChildContext();
        for (var j in d) if (!(j in x)) throw Error(R(108, U(g) || "Unknown", j));
        g = Ft({}, A, d);
      }
      u.legacyContext = g, bt(i, u, E), u.legacyContext = A;
    } else bt(i, u, E);
  }
  function hn(i, u) {
    if (i && i.defaultProps) {
      u = Ft({}, u), i = i.defaultProps;
      for (var d in i) u[d] === void 0 && (u[d] = i[d]);
      return u;
    }
    return u;
  }
  function tn(i, u, d, g, E) {
    if (typeof d == "function") if (d.prototype && d.prototype.isReactComponent) {
      E = Z(d, u.legacyContext);
      var x = d.contextType;
      x = new d(g, typeof x == "object" && x !== null ? x._currentValue : E), Sr(x, d, g, E), en(i, u, x, d);
    } else {
      x = Z(d, u.legacyContext), E = Xe(i, u, d, g, x);
      var A = kr !== 0;
      if (typeof E == "object" && E !== null && typeof E.render == "function" && E.$$typeof === void 0) Sr(E, d, g, x), en(i, u, E, d);
      else if (A) {
        g = u.treeContext, u.treeContext = Vt(g, 1, 0);
        try {
          bt(i, u, E);
        } finally {
          u.treeContext = g;
        }
      } else bt(i, u, E);
    }
    else if (typeof d == "string") {
      switch (E = u.blockedSegment, x = Cr(E.chunks, d, g, i.responseState, E.formatContext), E.lastPushedText = !1, A = E.formatContext, E.formatContext = b(A, d, g), vn(i, u, x), E.formatContext = A, d) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          E.chunks.push(Or, _(d), Mr);
      }
      E.lastPushedText = !1;
    } else {
      switch (d) {
        case C:
        case m:
        case Rr:
        case yt:
        case mr:
          bt(i, u, g.children);
          return;
        case st:
          bt(i, u, g.children);
          return;
        case h:
          throw Error(R(343));
        case Ne:
          e: {
            d = u.blockedBoundary, E = u.blockedSegment, x = g.fallback, g = g.children, A = /* @__PURE__ */ new Set();
            var j = { id: null, rootSegmentID: -1, parentFlushed: !1, pendingTasks: 0, forceClientRender: !1, completedSegments: [], byteSize: 0, fallbackAbortableTasks: A, errorDigest: null }, K = we(i, E.chunks.length, j, E.formatContext, !1, !1);
            E.children.push(K), E.lastPushedText = !1;
            var fe = we(i, 0, null, E.formatContext, !1, !1);
            fe.parentFlushed = !0, u.blockedBoundary = j, u.blockedSegment = fe;
            try {
              if (vn(
                i,
                u,
                g
              ), fe.lastPushedText && fe.textEmbedded && fe.chunks.push(O), fe.status = 1, Wn(j, fe), j.pendingTasks === 0) break e;
            } catch (se) {
              fe.status = 4, j.forceClientRender = !0, j.errorDigest = Te(i, se);
            } finally {
              u.blockedBoundary = d, u.blockedSegment = E;
            }
            u = _e(i, x, d, K, A, u.legacyContext, u.context, u.treeContext), i.pingedTasks.push(u);
          }
          return;
      }
      if (typeof d == "object" && d !== null) switch (d.$$typeof) {
        case Wr:
          if (g = Xe(i, u, d.render, g, E), kr !== 0) {
            d = u.treeContext, u.treeContext = Vt(d, 1, 0);
            try {
              bt(i, u, g);
            } finally {
              u.treeContext = d;
            }
          } else bt(i, u, g);
          return;
        case a:
          d = d.type, g = hn(d, g), tn(i, u, d, g, E);
          return;
        case At:
          if (E = g.children, d = d._context, g = g.value, x = d._currentValue, d._currentValue = g, A = V, V = g = { parent: A, depth: A === null ? 0 : A.depth + 1, context: d, parentValue: x, value: g }, u.context = g, bt(i, u, E), i = V, i === null) throw Error(R(403));
          g = i.parentValue, i.context._currentValue = g === w ? i.context._defaultValue : g, i = V = i.parent, u.context = i;
          return;
        case dt:
          g = g.children, g = g(d._currentValue), bt(i, u, g);
          return;
        case s:
          E = d._init, d = E(d._payload), g = hn(d, g), tn(i, u, d, g, void 0);
          return;
      }
      throw Error(R(
        130,
        d == null ? d : typeof d,
        ""
      ));
    }
  }
  function bt(i, u, d) {
    if (u.node = d, typeof d == "object" && d !== null) {
      switch (d.$$typeof) {
        case lt:
          tn(i, u, d.type, d.props, d.ref);
          return;
        case tr:
          throw Error(R(257));
        case s:
          var g = d._init;
          d = g(d._payload), bt(i, u, d);
          return;
      }
      if (ht(d)) {
        En(i, u, d);
        return;
      }
      if (d === null || typeof d != "object" ? g = null : (g = I && d[I] || d["@@iterator"], g = typeof g == "function" ? g : null), g && (g = g.call(d))) {
        if (d = g.next(), !d.done) {
          var E = [];
          do
            E.push(d.value), d = g.next();
          while (!d.done);
          En(i, u, E);
        }
        return;
      }
      throw i = Object.prototype.toString.call(d), Error(R(31, i === "[object Object]" ? "object with keys {" + Object.keys(d).join(", ") + "}" : i));
    }
    typeof d == "string" ? (g = u.blockedSegment, g.lastPushedText = ie(u.blockedSegment.chunks, d, i.responseState, g.lastPushedText)) : typeof d == "number" && (g = u.blockedSegment, g.lastPushedText = ie(u.blockedSegment.chunks, "" + d, i.responseState, g.lastPushedText));
  }
  function En(i, u, d) {
    for (var g = d.length, E = 0; E < g; E++) {
      var x = u.treeContext;
      u.treeContext = Vt(x, g, E);
      try {
        vn(i, u, d[E]);
      } finally {
        u.treeContext = x;
      }
    }
  }
  function vn(i, u, d) {
    var g = u.blockedSegment.formatContext, E = u.legacyContext, x = u.context;
    try {
      return bt(i, u, d);
    } catch (K) {
      if (qr(), typeof K == "object" && K !== null && typeof K.then == "function") {
        d = K;
        var A = u.blockedSegment, j = we(i, A.chunks.length, null, A.formatContext, A.lastPushedText, !0);
        A.children.push(j), A.lastPushedText = !1, i = _e(i, u.node, u.blockedBoundary, j, u.abortSet, u.legacyContext, u.context, u.treeContext).ping, d.then(i, i), u.blockedSegment.formatContext = g, u.legacyContext = E, u.context = x, Nt(x);
      } else throw u.blockedSegment.formatContext = g, u.legacyContext = E, u.context = x, Nt(x), K;
    }
  }
  function Hn(i) {
    var u = i.blockedBoundary;
    i = i.blockedSegment, i.status = 3, Uo(this, u, i);
  }
  function zn(i, u, d) {
    var g = i.blockedBoundary;
    i.blockedSegment.status = 3, g === null ? (u.allPendingTasks--, u.status !== 2 && (u.status = 2, u.destination !== null && u.destination.close())) : (g.pendingTasks--, g.forceClientRender || (g.forceClientRender = !0, i = d === void 0 ? Error(R(432)) : d, g.errorDigest = u.onError(i), g.parentFlushed && u.clientRenderedBoundaries.push(g)), g.fallbackAbortableTasks.forEach(function(E) {
      return zn(E, u, d);
    }), g.fallbackAbortableTasks.clear(), u.allPendingTasks--, u.allPendingTasks === 0 && (g = u.onAllReady, g()));
  }
  function Wn(i, u) {
    if (u.chunks.length === 0 && u.children.length === 1 && u.children[0].boundary === null) {
      var d = u.children[0];
      d.id = u.id, d.parentFlushed = !0, d.status === 1 && Wn(i, d);
    } else i.completedSegments.push(u);
  }
  function Uo(i, u, d) {
    if (u === null) {
      if (d.parentFlushed) {
        if (i.completedRootSegment !== null) throw Error(R(389));
        i.completedRootSegment = d;
      }
      i.pendingRootTasks--, i.pendingRootTasks === 0 && (i.onShellError = le, u = i.onShellReady, u());
    } else u.pendingTasks--, u.forceClientRender || (u.pendingTasks === 0 ? (d.parentFlushed && d.status === 1 && Wn(u, d), u.parentFlushed && i.completedBoundaries.push(u), u.fallbackAbortableTasks.forEach(Hn, i), u.fallbackAbortableTasks.clear()) : d.parentFlushed && d.status === 1 && (Wn(u, d), u.completedSegments.length === 1 && u.parentFlushed && i.partialBoundaries.push(u)));
    i.allPendingTasks--, i.allPendingTasks === 0 && (i = i.onAllReady, i());
  }
  function jo(i) {
    if (i.status !== 2) {
      var u = V, d = $.current;
      $.current = H;
      var g = Y;
      Y = i.responseState;
      try {
        var E = i.pingedTasks, x;
        for (x = 0; x < E.length; x++) {
          var A = E[x], j = i, K = A.blockedSegment;
          if (K.status === 0) {
            Nt(A.context);
            try {
              bt(j, A, A.node), K.lastPushedText && K.textEmbedded && K.chunks.push(O), A.abortSet.delete(A), K.status = 1, Uo(j, A.blockedBoundary, K);
            } catch (or) {
              if (qr(), typeof or == "object" && or !== null && typeof or.then == "function") {
                var fe = A.ping;
                or.then(fe, fe);
              } else {
                A.abortSet.delete(A), K.status = 4;
                var se = A.blockedBoundary, De = or, Ot = Te(j, De);
                if (se === null ? Ae(j, De) : (se.pendingTasks--, se.forceClientRender || (se.forceClientRender = !0, se.errorDigest = Ot, se.parentFlushed && j.clientRenderedBoundaries.push(se))), j.allPendingTasks--, j.allPendingTasks === 0) {
                  var nr = j.onAllReady;
                  nr();
                }
              }
            } finally {
            }
          }
        }
        E.splice(0, x), i.destination !== null && io(i, i.destination);
      } catch (or) {
        Te(i, or), Ae(i, or);
      } finally {
        Y = g, $.current = d, d === H && Nt(u);
      }
    }
  }
  function $n(i, u, d) {
    switch (d.parentFlushed = !0, d.status) {
      case 0:
        var g = d.id = i.nextSegmentId++;
        return d.lastPushedText = !1, d.textEmbedded = !1, i = i.responseState, v(u, He), v(u, i.placeholderPrefix), i = _(g.toString(16)), v(u, i), ue(u, Yr);
      case 1:
        d.status = 2;
        var E = !0;
        g = d.chunks;
        var x = 0;
        d = d.children;
        for (var A = 0; A < d.length; A++) {
          for (E = d[A]; x < E.index; x++) v(u, g[x]);
          E = Nn(i, u, E);
        }
        for (; x < g.length - 1; x++) v(u, g[x]);
        return x < g.length && (E = ue(u, g[x])), E;
      default:
        throw Error(R(390));
    }
  }
  function Nn(i, u, d) {
    var g = d.boundary;
    if (g === null) return $n(i, u, d);
    if (g.parentFlushed = !0, g.forceClientRender) g = g.errorDigest, ue(u, Br), v(u, Lt), g && (v(u, Xr), v(u, _(de(g))), v(u, Zt)), ue(u, un), $n(i, u, d);
    else if (0 < g.pendingTasks) {
      g.rootSegmentID = i.nextSegmentId++, 0 < g.completedSegments.length && i.partialBoundaries.push(g);
      var E = i.responseState, x = E.nextSuspenseID++;
      E = F(E.boundaryPrefix + x.toString(16)), g = g.id = E, it(u, i.responseState, g), $n(i, u, d);
    } else if (g.byteSize > i.progressiveChunkSize) g.rootSegmentID = i.nextSegmentId++, i.completedBoundaries.push(g), it(u, i.responseState, g.id), $n(i, u, d);
    else {
      if (ue(u, sn), d = g.completedSegments, d.length !== 1) throw Error(R(391));
      Nn(i, u, d[0]);
    }
    return ue(u, wn);
  }
  function Ho(i, u, d) {
    return gt(u, i.responseState, d.formatContext, d.id), Nn(i, u, d), jt(u, d.formatContext);
  }
  function zo(i, u, d) {
    for (var g = d.completedSegments, E = 0; E < g.length; E++) Wo(i, u, d, g[E]);
    if (g.length = 0, i = i.responseState, g = d.id, d = d.rootSegmentID, v(u, i.startInlineScript), i.sentCompleteBoundaryFunction ? v(u, mt) : (i.sentCompleteBoundaryFunction = !0, v(u, vr)), g === null) throw Error(R(395));
    return d = _(d.toString(16)), v(u, g), v(u, cn), v(u, i.segmentPrefix), v(u, d), ue(u, fn);
  }
  function Wo(i, u, d, g) {
    if (g.status === 2) return !0;
    var E = g.id;
    if (E === -1) {
      if ((g.id = d.rootSegmentID) === -1) throw Error(R(392));
      return Ho(i, u, g);
    }
    return Ho(i, u, g), i = i.responseState, v(u, i.startInlineScript), i.sentCompleteSegmentFunction ? v(u, pr) : (i.sentCompleteSegmentFunction = !0, v(u, zr)), v(u, i.segmentPrefix), E = _(E.toString(16)), v(u, E), v(u, hr), v(u, i.placeholderPrefix), v(u, E), ue(u, Ht);
  }
  function io(i, u) {
    Q = new Uint8Array(512), q = 0;
    try {
      var d = i.completedRootSegment;
      if (d !== null && i.pendingRootTasks === 0) {
        Nn(i, u, d), i.completedRootSegment = null;
        var g = i.responseState.bootstrapChunks;
        for (d = 0; d < g.length - 1; d++) v(u, g[d]);
        d < g.length && ue(u, g[d]);
      }
      var E = i.clientRenderedBoundaries, x;
      for (x = 0; x < E.length; x++) {
        var A = E[x];
        g = u;
        var j = i.responseState, K = A.id, fe = A.errorDigest, se = A.errorMessage, De = A.errorComponentStack;
        if (v(g, j.startInlineScript), j.sentClientRenderFunction ? v(g, We) : (j.sentClientRenderFunction = !0, v(
          g,
          er
        )), K === null) throw Error(R(395));
        v(g, K), v(g, zt), (fe || se || De) && (v(g, gr), v(g, _(Et(fe || "")))), (se || De) && (v(g, gr), v(g, _(Et(se || "")))), De && (v(g, gr), v(g, _(Et(De)))), ue(g, Wt);
      }
      E.splice(0, x);
      var Ot = i.completedBoundaries;
      for (x = 0; x < Ot.length; x++) zo(i, u, Ot[x]);
      Ot.splice(0, x), pt(u), Q = new Uint8Array(512), q = 0;
      var nr = i.partialBoundaries;
      for (x = 0; x < nr.length; x++) {
        var or = nr[x];
        e: {
          E = i, A = u;
          var Vn = or.completedSegments;
          for (j = 0; j < Vn.length; j++) if (!Wo(
            E,
            A,
            or,
            Vn[j]
          )) {
            j++, Vn.splice(0, j);
            var No = !1;
            break e;
          }
          Vn.splice(0, j), No = !0;
        }
        if (!No) {
          i.destination = null, x++, nr.splice(0, x);
          return;
        }
      }
      nr.splice(0, x);
      var Tn = i.completedBoundaries;
      for (x = 0; x < Tn.length; x++) zo(i, u, Tn[x]);
      Tn.splice(0, x);
    } finally {
      pt(u), i.allPendingTasks === 0 && i.pingedTasks.length === 0 && i.clientRenderedBoundaries.length === 0 && i.completedBoundaries.length === 0 && u.close();
    }
  }
  function $o(i, u) {
    try {
      var d = i.abortableTasks;
      d.forEach(function(g) {
        return zn(g, i, u);
      }), d.clear(), i.destination !== null && io(i, i.destination);
    } catch (g) {
      Te(i, g), Ae(i, g);
    }
  }
  return tl.renderToReadableStream = function(i, u) {
    return new Promise(function(d, g) {
      var E, x, A = new Promise(function(se, De) {
        x = se, E = De;
      }), j = be(i, Qe(u ? u.identifierPrefix : void 0, u ? u.nonce : void 0, u ? u.bootstrapScriptContent : void 0, u ? u.bootstrapScripts : void 0, u ? u.bootstrapModules : void 0), Rt(u ? u.namespaceURI : void 0), u ? u.progressiveChunkSize : void 0, u ? u.onError : void 0, x, function() {
        var se = new ReadableStream({ type: "bytes", pull: function(De) {
          if (j.status === 1) j.status = 2, et(De, j.fatalError);
          else if (j.status !== 2 && j.destination === null) {
            j.destination = De;
            try {
              io(j, De);
            } catch (Ot) {
              Te(j, Ot), Ae(j, Ot);
            }
          }
        }, cancel: function() {
          $o(j);
        } }, { highWaterMark: 0 });
        se.allReady = A, d(se);
      }, function(se) {
        A.catch(function() {
        }), g(se);
      }, E);
      if (u && u.signal) {
        var K = u.signal, fe = function() {
          $o(j, K.reason), K.removeEventListener("abort", fe);
        };
        K.addEventListener("abort", fe);
      }
      jo(j);
    });
  }, tl.version = "18.3.1", tl;
}
var Mo = {};
/**
 * @license React
 * react-dom-server-legacy.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var as;
function hs() {
  return as || (as = 1, process.env.NODE_ENV !== "production" && function() {
    var X = pi, R = "18.3.1", Q = X.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function q(e) {
      {
        for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)
          r[o - 1] = arguments[o];
        ue("warn", e, r);
      }
    }
    function v(e) {
      {
        for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)
          r[o - 1] = arguments[o];
        ue("error", e, r);
      }
    }
    function ue(e, t, r) {
      {
        var o = Q.ReactDebugCurrentFrame, l = o.getStackAddendum();
        l !== "" && (t += "%s", r = r.concat([l]));
        var c = r.map(function(p) {
          return String(p);
        });
        c.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, c);
      }
    }
    function pt(e) {
      e();
    }
    function xe(e) {
    }
    function _(e, t) {
      F(e, t);
    }
    function F(e, t) {
      return e.push(t);
    }
    function et(e) {
    }
    function B(e) {
      e.push(null);
    }
    function pe(e) {
      return e;
    }
    function ct(e) {
      return e;
    }
    function ae(e, t) {
      e.destroy(t);
    }
    function Ue(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, r = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return r;
      }
    }
    function z(e) {
      try {
        return M(e), !1;
      } catch {
        return !0;
      }
    }
    function M(e) {
      return "" + e;
    }
    function Ie(e, t) {
      if (z(e))
        return v("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Ue(e)), M(e);
    }
    function tt(e, t) {
      if (z(e))
        return v("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", t, Ue(e)), M(e);
    }
    function Pe(e) {
      if (z(e))
        return v("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Ue(e)), M(e);
    }
    var ne = Object.prototype.hasOwnProperty, he = 0, de = 1, Je = 2, Ce = 3, ht = 4, vt = 5, Ye = 6, kt = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", rt = kt + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", nt = new RegExp("^[" + kt + "][" + rt + "]*$"), xt = {}, G = {};
    function Qe(e) {
      return ne.call(G, e) ? !0 : ne.call(xt, e) ? !1 : nt.test(e) ? (G[e] = !0, !0) : (xt[e] = !0, v("Invalid attribute name: `%s`", e), !1);
    }
    function Ke(e, t, r, o) {
      if (r !== null && r.type === he)
        return !1;
      switch (typeof t) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (r !== null)
            return !r.acceptsBooleans;
          var l = e.toLowerCase().slice(0, 5);
          return l !== "data-" && l !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Rt(e) {
      return O.hasOwnProperty(e) ? O[e] : null;
    }
    function b(e, t, r, o, l, c, p) {
      this.acceptsBooleans = t === Je || t === Ce || t === ht, this.attributeName = o, this.attributeNamespace = l, this.mustUseProperty = r, this.propertyName = e, this.type = t, this.sanitizeURL = c, this.removeEmptyString = p;
    }
    var O = {}, ie = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    ie.forEach(function(e) {
      O[e] = new b(
        e,
        he,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
      var t = e[0], r = e[1];
      O[t] = new b(
        t,
        de,
        !1,
        // mustUseProperty
        r,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
      O[e] = new b(
        e,
        Je,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
      O[e] = new b(
        e,
        Je,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(e) {
      O[e] = new b(
        e,
        Ce,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      O[e] = new b(
        e,
        Ce,
        !0,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      O[e] = new b(
        e,
        ht,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      O[e] = new b(
        e,
        Ye,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(e) {
      O[e] = new b(
        e,
        vt,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var oe = /[\-\:]([a-z])/g, J = function(e) {
      return e[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(oe, J);
      O[t] = new b(
        t,
        de,
        !1,
        // mustUseProperty
        e,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(oe, J);
      O[t] = new b(
        t,
        de,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var t = e.replace(oe, J);
      O[t] = new b(
        t,
        de,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(e) {
      O[e] = new b(
        e,
        de,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var re = "xlinkHref";
    O[re] = new b(
      "xlinkHref",
      de,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(e) {
      O[e] = new b(
        e,
        de,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var ye = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Se(e, t) {
      return e + t.charAt(0).toUpperCase() + t.substring(1);
    }
    var ce = ["Webkit", "ms", "Moz", "O"];
    Object.keys(ye).forEach(function(e) {
      ce.forEach(function(t) {
        ye[Se(t, e)] = ye[e];
      });
    });
    var Fe = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function ot(e, t) {
      Fe[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || v("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || t.checked == null || v("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Ar(e, t) {
      if (e.indexOf("-") === -1)
        return typeof t.is == "string";
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Le = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, at = {}, Dr = new RegExp("^(aria)-[" + rt + "]*$"), cr = new RegExp("^(aria)[A-Z][" + rt + "]*$");
    function xr(e, t) {
      {
        if (ne.call(at, t) && at[t])
          return !0;
        if (cr.test(t)) {
          var r = "aria-" + t.slice(4).toLowerCase(), o = Le.hasOwnProperty(r) ? r : null;
          if (o == null)
            return v("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), at[t] = !0, !0;
          if (t !== o)
            return v("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, o), at[t] = !0, !0;
        }
        if (Dr.test(t)) {
          var l = t.toLowerCase(), c = Le.hasOwnProperty(l) ? l : null;
          if (c == null)
            return at[t] = !0, !1;
          if (t !== c)
            return v("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, c), at[t] = !0, !0;
        }
      }
      return !0;
    }
    function _t(e, t) {
      {
        var r = [];
        for (var o in t) {
          var l = xr(e, o);
          l || r.push(o);
        }
        var c = r.map(function(p) {
          return "`" + p + "`";
        }).join(", ");
        r.length === 1 ? v("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", c, e) : r.length > 1 && v("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", c, e);
      }
    }
    function fr(e, t) {
      Ar(e, t) || _t(e, t);
    }
    var ft = !1;
    function dr(e, t) {
      {
        if (e !== "input" && e !== "textarea" && e !== "select")
          return;
        t != null && t.value === null && !ft && (ft = !0, e === "select" && t.multiple ? v("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : v("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      }
    }
    var Ct = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Ze = function() {
    };
    {
      var je = {}, Cr = /^on./, Or = /^on[^A-Z]/, Mr = new RegExp("^(aria)-[" + rt + "]*$"), He = new RegExp("^(aria)[A-Z][" + rt + "]*$");
      Ze = function(e, t, r, o) {
        if (ne.call(je, t) && je[t])
          return !0;
        var l = t.toLowerCase();
        if (l === "onfocusin" || l === "onfocusout")
          return v("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), je[t] = !0, !0;
        if (o != null) {
          var c = o.registrationNameDependencies, p = o.possibleRegistrationNames;
          if (c.hasOwnProperty(t))
            return !0;
          var y = p.hasOwnProperty(l) ? p[l] : null;
          if (y != null)
            return v("Invalid event handler property `%s`. Did you mean `%s`?", t, y), je[t] = !0, !0;
          if (Cr.test(t))
            return v("Unknown event handler property `%s`. It will be ignored.", t), je[t] = !0, !0;
        } else if (Cr.test(t))
          return Or.test(t) && v("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), je[t] = !0, !0;
        if (Mr.test(t) || He.test(t))
          return !0;
        if (l === "innerhtml")
          return v("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), je[t] = !0, !0;
        if (l === "aria")
          return v("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), je[t] = !0, !0;
        if (l === "is" && r !== null && r !== void 0 && typeof r != "string")
          return v("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof r), je[t] = !0, !0;
        if (typeof r == "number" && isNaN(r))
          return v("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), je[t] = !0, !0;
        var k = Rt(t), D = k !== null && k.type === he;
        if (Ct.hasOwnProperty(l)) {
          var L = Ct[l];
          if (L !== t)
            return v("Invalid DOM property `%s`. Did you mean `%s`?", t, L), je[t] = !0, !0;
        } else if (!D && t !== l)
          return v("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, l), je[t] = !0, !0;
        return typeof r == "boolean" && Ke(t, r, k) ? (r ? v('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', r, t, t, r, t) : v('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', r, t, t, r, t, t, t), je[t] = !0, !0) : D ? !0 : Ke(t, r, k) ? (je[t] = !0, !1) : ((r === "false" || r === "true") && k !== null && k.type === Ce && (v("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", r, t, r === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', t, r), je[t] = !0), !0);
      };
    }
    var Yr = function(e, t, r) {
      {
        var o = [];
        for (var l in t) {
          var c = Ze(e, l, t[l], r);
          c || o.push(l);
        }
        var p = o.map(function(y) {
          return "`" + y + "`";
        }).join(", ");
        o.length === 1 ? v("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", p, e) : o.length > 1 && v("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", p, e);
      }
    };
    function sn(e, t, r) {
      Ar(e, t) || Yr(e, t, r);
    }
    var Lr = function() {
    };
    {
      var Gr = /^(?:webkit|moz|o)[A-Z]/, Br = /^-ms-/, wn = /-(.)/g, Lt = /;\s*$/, Zt = {}, Xr = {}, un = !1, it = !1, Bt = function(e) {
        return e.replace(wn, function(t, r) {
          return r.toUpperCase();
        });
      }, Jt = function(e) {
        Zt.hasOwnProperty(e) && Zt[e] || (Zt[e] = !0, v(
          "Unsupported style property %s. Did you mean %s?",
          e,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Bt(e.replace(Br, "ms-"))
        ));
      }, ge = function(e) {
        Zt.hasOwnProperty(e) && Zt[e] || (Zt[e] = !0, v("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
      }, It = function(e, t) {
        Xr.hasOwnProperty(t) && Xr[t] || (Xr[t] = !0, v(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, t.replace(Lt, "")));
      }, Qt = function(e, t) {
        un || (un = !0, v("`NaN` is an invalid value for the `%s` css style property.", e));
      }, Er = function(e, t) {
        it || (it = !0, v("`Infinity` is an invalid value for the `%s` css style property.", e));
      };
      Lr = function(e, t) {
        e.indexOf("-") > -1 ? Jt(e) : Gr.test(e) ? ge(e) : Lt.test(t) && It(e, t), typeof t == "number" && (isNaN(t) ? Qt(e, t) : isFinite(t) || Er(e, t));
      };
    }
    var Ut = Lr, Ur = /["'&<>]/;
    function Kt(e) {
      Pe(e);
      var t = "" + e, r = Ur.exec(t);
      if (!r)
        return t;
      var o, l = "", c, p = 0;
      for (c = r.index; c < t.length; c++) {
        switch (t.charCodeAt(c)) {
          case 34:
            o = "&quot;";
            break;
          case 38:
            o = "&amp;";
            break;
          case 39:
            o = "&#x27;";
            break;
          case 60:
            o = "&lt;";
            break;
          case 62:
            o = "&gt;";
            break;
          default:
            continue;
        }
        p !== c && (l += t.substring(p, c)), p = c + 1, l += o;
      }
      return p !== c ? l + t.substring(p, c) : l;
    }
    function Ge(e) {
      return typeof e == "boolean" || typeof e == "number" ? "" + e : Kt(e);
    }
    var qt = /([A-Z])/g, Tr = /^ms-/;
    function Zr(e) {
      return e.replace(qt, "-$1").toLowerCase().replace(Tr, "-ms-");
    }
    var ze = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Jr = !1;
    function kn(e) {
      !Jr && ze.test(e) && (Jr = !0, v("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
    }
    var xn = Array.isArray;
    function Pt(e) {
      return xn(e);
    }
    var jr = "<script>";
    function Hr(e, t, r, o, l) {
      var c = e === void 0 ? "" : e, p = jr, y = [];
      return {
        bootstrapChunks: y,
        startInlineScript: p,
        placeholderPrefix: c + "P:",
        segmentPrefix: c + "S:",
        boundaryPrefix: c + "B:",
        idPrefix: c,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var Oe = 0, gt = 1, jt = 2, zr = 3, pr = 4, hr = 5, Ht = 6, vr = 7;
    function mt(e, t) {
      return {
        insertionMode: e,
        selectedValue: t
      };
    }
    function cn(e, t, r) {
      switch (t) {
        case "select":
          return mt(gt, r.value != null ? r.value : r.defaultValue);
        case "svg":
          return mt(jt, null);
        case "math":
          return mt(zr, null);
        case "foreignObject":
          return mt(gt, null);
        case "table":
          return mt(pr, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return mt(hr, null);
        case "colgroup":
          return mt(vr, null);
        case "tr":
          return mt(Ht, null);
      }
      return e.insertionMode >= pr || e.insertionMode === Oe ? mt(gt, null) : e;
    }
    var fn = null;
    function er(e) {
      var t = e.nextSuspenseID++;
      return e.boundaryPrefix + t.toString(16);
    }
    function We(e, t, r) {
      var o = e.idPrefix, l = ":" + o + "R" + t;
      return r > 0 && (l += "H" + r.toString(32)), l + ":";
    }
    function zt(e) {
      return Ge(e);
    }
    var Wt = "<!-- -->";
    function gr(e, t, r, o) {
      return t === "" ? o : (o && e.push(Wt), e.push(zt(t)), !0);
    }
    function $t(e, t, r, o) {
      r && o && e.push(Wt);
    }
    var Et = /* @__PURE__ */ new Map();
    function Ft(e) {
      var t = Et.get(e);
      if (t !== void 0)
        return t;
      var r = Ge(Zr(e));
      return Et.set(e, r), r;
    }
    var lt = ' style="', tr = ":", mr = ";";
    function Rr(e, t, r) {
      if (typeof r != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var o = !0;
      for (var l in r)
        if (ne.call(r, l)) {
          var c = r[l];
          if (!(c == null || typeof c == "boolean" || c === "")) {
            var p = void 0, y = void 0, k = l.indexOf("--") === 0;
            k ? (p = Ge(l), tt(c, l), y = Ge(("" + c).trim())) : (Ut(l, c), p = Ft(l), typeof c == "number" ? c !== 0 && !ne.call(ye, l) ? y = c + "px" : y = "" + c : (tt(c, l), y = Ge(("" + c).trim()))), o ? (o = !1, e.push(lt, p, tr, y)) : e.push(mr, p, tr, y);
          }
        }
      o || e.push(dt);
    }
    var yt = " ", At = '="', dt = '"', Wr = '=""';
    function Ne(e, t, r, o) {
      switch (r) {
        case "style": {
          Rr(e, t, o);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(r.length > 2 && (r[0] === "o" || r[0] === "O") && (r[1] === "n" || r[1] === "N"))
      ) {
        var l = Rt(r);
        if (l !== null) {
          switch (typeof o) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!l.acceptsBooleans)
                return;
          }
          var c = l.attributeName, p = c;
          switch (l.type) {
            case Ce:
              o && e.push(yt, p, Wr);
              return;
            case ht:
              o === !0 ? e.push(yt, p, Wr) : o === !1 || e.push(yt, p, At, Ge(o), dt);
              return;
            case vt:
              isNaN(o) || e.push(yt, p, At, Ge(o), dt);
              break;
            case Ye:
              !isNaN(o) && o >= 1 && e.push(yt, p, At, Ge(o), dt);
              break;
            default:
              l.sanitizeURL && (Ie(o, c), o = "" + o, kn(o)), e.push(yt, p, At, Ge(o), dt);
          }
        } else if (Qe(r)) {
          switch (typeof o) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var y = r.toLowerCase().slice(0, 5);
              if (y !== "data-" && y !== "aria-")
                return;
            }
          }
          e.push(yt, r, At, Ge(o), dt);
        }
      }
    }
    var st = ">", a = "/>";
    function s(e, t, r) {
      if (t != null) {
        if (r != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof t != "object" || !("__html" in t))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var o = t.__html;
        o != null && (Pe(o), e.push("" + o));
      }
    }
    var h = !1, m = !1, C = !1, w = !1, I = !1, U = !1, N = !1;
    function Z(e, t) {
      {
        var r = e[t];
        if (r != null) {
          var o = Pt(r);
          e.multiple && !o ? v("The `%s` prop supplied to <select> must be an array if `multiple` is true.", t) : !e.multiple && o && v("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", t);
        }
      }
    }
    function V(e, t, r) {
      ot("select", t), Z(t, "value"), Z(t, "defaultValue"), t.value !== void 0 && t.defaultValue !== void 0 && !C && (v("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), C = !0), e.push(Yt("select"));
      var o = null, l = null;
      for (var c in t)
        if (ne.call(t, c)) {
          var p = t[c];
          if (p == null)
            continue;
          switch (c) {
            case "children":
              o = p;
              break;
            case "dangerouslySetInnerHTML":
              l = p;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              Ne(e, r, c, p);
              break;
          }
        }
      return e.push(st), s(e, l, o), o;
    }
    function me(e) {
      var t = "";
      return X.Children.forEach(e, function(r) {
        r != null && (t += r, !I && typeof r != "string" && typeof r != "number" && (I = !0, v("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), t;
    }
    var Ve = ' selected=""';
    function qe(e, t, r, o) {
      var l = o.selectedValue;
      e.push(Yt("option"));
      var c = null, p = null, y = null, k = null;
      for (var D in t)
        if (ne.call(t, D)) {
          var L = t[D];
          if (L == null)
            continue;
          switch (D) {
            case "children":
              c = L;
              break;
            case "selected":
              y = L, N || (v("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), N = !0);
              break;
            case "dangerouslySetInnerHTML":
              k = L;
              break;
            case "value":
              p = L;
            default:
              Ne(e, r, D, L);
              break;
          }
        }
      if (l != null) {
        var W;
        if (p !== null ? (Ie(p, "value"), W = "" + p) : (k !== null && (U || (U = !0, v("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), W = me(c)), Pt(l))
          for (var te = 0; te < l.length; te++) {
            Ie(l[te], "value");
            var Ee = "" + l[te];
            if (Ee === W) {
              e.push(Ve);
              break;
            }
          }
        else
          Ie(l, "select.value"), "" + l === W && e.push(Ve);
      } else y && e.push(Ve);
      return e.push(st), s(e, k, c), c;
    }
    function ut(e, t, r) {
      ot("input", t), t.checked !== void 0 && t.defaultChecked !== void 0 && !m && (v("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", t.type), m = !0), t.value !== void 0 && t.defaultValue !== void 0 && !h && (v("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", t.type), h = !0), e.push(Yt("input"));
      var o = null, l = null, c = null, p = null;
      for (var y in t)
        if (ne.call(t, y)) {
          var k = t[y];
          if (k == null)
            continue;
          switch (y) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              p = k;
              break;
            case "defaultValue":
              l = k;
              break;
            case "checked":
              c = k;
              break;
            case "value":
              o = k;
              break;
            default:
              Ne(e, r, y, k);
              break;
          }
        }
      return c !== null ? Ne(e, r, "checked", c) : p !== null && Ne(e, r, "checked", p), o !== null ? Ne(e, r, "value", o) : l !== null && Ne(e, r, "value", l), e.push(a), null;
    }
    function yr(e, t, r) {
      ot("textarea", t), t.value !== void 0 && t.defaultValue !== void 0 && !w && (v("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), w = !0), e.push(Yt("textarea"));
      var o = null, l = null, c = null;
      for (var p in t)
        if (ne.call(t, p)) {
          var y = t[p];
          if (y == null)
            continue;
          switch (p) {
            case "children":
              c = y;
              break;
            case "value":
              o = y;
              break;
            case "defaultValue":
              l = y;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              Ne(e, r, p, y);
              break;
          }
        }
      if (o === null && l !== null && (o = l), e.push(st), c != null) {
        if (v("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), o != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (Pt(c)) {
          if (c.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          Pe(c[0]), o = "" + c[0];
        }
        Pe(c), o = "" + c;
      }
      return typeof o == "string" && o[0] === `
` && e.push(wr), o !== null && (Ie(o, "value"), e.push(zt("" + o))), null;
    }
    function Nt(e, t, r, o) {
      e.push(Yt(r));
      for (var l in t)
        if (ne.call(t, l)) {
          var c = t[l];
          if (c == null)
            continue;
          switch (l) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(r + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              Ne(e, o, l, c);
              break;
          }
        }
      return e.push(a), null;
    }
    function _r(e, t, r) {
      e.push(Yt("menuitem"));
      for (var o in t)
        if (ne.call(t, o)) {
          var l = t[o];
          if (l == null)
            continue;
          switch (o) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              Ne(e, r, o, l);
              break;
          }
        }
      return e.push(st), null;
    }
    function Sr(e, t, r) {
      e.push(Yt("title"));
      var o = null;
      for (var l in t)
        if (ne.call(t, l)) {
          var c = t[l];
          if (c == null)
            continue;
          switch (l) {
            case "children":
              o = c;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              Ne(e, r, l, c);
              break;
          }
        }
      e.push(st);
      {
        var p = Array.isArray(o) && o.length < 2 ? o[0] || null : o;
        Array.isArray(o) && o.length > 1 ? v("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : p != null && p.$$typeof != null ? v("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : p != null && typeof p != "string" && typeof p != "number" && v("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return o;
    }
    function br(e, t, r, o) {
      e.push(Yt(r));
      var l = null, c = null;
      for (var p in t)
        if (ne.call(t, p)) {
          var y = t[p];
          if (y == null)
            continue;
          switch (p) {
            case "children":
              l = y;
              break;
            case "dangerouslySetInnerHTML":
              c = y;
              break;
            default:
              Ne(e, o, p, y);
              break;
          }
        }
      return e.push(st), s(e, c, l), typeof l == "string" ? (e.push(zt(l)), null) : l;
    }
    function Vt(e, t, r, o) {
      e.push(Yt(r));
      var l = null, c = null;
      for (var p in t)
        if (ne.call(t, p)) {
          var y = t[p];
          if (y == null)
            continue;
          switch (p) {
            case "children":
              l = y;
              break;
            case "dangerouslySetInnerHTML":
              c = y;
              break;
            case "style":
              Rr(e, o, y);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              Qe(p) && typeof y != "function" && typeof y != "symbol" && e.push(yt, p, At, Ge(y), dt);
              break;
          }
        }
      return e.push(st), s(e, c, l), l;
    }
    var wr = `
`;
    function oo(e, t, r, o) {
      e.push(Yt(r));
      var l = null, c = null;
      for (var p in t)
        if (ne.call(t, p)) {
          var y = t[p];
          if (y == null)
            continue;
          switch (p) {
            case "children":
              l = y;
              break;
            case "dangerouslySetInnerHTML":
              c = y;
              break;
            default:
              Ne(e, o, p, y);
              break;
          }
        }
      if (e.push(st), c != null) {
        if (l != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof c != "object" || !("__html" in c))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var k = c.__html;
        k != null && (typeof k == "string" && k.length > 0 && k[0] === `
` ? e.push(wr, k) : (Pe(k), e.push("" + k)));
      }
      return typeof l == "string" && l[0] === `
` && e.push(wr), l;
    }
    var Un = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Qr = /* @__PURE__ */ new Map();
    function Yt(e) {
      var t = Qr.get(e);
      if (t === void 0) {
        if (!Un.test(e))
          throw new Error("Invalid tag: " + e);
        t = "<" + e, Qr.set(e, t);
      }
      return t;
    }
    var ao = "<!DOCTYPE html>";
    function rr(e, t, r, o, l) {
      switch (fr(t, r), dr(t, r), sn(t, r, null), !r.suppressContentEditableWarning && r.contentEditable && r.children != null && v("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), l.insertionMode !== jt && l.insertionMode !== zr && t.indexOf("-") === -1 && typeof r.is != "string" && t.toLowerCase() !== t && v("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", t), t) {
        case "select":
          return V(e, r, o);
        case "option":
          return qe(e, r, o, l);
        case "textarea":
          return yr(e, r, o);
        case "input":
          return ut(e, r, o);
        case "menuitem":
          return _r(e, r, o);
        case "title":
          return Sr(e, r, o);
        case "listing":
        case "pre":
          return oo(e, r, t, o);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return Nt(e, r, t, o);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return br(e, r, t, o);
        case "html":
          return l.insertionMode === Oe && e.push(ao), br(e, r, t, o);
        default:
          return t.indexOf("-") === -1 && typeof r.is != "string" ? br(e, r, t, o) : Vt(e, r, t, o);
      }
    }
    var dn = "</", Ir = ">";
    function Re(e, t, r) {
      switch (t) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          e.push(dn, t, Ir);
      }
    }
    function Tt(e, t) {
      for (var r = t.bootstrapChunks, o = 0; o < r.length - 1; o++)
        _(e, r[o]);
      return o < r.length ? F(e, r[o]) : !0;
    }
    var Kr = '<template id="', kr = '"></template>';
    function Dt(e, t, r) {
      _(e, Kr), _(e, t.placeholderPrefix);
      var o = r.toString(16);
      return _(e, o), F(e, kr);
    }
    var $r = "<!--$-->", Gt = '<!--$?--><template id="', St = '"></template>', Cn = "<!--$!-->", qr = "<!--/$-->", jn = "<template", pn = '"', f = ' data-dgst="', S = ' data-msg="', T = ' data-stck="', P = "></template>";
    function H(e, t) {
      return F(e, $r);
    }
    function Y(e, t, r) {
      if (_(e, Gt), r === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return _(e, r), F(e, St);
    }
    function $(e, t, r, o, l) {
      var c;
      return c = F(e, Cn), _(e, jn), r && (_(e, f), _(e, Ge(r)), _(e, pn)), o && (_(e, S), _(e, Ge(o)), _(e, pn)), l && (_(e, T), _(e, Ge(l)), _(e, pn)), c = F(e, P), c;
    }
    function ee(e, t) {
      return F(e, qr);
    }
    function le(e, t) {
      return F(e, qr);
    }
    function be(e, t) {
      return F(e, qr);
    }
    var _e = '<div hidden id="', we = '">', Te = "</div>", Ae = '<svg aria-hidden="true" style="display:none" id="', Xe = '">', en = "</svg>", hn = '<math aria-hidden="true" style="display:none" id="', tn = '">', bt = "</math>", En = '<table hidden id="', vn = '">', Hn = "</table>", zn = '<table hidden><tbody id="', Wn = '">', Uo = "</tbody></table>", jo = '<table hidden><tr id="', $n = '">', Nn = "</tr></table>", Ho = '<table hidden><colgroup id="', zo = '">', Wo = "</colgroup></table>";
    function io(e, t, r, o) {
      switch (r.insertionMode) {
        case Oe:
        case gt:
          return _(e, _e), _(e, t.segmentPrefix), _(e, o.toString(16)), F(e, we);
        case jt:
          return _(e, Ae), _(e, t.segmentPrefix), _(e, o.toString(16)), F(e, Xe);
        case zr:
          return _(e, hn), _(e, t.segmentPrefix), _(e, o.toString(16)), F(e, tn);
        case pr:
          return _(e, En), _(e, t.segmentPrefix), _(e, o.toString(16)), F(e, vn);
        case hr:
          return _(e, zn), _(e, t.segmentPrefix), _(e, o.toString(16)), F(e, Wn);
        case Ht:
          return _(e, jo), _(e, t.segmentPrefix), _(e, o.toString(16)), F(e, $n);
        case vr:
          return _(e, Ho), _(e, t.segmentPrefix), _(e, o.toString(16)), F(e, zo);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function $o(e, t) {
      switch (t.insertionMode) {
        case Oe:
        case gt:
          return F(e, Te);
        case jt:
          return F(e, en);
        case zr:
          return F(e, bt);
        case pr:
          return F(e, Hn);
        case hr:
          return F(e, Uo);
        case Ht:
          return F(e, Nn);
        case vr:
          return F(e, Wo);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var i = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", u = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', d = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', g = i + ';$RS("', E = '$RS("', x = '","', A = '")<\/script>';
    function j(e, t, r) {
      _(e, t.startInlineScript), t.sentCompleteSegmentFunction ? _(e, E) : (t.sentCompleteSegmentFunction = !0, _(e, g)), _(e, t.segmentPrefix);
      var o = r.toString(16);
      return _(e, o), _(e, x), _(e, t.placeholderPrefix), _(e, o), F(e, A);
    }
    var K = u + ';$RC("', fe = '$RC("', se = '","', De = '")<\/script>';
    function Ot(e, t, r, o) {
      if (_(e, t.startInlineScript), t.sentCompleteBoundaryFunction ? _(e, fe) : (t.sentCompleteBoundaryFunction = !0, _(e, K)), r === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var l = o.toString(16);
      return _(e, r), _(e, se), _(e, t.segmentPrefix), _(e, l), F(e, De);
    }
    var nr = d + ';$RX("', or = '$RX("', Vn = '"', No = ")<\/script>", Tn = ",";
    function nl(e, t, r, o, l, c) {
      if (_(e, t.startInlineScript), t.sentClientRenderFunction ? _(e, or) : (t.sentClientRenderFunction = !0, _(e, nr)), r === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return _(e, r), _(e, Vn), (o || l || c) && (_(e, Tn), _(e, _a(o || ""))), (l || c) && (_(e, Tn), _(e, _a(l || ""))), c && (_(e, Tn), _(e, _a(c))), F(e, No);
    }
    var ol = /[<\u2028\u2029]/g;
    function _a(e) {
      var t = JSON.stringify(e);
      return t.replace(ol, function(r) {
        switch (r) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    function al(e, t) {
      var r = Hr(t);
      return {
        // Keep this in sync with ReactDOMServerFormatConfig
        bootstrapChunks: r.bootstrapChunks,
        startInlineScript: r.startInlineScript,
        placeholderPrefix: r.placeholderPrefix,
        segmentPrefix: r.segmentPrefix,
        boundaryPrefix: r.boundaryPrefix,
        idPrefix: r.idPrefix,
        nextSuspenseID: r.nextSuspenseID,
        sentCompleteSegmentFunction: r.sentCompleteSegmentFunction,
        sentCompleteBoundaryFunction: r.sentCompleteBoundaryFunction,
        sentClientRenderFunction: r.sentClientRenderFunction,
        // This is an extra field for the legacy renderer
        generateStaticMarkup: e
      };
    }
    function il() {
      return {
        insertionMode: gt,
        // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
        selectedValue: null
      };
    }
    function hi(e, t, r, o) {
      return r.generateStaticMarkup ? (e.push(Ge(t)), !1) : gr(e, t, r, o);
    }
    function vi(e, t, r, o) {
      if (!t.generateStaticMarkup)
        return $t(e, t, r, o);
    }
    function ll(e, t) {
      return t.generateStaticMarkup ? !0 : H(e);
    }
    function sl(e, t, r, o, l) {
      return t.generateStaticMarkup ? !0 : $(e, t, r, o, l);
    }
    function ul(e, t) {
      return t.generateStaticMarkup ? !0 : ee(e);
    }
    function cl(e, t) {
      return t.generateStaticMarkup ? !0 : be(e);
    }
    var Xt = Object.assign, fl = Symbol.for("react.element"), gi = Symbol.for("react.portal"), Vo = Symbol.for("react.fragment"), ar = Symbol.for("react.strict_mode"), mi = Symbol.for("react.profiler"), Yo = Symbol.for("react.provider"), Go = Symbol.for("react.context"), Xo = Symbol.for("react.forward_ref"), Zo = Symbol.for("react.suspense"), lo = Symbol.for("react.suspense_list"), so = Symbol.for("react.memo"), Yn = Symbol.for("react.lazy"), Ia = Symbol.for("react.scope"), Pa = Symbol.for("react.debug_trace_mode"), Fa = Symbol.for("react.legacy_hidden"), Jo = Symbol.for("react.default_value"), yi = Symbol.iterator, dl = "@@iterator";
    function pl(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = yi && e[yi] || e[dl];
      return typeof t == "function" ? t : null;
    }
    function hl(e, t, r) {
      var o = e.displayName;
      if (o)
        return o;
      var l = t.displayName || t.name || "";
      return l !== "" ? r + "(" + l + ")" : r;
    }
    function Aa(e) {
      return e.displayName || "Context";
    }
    function $e(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case Vo:
          return "Fragment";
        case gi:
          return "Portal";
        case mi:
          return "Profiler";
        case ar:
          return "StrictMode";
        case Zo:
          return "Suspense";
        case lo:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case Go:
            var t = e;
            return Aa(t) + ".Consumer";
          case Yo:
            var r = e;
            return Aa(r._context) + ".Provider";
          case Xo:
            return hl(e, e.render, "ForwardRef");
          case so:
            var o = e.displayName || null;
            return o !== null ? o : $e(e.type) || "Memo";
          case Yn: {
            var l = e, c = l._payload, p = l._init;
            try {
              return $e(p(c));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var uo = 0, Si, Da, Be, Gn, Oa, Ma, La;
    function Ba() {
    }
    Ba.__reactDisabledLog = !0;
    function bi() {
      {
        if (uo === 0) {
          Si = console.log, Da = console.info, Be = console.warn, Gn = console.error, Oa = console.group, Ma = console.groupCollapsed, La = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Ba,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        uo++;
      }
    }
    function wi() {
      {
        if (uo--, uo === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Xt({}, e, {
              value: Si
            }),
            info: Xt({}, e, {
              value: Da
            }),
            warn: Xt({}, e, {
              value: Be
            }),
            error: Xt({}, e, {
              value: Gn
            }),
            group: Xt({}, e, {
              value: Oa
            }),
            groupCollapsed: Xt({}, e, {
              value: Ma
            }),
            groupEnd: Xt({}, e, {
              value: La
            })
          });
        }
        uo < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Qo = Q.ReactCurrentDispatcher, Ko;
    function co(e, t, r) {
      {
        if (Ko === void 0)
          try {
            throw Error();
          } catch (l) {
            var o = l.stack.trim().match(/\n( *(at )?)/);
            Ko = o && o[1] || "";
          }
        return `
` + Ko + e;
      }
    }
    var Ua = !1, Xn;
    {
      var ja = typeof WeakMap == "function" ? WeakMap : Map;
      Xn = new ja();
    }
    function Rn(e, t) {
      if (!e || Ua)
        return "";
      {
        var r = Xn.get(e);
        if (r !== void 0)
          return r;
      }
      var o;
      Ua = !0;
      var l = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var c;
      c = Qo.current, Qo.current = null, bi();
      try {
        if (t) {
          var p = function() {
            throw Error();
          };
          if (Object.defineProperty(p.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(p, []);
            } catch (wt) {
              o = wt;
            }
            Reflect.construct(e, [], p);
          } else {
            try {
              p.call();
            } catch (wt) {
              o = wt;
            }
            e.call(p.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (wt) {
            o = wt;
          }
          e();
        }
      } catch (wt) {
        if (wt && o && typeof wt.stack == "string") {
          for (var y = wt.stack.split(`
`), k = o.stack.split(`
`), D = y.length - 1, L = k.length - 1; D >= 1 && L >= 0 && y[D] !== k[L]; )
            L--;
          for (; D >= 1 && L >= 0; D--, L--)
            if (y[D] !== k[L]) {
              if (D !== 1 || L !== 1)
                do
                  if (D--, L--, L < 0 || y[D] !== k[L]) {
                    var W = `
` + y[D].replace(" at new ", " at ");
                    return e.displayName && W.includes("<anonymous>") && (W = W.replace("<anonymous>", e.displayName)), typeof e == "function" && Xn.set(e, W), W;
                  }
                while (D >= 1 && L >= 0);
              break;
            }
        }
      } finally {
        Ua = !1, Qo.current = c, wi(), Error.prepareStackTrace = l;
      }
      var te = e ? e.displayName || e.name : "", Ee = te ? co(te) : "";
      return typeof e == "function" && Xn.set(e, Ee), Ee;
    }
    function Ha(e, t, r) {
      return Rn(e, !0);
    }
    function fo(e, t, r) {
      return Rn(e, !1);
    }
    function vl(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function po(e, t, r) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Rn(e, vl(e));
      if (typeof e == "string")
        return co(e);
      switch (e) {
        case Zo:
          return co("Suspense");
        case lo:
          return co("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case Xo:
            return fo(e.render);
          case so:
            return po(e.type, t, r);
          case Yn: {
            var o = e, l = o._payload, c = o._init;
            try {
              return po(c(l), t, r);
            } catch {
            }
          }
        }
      return "";
    }
    var ki = {}, za = Q.ReactDebugCurrentFrame;
    function qo(e) {
      if (e) {
        var t = e._owner, r = po(e.type, e._source, t ? t.type : null);
        za.setExtraStackFrame(r);
      } else
        za.setExtraStackFrame(null);
    }
    function ea(e, t, r, o, l) {
      {
        var c = Function.call.bind(ne);
        for (var p in e)
          if (c(e, p)) {
            var y = void 0;
            try {
              if (typeof e[p] != "function") {
                var k = Error((o || "React class") + ": " + r + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw k.name = "Invariant Violation", k;
              }
              y = e[p](t, p, o, r, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              y = D;
            }
            y && !(y instanceof Error) && (qo(l), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", o || "React class", r, p, typeof y), qo(null)), y instanceof Error && !(y.message in ki) && (ki[y.message] = !0, qo(l), v("Failed %s type: %s", r, y.message), qo(null));
          }
      }
    }
    var ta;
    ta = {};
    var ho = {};
    Object.freeze(ho);
    function vo(e, t) {
      {
        var r = e.contextTypes;
        if (!r)
          return ho;
        var o = {};
        for (var l in r)
          o[l] = t[l];
        {
          var c = $e(e) || "Unknown";
          ea(r, o, "context", c);
        }
        return o;
      }
    }
    function xi(e, t, r, o) {
      {
        if (typeof e.getChildContext != "function") {
          {
            var l = $e(t) || "Unknown";
            ta[l] || (ta[l] = !0, v("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", l, l));
          }
          return r;
        }
        var c = e.getChildContext();
        for (var p in c)
          if (!(p in o))
            throw new Error(($e(t) || "Unknown") + '.getChildContext(): key "' + p + '" is not defined in childContextTypes.');
        {
          var y = $e(t) || "Unknown";
          ea(o, c, "child context", y);
        }
        return Xt({}, r, c);
      }
    }
    var _n;
    _n = {};
    var ra = null, gn = null;
    function Wa(e) {
      e.context._currentValue2 = e.parentValue;
    }
    function In(e) {
      e.context._currentValue2 = e.value;
    }
    function na(e, t) {
      if (e !== t) {
        Wa(e);
        var r = e.parent, o = t.parent;
        if (r === null) {
          if (o !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (o === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          na(r, o);
        }
        In(t);
      }
    }
    function mn(e) {
      Wa(e);
      var t = e.parent;
      t !== null && mn(t);
    }
    function oa(e) {
      var t = e.parent;
      t !== null && oa(t), In(e);
    }
    function aa(e, t) {
      Wa(e);
      var r = e.parent;
      if (r === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      r.depth === t.depth ? na(r, t) : aa(r, t);
    }
    function go(e, t) {
      var r = t.parent;
      if (r === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      e.depth === r.depth ? na(e, r) : go(e, r), In(t);
    }
    function mo(e) {
      var t = gn, r = e;
      t !== r && (t === null ? oa(r) : r === null ? mn(t) : t.depth === r.depth ? na(t, r) : t.depth > r.depth ? aa(t, r) : go(t, r), gn = r);
    }
    function Ci(e, t) {
      var r;
      r = e._currentValue2, e._currentValue2 = t, e._currentRenderer2 !== void 0 && e._currentRenderer2 !== null && e._currentRenderer2 !== _n && v("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), e._currentRenderer2 = _n;
      var o = gn, l = {
        parent: o,
        depth: o === null ? 0 : o.depth + 1,
        context: e,
        parentValue: r,
        value: t
      };
      return gn = l, l;
    }
    function Ei(e) {
      var t = gn;
      if (t === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      t.context !== e && v("The parent context is not the expected context. This is probably a bug in React.");
      {
        var r = t.parentValue;
        r === Jo ? t.context._currentValue2 = t.context._defaultValue : t.context._currentValue2 = r, e._currentRenderer2 !== void 0 && e._currentRenderer2 !== null && e._currentRenderer2 !== _n && v("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), e._currentRenderer2 = _n;
      }
      return gn = t.parent;
    }
    function Ti() {
      return gn;
    }
    function yn(e) {
      var t = e._currentValue2;
      return t;
    }
    function $a(e) {
      return e._reactInternals;
    }
    function gl(e, t) {
      e._reactInternals = t;
    }
    var Ri = {}, Zn = {}, yo, Na, ia, la, sa, Jn, So, bo, ua;
    {
      yo = /* @__PURE__ */ new Set(), Na = /* @__PURE__ */ new Set(), ia = /* @__PURE__ */ new Set(), So = /* @__PURE__ */ new Set(), la = /* @__PURE__ */ new Set(), bo = /* @__PURE__ */ new Set(), ua = /* @__PURE__ */ new Set();
      var wo = /* @__PURE__ */ new Set();
      Jn = function(e, t) {
        if (!(e === null || typeof e == "function")) {
          var r = t + "_" + e;
          wo.has(r) || (wo.add(r), v("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e));
        }
      }, sa = function(e, t) {
        if (t === void 0) {
          var r = $e(e) || "Component";
          la.has(r) || (la.add(r), v("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", r));
        }
      };
    }
    function ca(e, t) {
      {
        var r = e.constructor, o = r && $e(r) || "ReactClass", l = o + "." + t;
        if (Ri[l])
          return;
        v(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, t, t, o), Ri[l] = !0;
      }
    }
    var fa = {
      isMounted: function(e) {
        return !1;
      },
      enqueueSetState: function(e, t, r) {
        var o = $a(e);
        o.queue === null ? ca(e, "setState") : (o.queue.push(t), r != null && Jn(r, "setState"));
      },
      enqueueReplaceState: function(e, t, r) {
        var o = $a(e);
        o.replace = !0, o.queue = [t], r != null && Jn(r, "setState");
      },
      enqueueForceUpdate: function(e, t) {
        var r = $a(e);
        r.queue === null ? ca(e, "forceUpdate") : t != null && Jn(t, "setState");
      }
    };
    function Va(e, t, r, o, l) {
      var c = r(l, o);
      sa(t, c);
      var p = c == null ? o : Xt({}, o, c);
      return p;
    }
    function _i(e, t, r) {
      var o = ho, l = e.contextType;
      if ("contextType" in e) {
        var c = (
          // Allow null for conditional declaration
          l === null || l !== void 0 && l.$$typeof === Go && l._context === void 0
        );
        if (!c && !ua.has(e)) {
          ua.add(e);
          var p = "";
          l === void 0 ? p = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof l != "object" ? p = " However, it is set to a " + typeof l + "." : l.$$typeof === Yo ? p = " Did you accidentally pass the Context.Provider instead?" : l._context !== void 0 ? p = " Did you accidentally pass the Context.Consumer instead?" : p = " However, it is set to an object with keys {" + Object.keys(l).join(", ") + "}.", v("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", $e(e) || "Component", p);
        }
      }
      typeof l == "object" && l !== null ? o = yn(l) : o = r;
      var y = new e(t, o);
      {
        if (typeof e.getDerivedStateFromProps == "function" && (y.state === null || y.state === void 0)) {
          var k = $e(e) || "Component";
          yo.has(k) || (yo.add(k), v("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", k, y.state === null ? "null" : "undefined", k));
        }
        if (typeof e.getDerivedStateFromProps == "function" || typeof y.getSnapshotBeforeUpdate == "function") {
          var D = null, L = null, W = null;
          if (typeof y.componentWillMount == "function" && y.componentWillMount.__suppressDeprecationWarning !== !0 ? D = "componentWillMount" : typeof y.UNSAFE_componentWillMount == "function" && (D = "UNSAFE_componentWillMount"), typeof y.componentWillReceiveProps == "function" && y.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? L = "componentWillReceiveProps" : typeof y.UNSAFE_componentWillReceiveProps == "function" && (L = "UNSAFE_componentWillReceiveProps"), typeof y.componentWillUpdate == "function" && y.componentWillUpdate.__suppressDeprecationWarning !== !0 ? W = "componentWillUpdate" : typeof y.UNSAFE_componentWillUpdate == "function" && (W = "UNSAFE_componentWillUpdate"), D !== null || L !== null || W !== null) {
            var te = $e(e) || "Component", Ee = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            ia.has(te) || (ia.add(te), v(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, te, Ee, D !== null ? `
  ` + D : "", L !== null ? `
  ` + L : "", W !== null ? `
  ` + W : ""));
          }
        }
      }
      return y;
    }
    function Ii(e, t, r) {
      {
        var o = $e(t) || "Component", l = e.render;
        l || (t.prototype && typeof t.prototype.render == "function" ? v("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", o) : v("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", o)), e.getInitialState && !e.getInitialState.isReactClassApproved && !e.state && v("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", o), e.getDefaultProps && !e.getDefaultProps.isReactClassApproved && v("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", o), e.propTypes && v("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", o), e.contextType && v("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", o), e.contextTypes && v("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", o), t.contextType && t.contextTypes && !bo.has(t) && (bo.add(t), v("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", o)), typeof e.componentShouldUpdate == "function" && v("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", o), t.prototype && t.prototype.isPureReactComponent && typeof e.shouldComponentUpdate < "u" && v("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", $e(t) || "A pure component"), typeof e.componentDidUnmount == "function" && v("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", o), typeof e.componentDidReceiveProps == "function" && v("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", o), typeof e.componentWillRecieveProps == "function" && v("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", o), typeof e.UNSAFE_componentWillRecieveProps == "function" && v("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", o);
        var c = e.props !== r;
        e.props !== void 0 && c && v("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", o, o), e.defaultProps && v("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", o, o), typeof e.getSnapshotBeforeUpdate == "function" && typeof e.componentDidUpdate != "function" && !Na.has(t) && (Na.add(t), v("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", $e(t))), typeof e.getDerivedStateFromProps == "function" && v("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", o), typeof e.getDerivedStateFromError == "function" && v("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", o), typeof t.getSnapshotBeforeUpdate == "function" && v("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", o);
        var p = e.state;
        p && (typeof p != "object" || Pt(p)) && v("%s.state: must be set to an object or null", o), typeof e.getChildContext == "function" && typeof t.childContextTypes != "object" && v("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", o);
      }
    }
    function Pi(e, t) {
      var r = t.state;
      if (typeof t.componentWillMount == "function") {
        if (t.componentWillMount.__suppressDeprecationWarning !== !0) {
          var o = $e(e) || "Unknown";
          Zn[o] || (q(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            o
          ), Zn[o] = !0);
        }
        t.componentWillMount();
      }
      typeof t.UNSAFE_componentWillMount == "function" && t.UNSAFE_componentWillMount(), r !== t.state && (v("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", $e(e) || "Component"), fa.enqueueReplaceState(t, t.state, null));
    }
    function ml(e, t, r, o) {
      if (e.queue !== null && e.queue.length > 0) {
        var l = e.queue, c = e.replace;
        if (e.queue = null, e.replace = !1, c && l.length === 1)
          t.state = l[0];
        else {
          for (var p = c ? l[0] : t.state, y = !0, k = c ? 1 : 0; k < l.length; k++) {
            var D = l[k], L = typeof D == "function" ? D.call(t, p, r, o) : D;
            L != null && (y ? (y = !1, p = Xt({}, p, L)) : Xt(p, L));
          }
          t.state = p;
        }
      } else
        e.queue = null;
    }
    function Fi(e, t, r, o) {
      Ii(e, t, r);
      var l = e.state !== void 0 ? e.state : null;
      e.updater = fa, e.props = r, e.state = l;
      var c = {
        queue: [],
        replace: !1
      };
      gl(e, c);
      var p = t.contextType;
      if (typeof p == "object" && p !== null ? e.context = yn(p) : e.context = o, e.state === r) {
        var y = $e(t) || "Component";
        So.has(y) || (So.add(y), v("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", y));
      }
      var k = t.getDerivedStateFromProps;
      typeof k == "function" && (e.state = Va(e, t, k, l, r)), typeof t.getDerivedStateFromProps != "function" && typeof e.getSnapshotBeforeUpdate != "function" && (typeof e.UNSAFE_componentWillMount == "function" || typeof e.componentWillMount == "function") && (Pi(t, e), ml(c, e, r, o));
    }
    var yl = {
      id: 1,
      overflow: ""
    };
    function Sl(e) {
      var t = e.overflow, r = e.id, o = r & ~bl(r);
      return o.toString(32) + t;
    }
    function Ya(e, t, r) {
      var o = e.id, l = e.overflow, c = ko(o) - 1, p = o & ~(1 << c), y = r + 1, k = ko(t) + c;
      if (k > 30) {
        var D = c - c % 5, L = (1 << D) - 1, W = (p & L).toString(32), te = p >> D, Ee = c - D, wt = ko(t) + Ee, Ln = y << Ee, Bn = Ln | te, ln = W + l;
        return {
          id: 1 << wt | Bn,
          overflow: ln
        };
      } else {
        var no = y << c, Kl = no | p, ss = l;
        return {
          id: 1 << k | Kl,
          overflow: ss
        };
      }
    }
    function ko(e) {
      return 32 - wl(e);
    }
    function bl(e) {
      return 1 << ko(e) - 1;
    }
    var wl = Math.clz32 ? Math.clz32 : kl, Ga = Math.log, da = Math.LN2;
    function kl(e) {
      var t = e >>> 0;
      return t === 0 ? 32 : 31 - (Ga(t) / da | 0) | 0;
    }
    function xl(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    var Cl = typeof Object.is == "function" ? Object.is : xl, rn = null, Xa = null, pa = null, Me = null, ir = !1, Qn = !1, Pn = 0, ke = null, Sn = 0, ha = 25, lr = !1, sr;
    function Nr() {
      if (rn === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return lr && v("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), rn;
    }
    function El(e, t) {
      if (t === null)
        return v("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", sr), !1;
      e.length !== t.length && v(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, sr, "[" + e.join(", ") + "]", "[" + t.join(", ") + "]");
      for (var r = 0; r < t.length && r < e.length; r++)
        if (!Cl(e[r], t[r]))
          return !1;
      return !0;
    }
    function Pr() {
      if (Sn > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function bn() {
      return Me === null ? pa === null ? (ir = !1, pa = Me = Pr()) : (ir = !0, Me = pa) : Me.next === null ? (ir = !1, Me = Me.next = Pr()) : (ir = !0, Me = Me.next), Me;
    }
    function Fn(e, t) {
      rn = t, Xa = e, lr = !1, Pn = 0;
    }
    function Tl(e, t, r, o) {
      for (; Qn; )
        Qn = !1, Pn = 0, Sn += 1, Me = null, r = e(t, o);
      return xo(), r;
    }
    function Za() {
      var e = Pn !== 0;
      return e;
    }
    function xo() {
      lr = !1, rn = null, Xa = null, Qn = !1, pa = null, Sn = 0, ke = null, Me = null;
    }
    function Rl(e) {
      return lr && v("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), yn(e);
    }
    function _l(e) {
      return sr = "useContext", Nr(), yn(e);
    }
    function va(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function Ja(e) {
      return sr = "useState", Ai(
        va,
        // useReducer has a special case to support lazy useState initializers
        e
      );
    }
    function Ai(e, t, r) {
      if (e !== va && (sr = "useReducer"), rn = Nr(), Me = bn(), ir) {
        var o = Me.queue, l = o.dispatch;
        if (ke !== null) {
          var c = ke.get(o);
          if (c !== void 0) {
            ke.delete(o);
            var p = Me.memoizedState, y = c;
            do {
              var k = y.action;
              lr = !0, p = e(p, k), lr = !1, y = y.next;
            } while (y !== null);
            return Me.memoizedState = p, [p, l];
          }
        }
        return [Me.memoizedState, l];
      } else {
        lr = !0;
        var D;
        e === va ? D = typeof t == "function" ? t() : t : D = r !== void 0 ? r(t) : t, lr = !1, Me.memoizedState = D;
        var L = Me.queue = {
          last: null,
          dispatch: null
        }, W = L.dispatch = Oi.bind(null, rn, L);
        return [Me.memoizedState, W];
      }
    }
    function Di(e, t) {
      rn = Nr(), Me = bn();
      var r = t === void 0 ? null : t;
      if (Me !== null) {
        var o = Me.memoizedState;
        if (o !== null && r !== null) {
          var l = o[1];
          if (El(r, l))
            return o[0];
        }
      }
      lr = !0;
      var c = e();
      return lr = !1, Me.memoizedState = [c, r], c;
    }
    function Qa(e) {
      rn = Nr(), Me = bn();
      var t = Me.memoizedState;
      if (t === null) {
        var r = {
          current: e
        };
        return Object.seal(r), Me.memoizedState = r, r;
      } else
        return t;
    }
    function Il(e, t) {
      sr = "useLayoutEffect", v("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Oi(e, t, r) {
      if (Sn >= ha)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (e === rn) {
        Qn = !0;
        var o = {
          action: r,
          next: null
        };
        ke === null && (ke = /* @__PURE__ */ new Map());
        var l = ke.get(t);
        if (l === void 0)
          ke.set(t, o);
        else {
          for (var c = l; c.next !== null; )
            c = c.next;
          c.next = o;
        }
      }
    }
    function Mi(e, t) {
      return Di(function() {
        return e;
      }, t);
    }
    function Pl(e, t, r) {
      return Nr(), t(e._source);
    }
    function Fl(e, t, r) {
      if (r === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return r();
    }
    function Al(e) {
      return Nr(), e;
    }
    function Dl() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function Ol() {
      return Nr(), [!1, Dl];
    }
    function Ml() {
      var e = Xa, t = Sl(e.treeContext), r = Ka;
      if (r === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var o = Pn++;
      return We(r, t, o);
    }
    function ga() {
    }
    var Li = {
      readContext: Rl,
      useContext: _l,
      useMemo: Di,
      useReducer: Ai,
      useRef: Qa,
      useState: Ja,
      useInsertionEffect: ga,
      useLayoutEffect: Il,
      useCallback: Mi,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: ga,
      // Effects are not run in the server environment.
      useEffect: ga,
      // Debugging effect
      useDebugValue: ga,
      useDeferredValue: Al,
      useTransition: Ol,
      useId: Ml,
      // Subscriptions are not setup in a server environment.
      useMutableSource: Pl,
      useSyncExternalStore: Fl
    }, Ka = null;
    function Bi(e) {
      Ka = e;
    }
    function ma(e) {
      try {
        var t = "", r = e;
        do {
          switch (r.tag) {
            case 0:
              t += co(r.type, null, null);
              break;
            case 1:
              t += fo(r.type, null, null);
              break;
            case 2:
              t += Ha(r.type, null, null);
              break;
          }
          r = r.parent;
        } while (r);
        return t;
      } catch (o) {
        return `
Error generating stack: ` + o.message + `
` + o.stack;
      }
    }
    var ya = Q.ReactCurrentDispatcher, Co = Q.ReactDebugCurrentFrame, Sa = 0, Kn = 1, ba = 2, wa = 3, ka = 4, qn = 0, qa = 1, An = 2, Ui = 12800;
    function Ll(e) {
      return console.error(e), null;
    }
    function eo() {
    }
    function to(e, t, r, o, l, c, p, y, k) {
      var D = [], L = /* @__PURE__ */ new Set(), W = {
        destination: null,
        responseState: t,
        progressiveChunkSize: o === void 0 ? Ui : o,
        status: qn,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: L,
        pingedTasks: D,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: l === void 0 ? Ll : l,
        onAllReady: eo,
        onShellReady: p === void 0 ? eo : p,
        onShellError: eo,
        onFatalError: eo
      }, te = xa(
        W,
        0,
        null,
        r,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      te.parentFlushed = !0;
      var Ee = Dn(W, e, null, te, L, ho, ra, yl);
      return D.push(Ee), W;
    }
    function Bl(e, t) {
      var r = e.pingedTasks;
      r.push(t), r.length === 1 && pt(function() {
        return ui(e);
      });
    }
    function Ul(e, t) {
      return {
        id: fn,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: t,
        errorDigest: null
      };
    }
    function Dn(e, t, r, o, l, c, p, y) {
      e.allPendingTasks++, r === null ? e.pendingRootTasks++ : r.pendingTasks++;
      var k = {
        node: t,
        ping: function() {
          return Bl(e, k);
        },
        blockedBoundary: r,
        blockedSegment: o,
        abortSet: l,
        legacyContext: c,
        context: p,
        treeContext: y
      };
      return k.componentStack = null, l.add(k), k;
    }
    function xa(e, t, r, o, l, c) {
      return {
        status: Sa,
        id: -1,
        // lazily assigned later
        index: t,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: o,
        boundary: r,
        lastPushedText: l,
        textEmbedded: c
      };
    }
    var nn = null;
    function ei() {
      return nn === null || nn.componentStack === null ? "" : ma(nn.componentStack);
    }
    function On(e, t) {
      e.componentStack = {
        tag: 0,
        parent: e.componentStack,
        type: t
      };
    }
    function Eo(e, t) {
      e.componentStack = {
        tag: 1,
        parent: e.componentStack,
        type: t
      };
    }
    function on(e, t) {
      e.componentStack = {
        tag: 2,
        parent: e.componentStack,
        type: t
      };
    }
    function Vr(e) {
      e.componentStack === null ? v("Unexpectedly popped too many stack frames. This is a bug in React.") : e.componentStack = e.componentStack.parent;
    }
    var an = null;
    function Ca(e, t) {
      {
        var r;
        typeof t == "string" ? r = t : t && typeof t.message == "string" ? r = t.message : r = String(t);
        var o = an || ei();
        an = null, e.errorMessage = r, e.errorComponentStack = o;
      }
    }
    function To(e, t) {
      var r = e.onError(t);
      if (r != null && typeof r != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof r + '" instead');
      return r;
    }
    function Fr(e, t) {
      var r = e.onShellError;
      r(t);
      var o = e.onFatalError;
      o(t), e.destination !== null ? (e.status = An, ae(e.destination, t)) : (e.status = qa, e.fatalError = t);
    }
    function Ro(e, t, r) {
      On(t, "Suspense");
      var o = t.blockedBoundary, l = t.blockedSegment, c = r.fallback, p = r.children, y = /* @__PURE__ */ new Set(), k = Ul(e, y), D = l.chunks.length, L = xa(
        e,
        D,
        k,
        l.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      l.children.push(L), l.lastPushedText = !1;
      var W = xa(
        e,
        0,
        null,
        l.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      W.parentFlushed = !0, t.blockedBoundary = k, t.blockedSegment = W;
      try {
        if (Mt(e, t, p), vi(W.chunks, e.responseState, W.lastPushedText, W.textEmbedded), W.status = Kn, ro(k, W), k.pendingTasks === 0) {
          Vr(t);
          return;
        }
      } catch (Ee) {
        W.status = ka, k.forceClientRender = !0, k.errorDigest = To(e, Ee), Ca(k, Ee);
      } finally {
        t.blockedBoundary = o, t.blockedSegment = l;
      }
      var te = Dn(e, c, o, L, y, t.legacyContext, t.context, t.treeContext);
      te.componentStack = t.componentStack, e.pingedTasks.push(te), Vr(t);
    }
    function ti(e, t, r, o) {
      On(t, r);
      var l = t.blockedSegment, c = rr(l.chunks, r, o, e.responseState, l.formatContext);
      l.lastPushedText = !1;
      var p = l.formatContext;
      l.formatContext = cn(p, r, o), Mt(e, t, c), l.formatContext = p, Re(l.chunks, r), l.lastPushedText = !1, Vr(t);
    }
    function _o(e) {
      return e.prototype && e.prototype.isReactComponent;
    }
    function Io(e, t, r, o, l) {
      var c = {};
      Fn(t, c);
      var p = r(o, l);
      return Tl(r, o, p, l);
    }
    function ji(e, t, r, o, l) {
      var c = r.render();
      r.props !== l && (ni || v("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", $e(o) || "a component"), ni = !0);
      {
        var p = o.childContextTypes;
        if (p != null) {
          var y = t.legacyContext, k = xi(r, o, y, p);
          t.legacyContext = k, ur(e, t, c), t.legacyContext = y;
          return;
        }
      }
      ur(e, t, c);
    }
    function jl(e, t, r, o) {
      on(t, r);
      var l = vo(r, t.legacyContext), c = _i(r, o, l);
      Fi(c, r, o, l), ji(e, t, c, r, o), Vr(t);
    }
    var Hi = {}, Po = {}, ri = {}, zi = {}, ni = !1, Fo = {}, oi = !1, ai = !1, ii = !1;
    function Wi(e, t, r, o) {
      var l;
      if (l = vo(r, t.legacyContext), Eo(t, r), r.prototype && typeof r.prototype.render == "function") {
        var c = $e(r) || "Unknown";
        Hi[c] || (v("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", c, c), Hi[c] = !0);
      }
      var p = Io(e, t, r, o, l), y = Za();
      if (typeof p == "object" && p !== null && typeof p.render == "function" && p.$$typeof === void 0) {
        var k = $e(r) || "Unknown";
        Po[k] || (v("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", k, k, k), Po[k] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof p == "object" && p !== null && typeof p.render == "function" && p.$$typeof === void 0
      ) {
        {
          var D = $e(r) || "Unknown";
          Po[D] || (v("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", D, D, D), Po[D] = !0);
        }
        Fi(p, r, o, l), ji(e, t, p, r, o);
      } else if ($i(r), y) {
        var L = t.treeContext, W = 1, te = 0;
        t.treeContext = Ya(L, W, te);
        try {
          ur(e, t, p);
        } finally {
          t.treeContext = L;
        }
      } else
        ur(e, t, p);
      Vr(t);
    }
    function $i(e) {
      {
        if (e && e.childContextTypes && v("%s(...): childContextTypes cannot be defined on a function component.", e.displayName || e.name || "Component"), e.defaultProps !== void 0) {
          var t = $e(e) || "Unknown";
          Fo[t] || (v("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", t), Fo[t] = !0);
        }
        if (typeof e.getDerivedStateFromProps == "function") {
          var r = $e(e) || "Unknown";
          zi[r] || (v("%s: Function components do not support getDerivedStateFromProps.", r), zi[r] = !0);
        }
        if (typeof e.contextType == "object" && e.contextType !== null) {
          var o = $e(e) || "Unknown";
          ri[o] || (v("%s: Function components do not support contextType.", o), ri[o] = !0);
        }
      }
    }
    function li(e, t) {
      if (e && e.defaultProps) {
        var r = Xt({}, t), o = e.defaultProps;
        for (var l in o)
          r[l] === void 0 && (r[l] = o[l]);
        return r;
      }
      return t;
    }
    function Ni(e, t, r, o, l) {
      Eo(t, r.render);
      var c = Io(e, t, r.render, o, l), p = Za();
      if (p) {
        var y = t.treeContext, k = 1, D = 0;
        t.treeContext = Ya(y, k, D);
        try {
          ur(e, t, c);
        } finally {
          t.treeContext = y;
        }
      } else
        ur(e, t, c);
      Vr(t);
    }
    function Hl(e, t, r, o, l) {
      var c = r.type, p = li(c, o);
      si(e, t, c, p, l);
    }
    function zl(e, t, r, o) {
      r._context === void 0 ? r !== r.Consumer && (ii || (ii = !0, v("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : r = r._context;
      var l = o.children;
      typeof l != "function" && v("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var c = yn(r), p = l(c);
      ur(e, t, p);
    }
    function Vi(e, t, r, o) {
      var l = r._context, c = o.value, p = o.children, y;
      y = t.context, t.context = Ci(l, c), ur(e, t, p), t.context = Ei(l), y !== t.context && v("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function Wl(e, t, r, o, l) {
      On(t, "Lazy");
      var c = r._payload, p = r._init, y = p(c), k = li(y, o);
      si(e, t, y, k, l), Vr(t);
    }
    function si(e, t, r, o, l) {
      if (typeof r == "function")
        if (_o(r)) {
          jl(e, t, r, o);
          return;
        } else {
          Wi(e, t, r, o);
          return;
        }
      if (typeof r == "string") {
        ti(e, t, r, o);
        return;
      }
      switch (r) {
        case Fa:
        case Pa:
        case ar:
        case mi:
        case Vo: {
          ur(e, t, o.children);
          return;
        }
        case lo: {
          On(t, "SuspenseList"), ur(e, t, o.children), Vr(t);
          return;
        }
        case Ia:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case Zo: {
          Ro(e, t, o);
          return;
        }
      }
      if (typeof r == "object" && r !== null)
        switch (r.$$typeof) {
          case Xo: {
            Ni(e, t, r, o, l);
            return;
          }
          case so: {
            Hl(e, t, r, o, l);
            return;
          }
          case Yo: {
            Vi(e, t, r, o);
            return;
          }
          case Go: {
            zl(e, t, r, o);
            return;
          }
          case Yn: {
            Wl(e, t, r, o);
            return;
          }
        }
      var c = "";
      throw (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (c += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (r == null ? r : typeof r) + "." + c));
    }
    function $l(e, t) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      e[Symbol.toStringTag] === "Generator" && (oi || v("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), oi = !0), e.entries === t && (ai || v("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), ai = !0);
    }
    function ur(e, t, r) {
      try {
        return Nl(e, t, r);
      } catch (o) {
        throw typeof o == "object" && o !== null && typeof o.then == "function" || (an = an !== null ? an : ei()), o;
      }
    }
    function Nl(e, t, r) {
      if (t.node = r, typeof r == "object" && r !== null) {
        switch (r.$$typeof) {
          case fl: {
            var o = r, l = o.type, c = o.props, p = o.ref;
            si(e, t, l, c, p);
            return;
          }
          case gi:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case Yn: {
            var y = r, k = y._payload, D = y._init, L;
            try {
              L = D(k);
            } catch (no) {
              throw typeof no == "object" && no !== null && typeof no.then == "function" && On(t, "Lazy"), no;
            }
            ur(e, t, L);
            return;
          }
        }
        if (Pt(r)) {
          Ea(e, t, r);
          return;
        }
        var W = pl(r);
        if (W) {
          $l(r, W);
          var te = W.call(r);
          if (te) {
            var Ee = te.next();
            if (!Ee.done) {
              var wt = [];
              do
                wt.push(Ee.value), Ee = te.next();
              while (!Ee.done);
              Ea(e, t, wt);
              return;
            }
            return;
          }
        }
        var Ln = Object.prototype.toString.call(r);
        throw new Error("Objects are not valid as a React child (found: " + (Ln === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : Ln) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof r == "string") {
        var Bn = t.blockedSegment;
        Bn.lastPushedText = hi(t.blockedSegment.chunks, r, e.responseState, Bn.lastPushedText);
        return;
      }
      if (typeof r == "number") {
        var ln = t.blockedSegment;
        ln.lastPushedText = hi(t.blockedSegment.chunks, "" + r, e.responseState, ln.lastPushedText);
        return;
      }
      typeof r == "function" && v("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function Ea(e, t, r) {
      for (var o = r.length, l = 0; l < o; l++) {
        var c = t.treeContext;
        t.treeContext = Ya(c, o, l);
        try {
          Mt(e, t, r[l]);
        } finally {
          t.treeContext = c;
        }
      }
    }
    function Vl(e, t, r) {
      var o = t.blockedSegment, l = o.chunks.length, c = xa(
        e,
        l,
        null,
        o.formatContext,
        // Adopt the parent segment's leading text embed
        o.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      o.children.push(c), o.lastPushedText = !1;
      var p = Dn(e, t.node, t.blockedBoundary, c, t.abortSet, t.legacyContext, t.context, t.treeContext);
      t.componentStack !== null && (p.componentStack = t.componentStack.parent);
      var y = p.ping;
      r.then(y, y);
    }
    function Mt(e, t, r) {
      var o = t.blockedSegment.formatContext, l = t.legacyContext, c = t.context, p = null;
      p = t.componentStack;
      try {
        return ur(e, t, r);
      } catch (y) {
        if (xo(), typeof y == "object" && y !== null && typeof y.then == "function") {
          Vl(e, t, y), t.blockedSegment.formatContext = o, t.legacyContext = l, t.context = c, mo(c), t.componentStack = p;
          return;
        } else
          throw t.blockedSegment.formatContext = o, t.legacyContext = l, t.context = c, mo(c), t.componentStack = p, y;
      }
    }
    function Yl(e, t, r, o) {
      var l = To(e, o);
      if (t === null ? Fr(e, o) : (t.pendingTasks--, t.forceClientRender || (t.forceClientRender = !0, t.errorDigest = l, Ca(t, o), t.parentFlushed && e.clientRenderedBoundaries.push(t))), e.allPendingTasks--, e.allPendingTasks === 0) {
        var c = e.onAllReady;
        c();
      }
    }
    function Yi(e) {
      var t = this, r = e.blockedBoundary, o = e.blockedSegment;
      o.status = wa, Xi(t, r, o);
    }
    function Gi(e, t, r) {
      var o = e.blockedBoundary, l = e.blockedSegment;
      if (l.status = wa, o === null)
        t.allPendingTasks--, t.status !== An && (t.status = An, t.destination !== null && B(t.destination));
      else {
        if (o.pendingTasks--, !o.forceClientRender) {
          o.forceClientRender = !0;
          var c = r === void 0 ? new Error("The render was aborted by the server without a reason.") : r;
          o.errorDigest = t.onError(c);
          {
            var p = "The server did not finish this Suspense boundary: ";
            c && typeof c.message == "string" ? c = p + c.message : c = p + String(c);
            var y = nn;
            nn = e;
            try {
              Ca(o, c);
            } finally {
              nn = y;
            }
          }
          o.parentFlushed && t.clientRenderedBoundaries.push(o);
        }
        if (o.fallbackAbortableTasks.forEach(function(D) {
          return Gi(D, t, r);
        }), o.fallbackAbortableTasks.clear(), t.allPendingTasks--, t.allPendingTasks === 0) {
          var k = t.onAllReady;
          k();
        }
      }
    }
    function ro(e, t) {
      if (t.chunks.length === 0 && t.children.length === 1 && t.children[0].boundary === null) {
        var r = t.children[0];
        r.id = t.id, r.parentFlushed = !0, r.status === Kn && ro(e, r);
      } else {
        var o = e.completedSegments;
        o.push(t);
      }
    }
    function Xi(e, t, r) {
      if (t === null) {
        if (r.parentFlushed) {
          if (e.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          e.completedRootSegment = r;
        }
        if (e.pendingRootTasks--, e.pendingRootTasks === 0) {
          e.onShellError = eo;
          var o = e.onShellReady;
          o();
        }
      } else if (t.pendingTasks--, !t.forceClientRender) {
        if (t.pendingTasks === 0)
          r.parentFlushed && r.status === Kn && ro(t, r), t.parentFlushed && e.completedBoundaries.push(t), t.fallbackAbortableTasks.forEach(Yi, e), t.fallbackAbortableTasks.clear();
        else if (r.parentFlushed && r.status === Kn) {
          ro(t, r);
          var l = t.completedSegments;
          l.length === 1 && t.parentFlushed && e.partialBoundaries.push(t);
        }
      }
      if (e.allPendingTasks--, e.allPendingTasks === 0) {
        var c = e.onAllReady;
        c();
      }
    }
    function Gl(e, t) {
      var r = t.blockedSegment;
      if (r.status === Sa) {
        mo(t.context);
        var o = null;
        o = nn, nn = t;
        try {
          ur(e, t, t.node), vi(r.chunks, e.responseState, r.lastPushedText, r.textEmbedded), t.abortSet.delete(t), r.status = Kn, Xi(e, t.blockedBoundary, r);
        } catch (c) {
          if (xo(), typeof c == "object" && c !== null && typeof c.then == "function") {
            var l = t.ping;
            c.then(l, l);
          } else
            t.abortSet.delete(t), r.status = ka, Yl(e, t.blockedBoundary, r, c);
        } finally {
          nn = o;
        }
      }
    }
    function ui(e) {
      if (e.status !== An) {
        var t = Ti(), r = ya.current;
        ya.current = Li;
        var o;
        o = Co.getCurrentStack, Co.getCurrentStack = ei;
        var l = Ka;
        Bi(e.responseState);
        try {
          var c = e.pingedTasks, p;
          for (p = 0; p < c.length; p++) {
            var y = c[p];
            Gl(e, y);
          }
          c.splice(0, p), e.destination !== null && Ra(e, e.destination);
        } catch (k) {
          To(e, k), Fr(e, k);
        } finally {
          Bi(l), ya.current = r, Co.getCurrentStack = o, r === Li && mo(t);
        }
      }
    }
    function Mn(e, t, r) {
      switch (r.parentFlushed = !0, r.status) {
        case Sa: {
          var o = r.id = e.nextSegmentId++;
          return r.lastPushedText = !1, r.textEmbedded = !1, Dt(t, e.responseState, o);
        }
        case Kn: {
          r.status = ba;
          for (var l = !0, c = r.chunks, p = 0, y = r.children, k = 0; k < y.length; k++) {
            for (var D = y[k]; p < D.index; p++)
              _(t, c[p]);
            l = Ao(e, t, D);
          }
          for (; p < c.length - 1; p++)
            _(t, c[p]);
          return p < c.length && (l = F(t, c[p])), l;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function Ao(e, t, r) {
      var o = r.boundary;
      if (o === null)
        return Mn(e, t, r);
      if (o.parentFlushed = !0, o.forceClientRender)
        return sl(t, e.responseState, o.errorDigest, o.errorMessage, o.errorComponentStack), Mn(e, t, r), cl(t, e.responseState);
      if (o.pendingTasks > 0) {
        o.rootSegmentID = e.nextSegmentId++, o.completedSegments.length > 0 && e.partialBoundaries.push(o);
        var l = o.id = er(e.responseState);
        return Y(t, e.responseState, l), Mn(e, t, r), le(t, e.responseState);
      } else {
        if (o.byteSize > e.progressiveChunkSize)
          return o.rootSegmentID = e.nextSegmentId++, e.completedBoundaries.push(o), Y(t, e.responseState, o.id), Mn(e, t, r), le(t, e.responseState);
        ll(t, e.responseState);
        var c = o.completedSegments;
        if (c.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var p = c[0];
        return Ao(e, t, p), ul(t, e.responseState);
      }
    }
    function Xl(e, t, r) {
      return nl(t, e.responseState, r.id, r.errorDigest, r.errorMessage, r.errorComponentStack);
    }
    function ci(e, t, r) {
      return io(t, e.responseState, r.formatContext, r.id), Ao(e, t, r), $o(t, r.formatContext);
    }
    function Do(e, t, r) {
      for (var o = r.completedSegments, l = 0; l < o.length; l++) {
        var c = o[l];
        Zi(e, t, r, c);
      }
      return o.length = 0, Ot(t, e.responseState, r.id, r.rootSegmentID);
    }
    function Ta(e, t, r) {
      for (var o = r.completedSegments, l = 0; l < o.length; l++) {
        var c = o[l];
        if (!Zi(e, t, r, c))
          return l++, o.splice(0, l), !1;
      }
      return o.splice(0, l), !0;
    }
    function Zi(e, t, r, o) {
      if (o.status === ba)
        return !0;
      var l = o.id;
      if (l === -1) {
        var c = o.id = r.rootSegmentID;
        if (c === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return ci(e, t, o);
      } else
        return ci(e, t, o), j(t, e.responseState, l);
    }
    function Ra(e, t) {
      try {
        var r = e.completedRootSegment;
        r !== null && e.pendingRootTasks === 0 && (Ao(e, t, r), e.completedRootSegment = null, Tt(t, e.responseState));
        var o = e.clientRenderedBoundaries, l;
        for (l = 0; l < o.length; l++) {
          var c = o[l];
          if (!Xl(e, t, c)) {
            e.destination = null, l++, o.splice(0, l);
            return;
          }
        }
        o.splice(0, l);
        var p = e.completedBoundaries;
        for (l = 0; l < p.length; l++) {
          var y = p[l];
          if (!Do(e, t, y)) {
            e.destination = null, l++, p.splice(0, l);
            return;
          }
        }
        p.splice(0, l);
        var k = e.partialBoundaries;
        for (l = 0; l < k.length; l++) {
          var D = k[l];
          if (!Ta(e, t, D)) {
            e.destination = null, l++, k.splice(0, l);
            return;
          }
        }
        k.splice(0, l);
        var L = e.completedBoundaries;
        for (l = 0; l < L.length; l++) {
          var W = L[l];
          if (!Do(e, t, W)) {
            e.destination = null, l++, L.splice(0, l);
            return;
          }
        }
        L.splice(0, l);
      } finally {
        e.allPendingTasks === 0 && e.pingedTasks.length === 0 && e.clientRenderedBoundaries.length === 0 && e.completedBoundaries.length === 0 && (e.abortableTasks.size !== 0 && v("There was still abortable task at the root when we closed. This is a bug in React."), B(t));
      }
    }
    function Ji(e) {
      pt(function() {
        return ui(e);
      });
    }
    function Zl(e, t) {
      if (e.status === qa) {
        e.status = An, ae(t, e.fatalError);
        return;
      }
      if (e.status !== An && e.destination === null) {
        e.destination = t;
        try {
          Ra(e, t);
        } catch (r) {
          To(e, r), Fr(e, r);
        }
      }
    }
    function Qi(e, t) {
      try {
        var r = e.abortableTasks;
        r.forEach(function(o) {
          return Gi(o, e, t);
        }), r.clear(), e.destination !== null && Ra(e, e.destination);
      } catch (o) {
        To(e, o), Fr(e, o);
      }
    }
    function fi() {
    }
    function Ki(e, t, r, o) {
      var l = !1, c = null, p = "", y = {
        push: function(W) {
          return W !== null && (p += W), !0;
        },
        destroy: function(W) {
          l = !0, c = W;
        }
      }, k = !1;
      function D() {
        k = !0;
      }
      var L = to(e, al(r, t ? t.identifierPrefix : void 0), il(), 1 / 0, fi, void 0, D);
      if (Ji(L), Qi(L, o), Zl(L, y), l)
        throw c;
      if (!k)
        throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
      return p;
    }
    function Jl(e, t) {
      return Ki(e, t, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function qi(e, t) {
      return Ki(e, t, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
    }
    function Ql() {
      throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function n() {
      throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    Mo.renderToNodeStream = Ql, Mo.renderToStaticMarkup = qi, Mo.renderToStaticNodeStream = n, Mo.renderToString = Jl, Mo.version = R;
  }()), Mo;
}
var rl = {};
/**
 * @license React
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var is;
function vs() {
  return is || (is = 1, process.env.NODE_ENV !== "production" && function() {
    var X = pi, R = "18.3.1", Q = X.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function q(n) {
      {
        for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
          t[r - 1] = arguments[r];
        ue("warn", n, t);
      }
    }
    function v(n) {
      {
        for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
          t[r - 1] = arguments[r];
        ue("error", n, t);
      }
    }
    function ue(n, e, t) {
      {
        var r = Q.ReactDebugCurrentFrame, o = r.getStackAddendum();
        o !== "" && (e += "%s", t = t.concat([o]));
        var l = t.map(function(c) {
          return String(c);
        });
        l.unshift("Warning: " + e), Function.prototype.apply.call(console[n], console, l);
      }
    }
    function pt(n) {
      n();
    }
    var xe = 512, _ = null, F = 0;
    function et(n) {
      _ = new Uint8Array(xe), F = 0;
    }
    function B(n, e) {
      if (e.length !== 0) {
        if (e.length > xe) {
          F > 0 && (n.enqueue(new Uint8Array(_.buffer, 0, F)), _ = new Uint8Array(xe), F = 0), n.enqueue(e);
          return;
        }
        var t = e, r = _.length - F;
        r < t.length && (r === 0 ? n.enqueue(_) : (_.set(t.subarray(0, r), F), n.enqueue(_), t = t.subarray(r)), _ = new Uint8Array(xe), F = 0), _.set(t, F), F += t.length;
      }
    }
    function pe(n, e) {
      return B(n, e), !0;
    }
    function ct(n) {
      _ && F > 0 && (n.enqueue(new Uint8Array(_.buffer, 0, F)), _ = null, F = 0);
    }
    function ae(n) {
      n.close();
    }
    var Ue = new TextEncoder();
    function z(n) {
      return Ue.encode(n);
    }
    function M(n) {
      return Ue.encode(n);
    }
    function Ie(n, e) {
      typeof n.error == "function" ? n.error(e) : n.close();
    }
    function tt(n) {
      {
        var e = typeof Symbol == "function" && Symbol.toStringTag, t = e && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return t;
      }
    }
    function Pe(n) {
      try {
        return ne(n), !1;
      } catch {
        return !0;
      }
    }
    function ne(n) {
      return "" + n;
    }
    function he(n, e) {
      if (Pe(n))
        return v("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", e, tt(n)), ne(n);
    }
    function de(n, e) {
      if (Pe(n))
        return v("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", e, tt(n)), ne(n);
    }
    function Je(n) {
      if (Pe(n))
        return v("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", tt(n)), ne(n);
    }
    var Ce = Object.prototype.hasOwnProperty, ht = 0, vt = 1, Ye = 2, kt = 3, rt = 4, nt = 5, xt = 6, G = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Qe = G + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Ke = new RegExp("^[" + G + "][" + Qe + "]*$"), Rt = {}, b = {};
    function O(n) {
      return Ce.call(b, n) ? !0 : Ce.call(Rt, n) ? !1 : Ke.test(n) ? (b[n] = !0, !0) : (Rt[n] = !0, v("Invalid attribute name: `%s`", n), !1);
    }
    function ie(n, e, t, r) {
      if (t !== null && t.type === ht)
        return !1;
      switch (typeof e) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (t !== null)
            return !t.acceptsBooleans;
          var o = n.toLowerCase().slice(0, 5);
          return o !== "data-" && o !== "aria-";
        }
        default:
          return !1;
      }
    }
    function oe(n) {
      return re.hasOwnProperty(n) ? re[n] : null;
    }
    function J(n, e, t, r, o, l, c) {
      this.acceptsBooleans = e === Ye || e === kt || e === rt, this.attributeName = r, this.attributeNamespace = o, this.mustUseProperty = t, this.propertyName = n, this.type = e, this.sanitizeURL = l, this.removeEmptyString = c;
    }
    var re = {}, ye = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    ye.forEach(function(n) {
      re[n] = new J(
        n,
        ht,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
      var e = n[0], t = n[1];
      re[e] = new J(
        e,
        vt,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
      re[n] = new J(
        n,
        Ye,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
      re[n] = new J(
        n,
        Ye,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(n) {
      re[n] = new J(
        n,
        kt,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      re[n] = new J(
        n,
        kt,
        !0,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      re[n] = new J(
        n,
        rt,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      re[n] = new J(
        n,
        xt,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(n) {
      re[n] = new J(
        n,
        nt,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Se = /[\-\:]([a-z])/g, ce = function(n) {
      return n[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var e = n.replace(Se, ce);
      re[e] = new J(
        e,
        vt,
        !1,
        // mustUseProperty
        n,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var e = n.replace(Se, ce);
      re[e] = new J(
        e,
        vt,
        !1,
        // mustUseProperty
        n,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var e = n.replace(Se, ce);
      re[e] = new J(
        e,
        vt,
        !1,
        // mustUseProperty
        n,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(n) {
      re[n] = new J(
        n,
        vt,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Fe = "xlinkHref";
    re[Fe] = new J(
      "xlinkHref",
      vt,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(n) {
      re[n] = new J(
        n,
        vt,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var ot = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Ar(n, e) {
      return n + e.charAt(0).toUpperCase() + e.substring(1);
    }
    var Le = ["Webkit", "ms", "Moz", "O"];
    Object.keys(ot).forEach(function(n) {
      Le.forEach(function(e) {
        ot[Ar(e, n)] = ot[n];
      });
    });
    var at = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Dr(n, e) {
      at[e.type] || e.onChange || e.onInput || e.readOnly || e.disabled || e.value == null || v("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), e.onChange || e.readOnly || e.disabled || e.checked == null || v("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function cr(n, e) {
      if (n.indexOf("-") === -1)
        return typeof e.is == "string";
      switch (n) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var xr = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, _t = {}, fr = new RegExp("^(aria)-[" + Qe + "]*$"), ft = new RegExp("^(aria)[A-Z][" + Qe + "]*$");
    function dr(n, e) {
      {
        if (Ce.call(_t, e) && _t[e])
          return !0;
        if (ft.test(e)) {
          var t = "aria-" + e.slice(4).toLowerCase(), r = xr.hasOwnProperty(t) ? t : null;
          if (r == null)
            return v("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", e), _t[e] = !0, !0;
          if (e !== r)
            return v("Invalid ARIA attribute `%s`. Did you mean `%s`?", e, r), _t[e] = !0, !0;
        }
        if (fr.test(e)) {
          var o = e.toLowerCase(), l = xr.hasOwnProperty(o) ? o : null;
          if (l == null)
            return _t[e] = !0, !1;
          if (e !== l)
            return v("Unknown ARIA attribute `%s`. Did you mean `%s`?", e, l), _t[e] = !0, !0;
        }
      }
      return !0;
    }
    function Ct(n, e) {
      {
        var t = [];
        for (var r in e) {
          var o = dr(n, r);
          o || t.push(r);
        }
        var l = t.map(function(c) {
          return "`" + c + "`";
        }).join(", ");
        t.length === 1 ? v("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", l, n) : t.length > 1 && v("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", l, n);
      }
    }
    function Ze(n, e) {
      cr(n, e) || Ct(n, e);
    }
    var je = !1;
    function Cr(n, e) {
      {
        if (n !== "input" && n !== "textarea" && n !== "select")
          return;
        e != null && e.value === null && !je && (je = !0, n === "select" && e.multiple ? v("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", n) : v("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", n));
      }
    }
    var Or = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Mr = function() {
    };
    {
      var He = {}, Yr = /^on./, sn = /^on[^A-Z]/, Lr = new RegExp("^(aria)-[" + Qe + "]*$"), Gr = new RegExp("^(aria)[A-Z][" + Qe + "]*$");
      Mr = function(n, e, t, r) {
        if (Ce.call(He, e) && He[e])
          return !0;
        var o = e.toLowerCase();
        if (o === "onfocusin" || o === "onfocusout")
          return v("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), He[e] = !0, !0;
        if (r != null) {
          var l = r.registrationNameDependencies, c = r.possibleRegistrationNames;
          if (l.hasOwnProperty(e))
            return !0;
          var p = c.hasOwnProperty(o) ? c[o] : null;
          if (p != null)
            return v("Invalid event handler property `%s`. Did you mean `%s`?", e, p), He[e] = !0, !0;
          if (Yr.test(e))
            return v("Unknown event handler property `%s`. It will be ignored.", e), He[e] = !0, !0;
        } else if (Yr.test(e))
          return sn.test(e) && v("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", e), He[e] = !0, !0;
        if (Lr.test(e) || Gr.test(e))
          return !0;
        if (o === "innerhtml")
          return v("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), He[e] = !0, !0;
        if (o === "aria")
          return v("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), He[e] = !0, !0;
        if (o === "is" && t !== null && t !== void 0 && typeof t != "string")
          return v("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof t), He[e] = !0, !0;
        if (typeof t == "number" && isNaN(t))
          return v("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", e), He[e] = !0, !0;
        var y = oe(e), k = y !== null && y.type === ht;
        if (Or.hasOwnProperty(o)) {
          var D = Or[o];
          if (D !== e)
            return v("Invalid DOM property `%s`. Did you mean `%s`?", e, D), He[e] = !0, !0;
        } else if (!k && e !== o)
          return v("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", e, o), He[e] = !0, !0;
        return typeof t == "boolean" && ie(e, t, y) ? (t ? v('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', t, e, e, t, e) : v('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', t, e, e, t, e, e, e), He[e] = !0, !0) : k ? !0 : ie(e, t, y) ? (He[e] = !0, !1) : ((t === "false" || t === "true") && y !== null && y.type === kt && (v("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", t, e, t === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', e, t), He[e] = !0), !0);
      };
    }
    var Br = function(n, e, t) {
      {
        var r = [];
        for (var o in e) {
          var l = Mr(n, o, e[o], t);
          l || r.push(o);
        }
        var c = r.map(function(p) {
          return "`" + p + "`";
        }).join(", ");
        r.length === 1 ? v("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", c, n) : r.length > 1 && v("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", c, n);
      }
    };
    function wn(n, e, t) {
      cr(n, e) || Br(n, e, t);
    }
    var Lt = function() {
    };
    {
      var Zt = /^(?:webkit|moz|o)[A-Z]/, Xr = /^-ms-/, un = /-(.)/g, it = /;\s*$/, Bt = {}, Jt = {}, ge = !1, It = !1, Qt = function(n) {
        return n.replace(un, function(e, t) {
          return t.toUpperCase();
        });
      }, Er = function(n) {
        Bt.hasOwnProperty(n) && Bt[n] || (Bt[n] = !0, v(
          "Unsupported style property %s. Did you mean %s?",
          n,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Qt(n.replace(Xr, "ms-"))
        ));
      }, Ut = function(n) {
        Bt.hasOwnProperty(n) && Bt[n] || (Bt[n] = !0, v("Unsupported vendor-prefixed style property %s. Did you mean %s?", n, n.charAt(0).toUpperCase() + n.slice(1)));
      }, Ur = function(n, e) {
        Jt.hasOwnProperty(e) && Jt[e] || (Jt[e] = !0, v(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, n, e.replace(it, "")));
      }, Kt = function(n, e) {
        ge || (ge = !0, v("`NaN` is an invalid value for the `%s` css style property.", n));
      }, Ge = function(n, e) {
        It || (It = !0, v("`Infinity` is an invalid value for the `%s` css style property.", n));
      };
      Lt = function(n, e) {
        n.indexOf("-") > -1 ? Er(n) : Zt.test(n) ? Ut(n) : it.test(e) && Ur(n, e), typeof e == "number" && (isNaN(e) ? Kt(n, e) : isFinite(e) || Ge(n, e));
      };
    }
    var qt = Lt, Tr = /["'&<>]/;
    function Zr(n) {
      Je(n);
      var e = "" + n, t = Tr.exec(e);
      if (!t)
        return e;
      var r, o = "", l, c = 0;
      for (l = t.index; l < e.length; l++) {
        switch (e.charCodeAt(l)) {
          case 34:
            r = "&quot;";
            break;
          case 38:
            r = "&amp;";
            break;
          case 39:
            r = "&#x27;";
            break;
          case 60:
            r = "&lt;";
            break;
          case 62:
            r = "&gt;";
            break;
          default:
            continue;
        }
        c !== l && (o += e.substring(c, l)), c = l + 1, o += r;
      }
      return c !== l ? o + e.substring(c, l) : o;
    }
    function ze(n) {
      return typeof n == "boolean" || typeof n == "number" ? "" + n : Zr(n);
    }
    var Jr = /([A-Z])/g, kn = /^ms-/;
    function xn(n) {
      return n.replace(Jr, "-$1").toLowerCase().replace(kn, "-ms-");
    }
    var Pt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, jr = !1;
    function Hr(n) {
      !jr && Pt.test(n) && (jr = !0, v("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(n)));
    }
    var Oe = Array.isArray;
    function gt(n) {
      return Oe(n);
    }
    var jt = M("<script>"), zr = M("<\/script>"), pr = M('<script src="'), hr = M('<script type="module" src="'), Ht = M('" async=""><\/script>');
    function vr(n) {
      return Je(n), ("" + n).replace(mt, cn);
    }
    var mt = /(<\/|<)(s)(cript)/gi, cn = function(n, e, t, r) {
      return "" + e + (t === "s" ? "\\u0073" : "\\u0053") + r;
    };
    function fn(n, e, t, r, o) {
      var l = n === void 0 ? "" : n, c = e === void 0 ? jt : M('<script nonce="' + ze(e) + '">'), p = [];
      if (t !== void 0 && p.push(c, z(vr(t)), zr), r !== void 0)
        for (var y = 0; y < r.length; y++)
          p.push(pr, z(ze(r[y])), Ht);
      if (o !== void 0)
        for (var k = 0; k < o.length; k++)
          p.push(hr, z(ze(o[k])), Ht);
      return {
        bootstrapChunks: p,
        startInlineScript: c,
        placeholderPrefix: M(l + "P:"),
        segmentPrefix: M(l + "S:"),
        boundaryPrefix: l + "B:",
        idPrefix: l,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
      };
    }
    var er = 0, We = 1, zt = 2, Wt = 3, gr = 4, $t = 5, Et = 6, Ft = 7;
    function lt(n, e) {
      return {
        insertionMode: n,
        selectedValue: e
      };
    }
    function tr(n) {
      var e = n === "http://www.w3.org/2000/svg" ? zt : n === "http://www.w3.org/1998/Math/MathML" ? Wt : er;
      return lt(e, null);
    }
    function mr(n, e, t) {
      switch (e) {
        case "select":
          return lt(We, t.value != null ? t.value : t.defaultValue);
        case "svg":
          return lt(zt, null);
        case "math":
          return lt(Wt, null);
        case "foreignObject":
          return lt(We, null);
        case "table":
          return lt(gr, null);
        case "thead":
        case "tbody":
        case "tfoot":
          return lt($t, null);
        case "colgroup":
          return lt(Ft, null);
        case "tr":
          return lt(Et, null);
      }
      return n.insertionMode >= gr || n.insertionMode === er ? lt(We, null) : n;
    }
    var Rr = null;
    function yt(n) {
      var e = n.nextSuspenseID++;
      return M(n.boundaryPrefix + e.toString(16));
    }
    function At(n, e, t) {
      var r = n.idPrefix, o = ":" + r + "R" + e;
      return t > 0 && (o += "H" + t.toString(32)), o + ":";
    }
    function dt(n) {
      return ze(n);
    }
    var Wr = M("<!-- -->");
    function Ne(n, e, t, r) {
      return e === "" ? r : (r && n.push(Wr), n.push(z(dt(e))), !0);
    }
    function st(n, e, t, r) {
      t && r && n.push(Wr);
    }
    var a = /* @__PURE__ */ new Map();
    function s(n) {
      var e = a.get(n);
      if (e !== void 0)
        return e;
      var t = M(ze(xn(n)));
      return a.set(n, t), t;
    }
    var h = M(' style="'), m = M(":"), C = M(";");
    function w(n, e, t) {
      if (typeof t != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      var r = !0;
      for (var o in t)
        if (Ce.call(t, o)) {
          var l = t[o];
          if (!(l == null || typeof l == "boolean" || l === "")) {
            var c = void 0, p = void 0, y = o.indexOf("--") === 0;
            y ? (c = z(ze(o)), de(l, o), p = z(ze(("" + l).trim()))) : (qt(o, l), c = s(o), typeof l == "number" ? l !== 0 && !Ce.call(ot, o) ? p = z(l + "px") : p = z("" + l) : (de(l, o), p = z(ze(("" + l).trim())))), r ? (r = !1, n.push(h, c, m, p)) : n.push(C, c, m, p);
          }
        }
      r || n.push(N);
    }
    var I = M(" "), U = M('="'), N = M('"'), Z = M('=""');
    function V(n, e, t, r) {
      switch (t) {
        case "style": {
          w(n, e, r);
          return;
        }
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
          return;
      }
      if (
        // shouldIgnoreAttribute
        // We have already filtered out null/undefined and reserved words.
        !(t.length > 2 && (t[0] === "o" || t[0] === "O") && (t[1] === "n" || t[1] === "N"))
      ) {
        var o = oe(t);
        if (o !== null) {
          switch (typeof r) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              if (!o.acceptsBooleans)
                return;
          }
          var l = o.attributeName, c = z(l);
          switch (o.type) {
            case kt:
              r && n.push(I, c, Z);
              return;
            case rt:
              r === !0 ? n.push(I, c, Z) : r === !1 || n.push(I, c, U, z(ze(r)), N);
              return;
            case nt:
              isNaN(r) || n.push(I, c, U, z(ze(r)), N);
              break;
            case xt:
              !isNaN(r) && r >= 1 && n.push(I, c, U, z(ze(r)), N);
              break;
            default:
              o.sanitizeURL && (he(r, l), r = "" + r, Hr(r)), n.push(I, c, U, z(ze(r)), N);
          }
        } else if (O(t)) {
          switch (typeof r) {
            case "function":
            case "symbol":
              return;
            case "boolean": {
              var p = t.toLowerCase().slice(0, 5);
              if (p !== "data-" && p !== "aria-")
                return;
            }
          }
          n.push(I, z(t), U, z(ze(r)), N);
        }
      }
    }
    var me = M(">"), Ve = M("/>");
    function qe(n, e, t) {
      if (e != null) {
        if (t != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof e != "object" || !("__html" in e))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var r = e.__html;
        r != null && (Je(r), n.push(z("" + r)));
      }
    }
    var ut = !1, yr = !1, Nt = !1, _r = !1, Sr = !1, br = !1, Vt = !1;
    function wr(n, e) {
      {
        var t = n[e];
        if (t != null) {
          var r = gt(t);
          n.multiple && !r ? v("The `%s` prop supplied to <select> must be an array if `multiple` is true.", e) : !n.multiple && r && v("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", e);
        }
      }
    }
    function oo(n, e, t) {
      Dr("select", e), wr(e, "value"), wr(e, "defaultValue"), e.value !== void 0 && e.defaultValue !== void 0 && !Nt && (v("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Nt = !0), n.push(St("select"));
      var r = null, o = null;
      for (var l in e)
        if (Ce.call(e, l)) {
          var c = e[l];
          if (c == null)
            continue;
          switch (l) {
            case "children":
              r = c;
              break;
            case "dangerouslySetInnerHTML":
              o = c;
              break;
            case "defaultValue":
            case "value":
              break;
            default:
              V(n, t, l, c);
              break;
          }
        }
      return n.push(me), qe(n, o, r), r;
    }
    function Un(n) {
      var e = "";
      return X.Children.forEach(n, function(t) {
        t != null && (e += t, !Sr && typeof t != "string" && typeof t != "number" && (Sr = !0, v("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }), e;
    }
    var Qr = M(' selected=""');
    function Yt(n, e, t, r) {
      var o = r.selectedValue;
      n.push(St("option"));
      var l = null, c = null, p = null, y = null;
      for (var k in e)
        if (Ce.call(e, k)) {
          var D = e[k];
          if (D == null)
            continue;
          switch (k) {
            case "children":
              l = D;
              break;
            case "selected":
              p = D, Vt || (v("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Vt = !0);
              break;
            case "dangerouslySetInnerHTML":
              y = D;
              break;
            case "value":
              c = D;
            default:
              V(n, t, k, D);
              break;
          }
        }
      if (o != null) {
        var L;
        if (c !== null ? (he(c, "value"), L = "" + c) : (y !== null && (br || (br = !0, v("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."))), L = Un(l)), gt(o))
          for (var W = 0; W < o.length; W++) {
            he(o[W], "value");
            var te = "" + o[W];
            if (te === L) {
              n.push(Qr);
              break;
            }
          }
        else
          he(o, "select.value"), "" + o === L && n.push(Qr);
      } else p && n.push(Qr);
      return n.push(me), qe(n, y, l), l;
    }
    function ao(n, e, t) {
      Dr("input", e), e.checked !== void 0 && e.defaultChecked !== void 0 && !yr && (v("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", e.type), yr = !0), e.value !== void 0 && e.defaultValue !== void 0 && !ut && (v("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", e.type), ut = !0), n.push(St("input"));
      var r = null, o = null, l = null, c = null;
      for (var p in e)
        if (Ce.call(e, p)) {
          var y = e[p];
          if (y == null)
            continue;
          switch (p) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            case "defaultChecked":
              c = y;
              break;
            case "defaultValue":
              o = y;
              break;
            case "checked":
              l = y;
              break;
            case "value":
              r = y;
              break;
            default:
              V(n, t, p, y);
              break;
          }
        }
      return l !== null ? V(n, t, "checked", l) : c !== null && V(n, t, "checked", c), r !== null ? V(n, t, "value", r) : o !== null && V(n, t, "value", o), n.push(Ve), null;
    }
    function rr(n, e, t) {
      Dr("textarea", e), e.value !== void 0 && e.defaultValue !== void 0 && !_r && (v("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), _r = !0), n.push(St("textarea"));
      var r = null, o = null, l = null;
      for (var c in e)
        if (Ce.call(e, c)) {
          var p = e[c];
          if (p == null)
            continue;
          switch (c) {
            case "children":
              l = p;
              break;
            case "value":
              r = p;
              break;
            case "defaultValue":
              o = p;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            default:
              V(n, t, c, p);
              break;
          }
        }
      if (r === null && o !== null && (r = o), n.push(me), l != null) {
        if (v("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), r != null)
          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
        if (gt(l)) {
          if (l.length > 1)
            throw new Error("<textarea> can only have at most one child.");
          Je(l[0]), r = "" + l[0];
        }
        Je(l), r = "" + l;
      }
      return typeof r == "string" && r[0] === `
` && n.push(kr), r !== null && (he(r, "value"), n.push(z(dt("" + r)))), null;
    }
    function dn(n, e, t, r) {
      n.push(St(t));
      for (var o in e)
        if (Ce.call(e, o)) {
          var l = e[o];
          if (l == null)
            continue;
          switch (o) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error(t + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
            default:
              V(n, r, o, l);
              break;
          }
        }
      return n.push(Ve), null;
    }
    function Ir(n, e, t) {
      n.push(St("menuitem"));
      for (var r in e)
        if (Ce.call(e, r)) {
          var o = e[r];
          if (o == null)
            continue;
          switch (r) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
            default:
              V(n, t, r, o);
              break;
          }
        }
      return n.push(me), null;
    }
    function Re(n, e, t) {
      n.push(St("title"));
      var r = null;
      for (var o in e)
        if (Ce.call(e, o)) {
          var l = e[o];
          if (l == null)
            continue;
          switch (o) {
            case "children":
              r = l;
              break;
            case "dangerouslySetInnerHTML":
              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
            default:
              V(n, t, o, l);
              break;
          }
        }
      n.push(me);
      {
        var c = Array.isArray(r) && r.length < 2 ? r[0] || null : r;
        Array.isArray(r) && r.length > 1 ? v("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : c != null && c.$$typeof != null ? v("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering") : c != null && typeof c != "string" && typeof c != "number" && v("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
      }
      return r;
    }
    function Tt(n, e, t, r) {
      n.push(St(t));
      var o = null, l = null;
      for (var c in e)
        if (Ce.call(e, c)) {
          var p = e[c];
          if (p == null)
            continue;
          switch (c) {
            case "children":
              o = p;
              break;
            case "dangerouslySetInnerHTML":
              l = p;
              break;
            default:
              V(n, r, c, p);
              break;
          }
        }
      return n.push(me), qe(n, l, o), typeof o == "string" ? (n.push(z(dt(o))), null) : o;
    }
    function Kr(n, e, t, r) {
      n.push(St(t));
      var o = null, l = null;
      for (var c in e)
        if (Ce.call(e, c)) {
          var p = e[c];
          if (p == null)
            continue;
          switch (c) {
            case "children":
              o = p;
              break;
            case "dangerouslySetInnerHTML":
              l = p;
              break;
            case "style":
              w(n, r, p);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
              break;
            default:
              O(c) && typeof p != "function" && typeof p != "symbol" && n.push(I, z(c), U, z(ze(p)), N);
              break;
          }
        }
      return n.push(me), qe(n, l, o), o;
    }
    var kr = M(`
`);
    function Dt(n, e, t, r) {
      n.push(St(t));
      var o = null, l = null;
      for (var c in e)
        if (Ce.call(e, c)) {
          var p = e[c];
          if (p == null)
            continue;
          switch (c) {
            case "children":
              o = p;
              break;
            case "dangerouslySetInnerHTML":
              l = p;
              break;
            default:
              V(n, r, c, p);
              break;
          }
        }
      if (n.push(me), l != null) {
        if (o != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof l != "object" || !("__html" in l))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        var y = l.__html;
        y != null && (typeof y == "string" && y.length > 0 && y[0] === `
` ? n.push(kr, z(y)) : (Je(y), n.push(z("" + y))));
      }
      return typeof o == "string" && o[0] === `
` && n.push(kr), o;
    }
    var $r = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Gt = /* @__PURE__ */ new Map();
    function St(n) {
      var e = Gt.get(n);
      if (e === void 0) {
        if (!$r.test(n))
          throw new Error("Invalid tag: " + n);
        e = M("<" + n), Gt.set(n, e);
      }
      return e;
    }
    var Cn = M("<!DOCTYPE html>");
    function qr(n, e, t, r, o) {
      switch (Ze(e, t), Cr(e, t), wn(e, t, null), !t.suppressContentEditableWarning && t.contentEditable && t.children != null && v("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), o.insertionMode !== zt && o.insertionMode !== Wt && e.indexOf("-") === -1 && typeof t.is != "string" && e.toLowerCase() !== e && v("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e) {
        case "select":
          return oo(n, t, r);
        case "option":
          return Yt(n, t, r, o);
        case "textarea":
          return rr(n, t, r);
        case "input":
          return ao(n, t, r);
        case "menuitem":
          return Ir(n, t, r);
        case "title":
          return Re(n, t, r);
        case "listing":
        case "pre":
          return Dt(n, t, e, r);
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          return dn(n, t, e, r);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return Tt(n, t, e, r);
        case "html":
          return o.insertionMode === er && n.push(Cn), Tt(n, t, e, r);
        default:
          return e.indexOf("-") === -1 && typeof t.is != "string" ? Tt(n, t, e, r) : Kr(n, t, e, r);
      }
    }
    var jn = M("</"), pn = M(">");
    function f(n, e, t) {
      switch (e) {
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "input":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
          break;
        default:
          n.push(jn, z(e), pn);
      }
    }
    function S(n, e) {
      for (var t = e.bootstrapChunks, r = 0; r < t.length - 1; r++)
        B(n, t[r]);
      return r < t.length ? pe(n, t[r]) : !0;
    }
    var T = M('<template id="'), P = M('"></template>');
    function H(n, e, t) {
      B(n, T), B(n, e.placeholderPrefix);
      var r = z(t.toString(16));
      return B(n, r), pe(n, P);
    }
    var Y = M("<!--$-->"), $ = M('<!--$?--><template id="'), ee = M('"></template>'), le = M("<!--$!-->"), be = M("<!--/$-->"), _e = M("<template"), we = M('"'), Te = M(' data-dgst="'), Ae = M(' data-msg="'), Xe = M(' data-stck="'), en = M("></template>");
    function hn(n, e) {
      return pe(n, Y);
    }
    function tn(n, e, t) {
      if (B(n, $), t === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return B(n, t), pe(n, ee);
    }
    function bt(n, e, t, r, o) {
      var l;
      return l = pe(n, le), B(n, _e), t && (B(n, Te), B(n, z(ze(t))), B(n, we)), r && (B(n, Ae), B(n, z(ze(r))), B(n, we)), o && (B(n, Xe), B(n, z(ze(o))), B(n, we)), l = pe(n, en), l;
    }
    function En(n, e) {
      return pe(n, be);
    }
    function vn(n, e) {
      return pe(n, be);
    }
    function Hn(n, e) {
      return pe(n, be);
    }
    var zn = M('<div hidden id="'), Wn = M('">'), Uo = M("</div>"), jo = M('<svg aria-hidden="true" style="display:none" id="'), $n = M('">'), Nn = M("</svg>"), Ho = M('<math aria-hidden="true" style="display:none" id="'), zo = M('">'), Wo = M("</math>"), io = M('<table hidden id="'), $o = M('">'), i = M("</table>"), u = M('<table hidden><tbody id="'), d = M('">'), g = M("</tbody></table>"), E = M('<table hidden><tr id="'), x = M('">'), A = M("</tr></table>"), j = M('<table hidden><colgroup id="'), K = M('">'), fe = M("</colgroup></table>");
    function se(n, e, t, r) {
      switch (t.insertionMode) {
        case er:
        case We:
          return B(n, zn), B(n, e.segmentPrefix), B(n, z(r.toString(16))), pe(n, Wn);
        case zt:
          return B(n, jo), B(n, e.segmentPrefix), B(n, z(r.toString(16))), pe(n, $n);
        case Wt:
          return B(n, Ho), B(n, e.segmentPrefix), B(n, z(r.toString(16))), pe(n, zo);
        case gr:
          return B(n, io), B(n, e.segmentPrefix), B(n, z(r.toString(16))), pe(n, $o);
        case $t:
          return B(n, u), B(n, e.segmentPrefix), B(n, z(r.toString(16))), pe(n, d);
        case Et:
          return B(n, E), B(n, e.segmentPrefix), B(n, z(r.toString(16))), pe(n, x);
        case Ft:
          return B(n, j), B(n, e.segmentPrefix), B(n, z(r.toString(16))), pe(n, K);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    function De(n, e) {
      switch (e.insertionMode) {
        case er:
        case We:
          return pe(n, Uo);
        case zt:
          return pe(n, Nn);
        case Wt:
          return pe(n, Wo);
        case gr:
          return pe(n, i);
        case $t:
          return pe(n, g);
        case Et:
          return pe(n, A);
        case Ft:
          return pe(n, fe);
        default:
          throw new Error("Unknown insertion mode. This is a bug in React.");
      }
    }
    var Ot = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}", nr = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}', or = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}', Vn = M(Ot + ';$RS("'), No = M('$RS("'), Tn = M('","'), nl = M('")<\/script>');
    function ol(n, e, t) {
      B(n, e.startInlineScript), e.sentCompleteSegmentFunction ? B(n, No) : (e.sentCompleteSegmentFunction = !0, B(n, Vn)), B(n, e.segmentPrefix);
      var r = z(t.toString(16));
      return B(n, r), B(n, Tn), B(n, e.placeholderPrefix), B(n, r), pe(n, nl);
    }
    var _a = M(nr + ';$RC("'), al = M('$RC("'), il = M('","'), hi = M('")<\/script>');
    function vi(n, e, t, r) {
      if (B(n, e.startInlineScript), e.sentCompleteBoundaryFunction ? B(n, al) : (e.sentCompleteBoundaryFunction = !0, B(n, _a)), t === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      var o = z(r.toString(16));
      return B(n, t), B(n, il), B(n, e.segmentPrefix), B(n, o), pe(n, hi);
    }
    var ll = M(or + ';$RX("'), sl = M('$RX("'), ul = M('"'), cl = M(")<\/script>"), Xt = M(",");
    function fl(n, e, t, r, o, l) {
      if (B(n, e.startInlineScript), e.sentClientRenderFunction ? B(n, sl) : (e.sentClientRenderFunction = !0, B(n, ll)), t === null)
        throw new Error("An ID must have been assigned before we can complete the boundary.");
      return B(n, t), B(n, ul), (r || o || l) && (B(n, Xt), B(n, z(Vo(r || "")))), (o || l) && (B(n, Xt), B(n, z(Vo(o || "")))), l && (B(n, Xt), B(n, z(Vo(l)))), pe(n, cl);
    }
    var gi = /[<\u2028\u2029]/g;
    function Vo(n) {
      var e = JSON.stringify(n);
      return e.replace(gi, function(t) {
        switch (t) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
      });
    }
    var ar = Object.assign, mi = Symbol.for("react.element"), Yo = Symbol.for("react.portal"), Go = Symbol.for("react.fragment"), Xo = Symbol.for("react.strict_mode"), Zo = Symbol.for("react.profiler"), lo = Symbol.for("react.provider"), so = Symbol.for("react.context"), Yn = Symbol.for("react.forward_ref"), Ia = Symbol.for("react.suspense"), Pa = Symbol.for("react.suspense_list"), Fa = Symbol.for("react.memo"), Jo = Symbol.for("react.lazy"), yi = Symbol.for("react.scope"), dl = Symbol.for("react.debug_trace_mode"), pl = Symbol.for("react.legacy_hidden"), hl = Symbol.for("react.default_value"), Aa = Symbol.iterator, $e = "@@iterator";
    function uo(n) {
      if (n === null || typeof n != "object")
        return null;
      var e = Aa && n[Aa] || n[$e];
      return typeof e == "function" ? e : null;
    }
    function Si(n, e, t) {
      var r = n.displayName;
      if (r)
        return r;
      var o = e.displayName || e.name || "";
      return o !== "" ? t + "(" + o + ")" : t;
    }
    function Da(n) {
      return n.displayName || "Context";
    }
    function Be(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case Go:
          return "Fragment";
        case Yo:
          return "Portal";
        case Zo:
          return "Profiler";
        case Xo:
          return "StrictMode";
        case Ia:
          return "Suspense";
        case Pa:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case so:
            var e = n;
            return Da(e) + ".Consumer";
          case lo:
            var t = n;
            return Da(t._context) + ".Provider";
          case Yn:
            return Si(n, n.render, "ForwardRef");
          case Fa:
            var r = n.displayName || null;
            return r !== null ? r : Be(n.type) || "Memo";
          case Jo: {
            var o = n, l = o._payload, c = o._init;
            try {
              return Be(c(l));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Gn = 0, Oa, Ma, La, Ba, bi, wi, Qo;
    function Ko() {
    }
    Ko.__reactDisabledLog = !0;
    function co() {
      {
        if (Gn === 0) {
          Oa = console.log, Ma = console.info, La = console.warn, Ba = console.error, bi = console.group, wi = console.groupCollapsed, Qo = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: Ko,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        Gn++;
      }
    }
    function Ua() {
      {
        if (Gn--, Gn === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ar({}, n, {
              value: Oa
            }),
            info: ar({}, n, {
              value: Ma
            }),
            warn: ar({}, n, {
              value: La
            }),
            error: ar({}, n, {
              value: Ba
            }),
            group: ar({}, n, {
              value: bi
            }),
            groupCollapsed: ar({}, n, {
              value: wi
            }),
            groupEnd: ar({}, n, {
              value: Qo
            })
          });
        }
        Gn < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Xn = Q.ReactCurrentDispatcher, ja;
    function Rn(n, e, t) {
      {
        if (ja === void 0)
          try {
            throw Error();
          } catch (o) {
            var r = o.stack.trim().match(/\n( *(at )?)/);
            ja = r && r[1] || "";
          }
        return `
` + ja + n;
      }
    }
    var Ha = !1, fo;
    {
      var vl = typeof WeakMap == "function" ? WeakMap : Map;
      fo = new vl();
    }
    function po(n, e) {
      if (!n || Ha)
        return "";
      {
        var t = fo.get(n);
        if (t !== void 0)
          return t;
      }
      var r;
      Ha = !0;
      var o = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var l;
      l = Xn.current, Xn.current = null, co();
      try {
        if (e) {
          var c = function() {
            throw Error();
          };
          if (Object.defineProperty(c.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(c, []);
            } catch (Ee) {
              r = Ee;
            }
            Reflect.construct(n, [], c);
          } else {
            try {
              c.call();
            } catch (Ee) {
              r = Ee;
            }
            n.call(c.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ee) {
            r = Ee;
          }
          n();
        }
      } catch (Ee) {
        if (Ee && r && typeof Ee.stack == "string") {
          for (var p = Ee.stack.split(`
`), y = r.stack.split(`
`), k = p.length - 1, D = y.length - 1; k >= 1 && D >= 0 && p[k] !== y[D]; )
            D--;
          for (; k >= 1 && D >= 0; k--, D--)
            if (p[k] !== y[D]) {
              if (k !== 1 || D !== 1)
                do
                  if (k--, D--, D < 0 || p[k] !== y[D]) {
                    var L = `
` + p[k].replace(" at new ", " at ");
                    return n.displayName && L.includes("<anonymous>") && (L = L.replace("<anonymous>", n.displayName)), typeof n == "function" && fo.set(n, L), L;
                  }
                while (k >= 1 && D >= 0);
              break;
            }
        }
      } finally {
        Ha = !1, Xn.current = l, Ua(), Error.prepareStackTrace = o;
      }
      var W = n ? n.displayName || n.name : "", te = W ? Rn(W) : "";
      return typeof n == "function" && fo.set(n, te), te;
    }
    function ki(n, e, t) {
      return po(n, !0);
    }
    function za(n, e, t) {
      return po(n, !1);
    }
    function qo(n) {
      var e = n.prototype;
      return !!(e && e.isReactComponent);
    }
    function ea(n, e, t) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return po(n, qo(n));
      if (typeof n == "string")
        return Rn(n);
      switch (n) {
        case Ia:
          return Rn("Suspense");
        case Pa:
          return Rn("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case Yn:
            return za(n.render);
          case Fa:
            return ea(n.type, e, t);
          case Jo: {
            var r = n, o = r._payload, l = r._init;
            try {
              return ea(l(o), e, t);
            } catch {
            }
          }
        }
      return "";
    }
    var ta = {}, ho = Q.ReactDebugCurrentFrame;
    function vo(n) {
      if (n) {
        var e = n._owner, t = ea(n.type, n._source, e ? e.type : null);
        ho.setExtraStackFrame(t);
      } else
        ho.setExtraStackFrame(null);
    }
    function xi(n, e, t, r, o) {
      {
        var l = Function.call.bind(Ce);
        for (var c in n)
          if (l(n, c)) {
            var p = void 0;
            try {
              if (typeof n[c] != "function") {
                var y = Error((r || "React class") + ": " + t + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw y.name = "Invariant Violation", y;
              }
              p = n[c](e, c, r, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (k) {
              p = k;
            }
            p && !(p instanceof Error) && (vo(o), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", r || "React class", t, c, typeof p), vo(null)), p instanceof Error && !(p.message in ta) && (ta[p.message] = !0, vo(o), v("Failed %s type: %s", t, p.message), vo(null));
          }
      }
    }
    var _n;
    _n = {};
    var ra = {};
    Object.freeze(ra);
    function gn(n, e) {
      {
        var t = n.contextTypes;
        if (!t)
          return ra;
        var r = {};
        for (var o in t)
          r[o] = e[o];
        {
          var l = Be(n) || "Unknown";
          xi(t, r, "context", l);
        }
        return r;
      }
    }
    function Wa(n, e, t, r) {
      {
        if (typeof n.getChildContext != "function") {
          {
            var o = Be(e) || "Unknown";
            _n[o] || (_n[o] = !0, v("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", o, o));
          }
          return t;
        }
        var l = n.getChildContext();
        for (var c in l)
          if (!(c in r))
            throw new Error((Be(e) || "Unknown") + '.getChildContext(): key "' + c + '" is not defined in childContextTypes.');
        {
          var p = Be(e) || "Unknown";
          xi(r, l, "child context", p);
        }
        return ar({}, t, l);
      }
    }
    var In;
    In = {};
    var na = null, mn = null;
    function oa(n) {
      n.context._currentValue = n.parentValue;
    }
    function aa(n) {
      n.context._currentValue = n.value;
    }
    function go(n, e) {
      if (n !== e) {
        oa(n);
        var t = n.parent, r = e.parent;
        if (t === null) {
          if (r !== null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
        } else {
          if (r === null)
            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
          go(t, r);
        }
        aa(e);
      }
    }
    function mo(n) {
      oa(n);
      var e = n.parent;
      e !== null && mo(e);
    }
    function Ci(n) {
      var e = n.parent;
      e !== null && Ci(e), aa(n);
    }
    function Ei(n, e) {
      oa(n);
      var t = n.parent;
      if (t === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      t.depth === e.depth ? go(t, e) : Ei(t, e);
    }
    function Ti(n, e) {
      var t = e.parent;
      if (t === null)
        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
      n.depth === t.depth ? go(n, t) : Ti(n, t), aa(e);
    }
    function yn(n) {
      var e = mn, t = n;
      e !== t && (e === null ? Ci(t) : t === null ? mo(e) : e.depth === t.depth ? go(e, t) : e.depth > t.depth ? Ei(e, t) : Ti(e, t), mn = t);
    }
    function $a(n, e) {
      var t;
      t = n._currentValue, n._currentValue = e, n._currentRenderer !== void 0 && n._currentRenderer !== null && n._currentRenderer !== In && v("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), n._currentRenderer = In;
      var r = mn, o = {
        parent: r,
        depth: r === null ? 0 : r.depth + 1,
        context: n,
        parentValue: t,
        value: e
      };
      return mn = o, o;
    }
    function gl(n) {
      var e = mn;
      if (e === null)
        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
      e.context !== n && v("The parent context is not the expected context. This is probably a bug in React.");
      {
        var t = e.parentValue;
        t === hl ? e.context._currentValue = e.context._defaultValue : e.context._currentValue = t, n._currentRenderer !== void 0 && n._currentRenderer !== null && n._currentRenderer !== In && v("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), n._currentRenderer = In;
      }
      return mn = e.parent;
    }
    function Ri() {
      return mn;
    }
    function Zn(n) {
      var e = n._currentValue;
      return e;
    }
    function yo(n) {
      return n._reactInternals;
    }
    function Na(n, e) {
      n._reactInternals = e;
    }
    var ia = {}, la = {}, sa, Jn, So, bo, ua, wo, ca, fa, Va;
    {
      sa = /* @__PURE__ */ new Set(), Jn = /* @__PURE__ */ new Set(), So = /* @__PURE__ */ new Set(), ca = /* @__PURE__ */ new Set(), bo = /* @__PURE__ */ new Set(), fa = /* @__PURE__ */ new Set(), Va = /* @__PURE__ */ new Set();
      var _i = /* @__PURE__ */ new Set();
      wo = function(n, e) {
        if (!(n === null || typeof n == "function")) {
          var t = e + "_" + n;
          _i.has(t) || (_i.add(t), v("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", e, n));
        }
      }, ua = function(n, e) {
        if (e === void 0) {
          var t = Be(n) || "Component";
          bo.has(t) || (bo.add(t), v("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", t));
        }
      };
    }
    function Ii(n, e) {
      {
        var t = n.constructor, r = t && Be(t) || "ReactClass", o = r + "." + e;
        if (ia[o])
          return;
        v(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, e, e, r), ia[o] = !0;
      }
    }
    var Pi = {
      isMounted: function(n) {
        return !1;
      },
      enqueueSetState: function(n, e, t) {
        var r = yo(n);
        r.queue === null ? Ii(n, "setState") : (r.queue.push(e), t != null && wo(t, "setState"));
      },
      enqueueReplaceState: function(n, e, t) {
        var r = yo(n);
        r.replace = !0, r.queue = [e], t != null && wo(t, "setState");
      },
      enqueueForceUpdate: function(n, e) {
        var t = yo(n);
        t.queue === null ? Ii(n, "forceUpdate") : e != null && wo(e, "setState");
      }
    };
    function ml(n, e, t, r, o) {
      var l = t(o, r);
      ua(e, l);
      var c = l == null ? r : ar({}, r, l);
      return c;
    }
    function Fi(n, e, t) {
      var r = ra, o = n.contextType;
      if ("contextType" in n) {
        var l = (
          // Allow null for conditional declaration
          o === null || o !== void 0 && o.$$typeof === so && o._context === void 0
        );
        if (!l && !Va.has(n)) {
          Va.add(n);
          var c = "";
          o === void 0 ? c = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof o != "object" ? c = " However, it is set to a " + typeof o + "." : o.$$typeof === lo ? c = " Did you accidentally pass the Context.Provider instead?" : o._context !== void 0 ? c = " Did you accidentally pass the Context.Consumer instead?" : c = " However, it is set to an object with keys {" + Object.keys(o).join(", ") + "}.", v("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Be(n) || "Component", c);
        }
      }
      typeof o == "object" && o !== null ? r = Zn(o) : r = t;
      var p = new n(e, r);
      {
        if (typeof n.getDerivedStateFromProps == "function" && (p.state === null || p.state === void 0)) {
          var y = Be(n) || "Component";
          sa.has(y) || (sa.add(y), v("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", y, p.state === null ? "null" : "undefined", y));
        }
        if (typeof n.getDerivedStateFromProps == "function" || typeof p.getSnapshotBeforeUpdate == "function") {
          var k = null, D = null, L = null;
          if (typeof p.componentWillMount == "function" && p.componentWillMount.__suppressDeprecationWarning !== !0 ? k = "componentWillMount" : typeof p.UNSAFE_componentWillMount == "function" && (k = "UNSAFE_componentWillMount"), typeof p.componentWillReceiveProps == "function" && p.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? D = "componentWillReceiveProps" : typeof p.UNSAFE_componentWillReceiveProps == "function" && (D = "UNSAFE_componentWillReceiveProps"), typeof p.componentWillUpdate == "function" && p.componentWillUpdate.__suppressDeprecationWarning !== !0 ? L = "componentWillUpdate" : typeof p.UNSAFE_componentWillUpdate == "function" && (L = "UNSAFE_componentWillUpdate"), k !== null || D !== null || L !== null) {
            var W = Be(n) || "Component", te = typeof n.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            So.has(W) || (So.add(W), v(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, W, te, k !== null ? `
  ` + k : "", D !== null ? `
  ` + D : "", L !== null ? `
  ` + L : ""));
          }
        }
      }
      return p;
    }
    function yl(n, e, t) {
      {
        var r = Be(e) || "Component", o = n.render;
        o || (e.prototype && typeof e.prototype.render == "function" ? v("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", r) : v("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", r)), n.getInitialState && !n.getInitialState.isReactClassApproved && !n.state && v("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", r), n.getDefaultProps && !n.getDefaultProps.isReactClassApproved && v("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", r), n.propTypes && v("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", r), n.contextType && v("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", r), n.contextTypes && v("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", r), e.contextType && e.contextTypes && !fa.has(e) && (fa.add(e), v("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", r)), typeof n.componentShouldUpdate == "function" && v("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", r), e.prototype && e.prototype.isPureReactComponent && typeof n.shouldComponentUpdate < "u" && v("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Be(e) || "A pure component"), typeof n.componentDidUnmount == "function" && v("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", r), typeof n.componentDidReceiveProps == "function" && v("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", r), typeof n.componentWillRecieveProps == "function" && v("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", r), typeof n.UNSAFE_componentWillRecieveProps == "function" && v("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", r);
        var l = n.props !== t;
        n.props !== void 0 && l && v("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", r, r), n.defaultProps && v("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", r, r), typeof n.getSnapshotBeforeUpdate == "function" && typeof n.componentDidUpdate != "function" && !Jn.has(e) && (Jn.add(e), v("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Be(e))), typeof n.getDerivedStateFromProps == "function" && v("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", r), typeof n.getDerivedStateFromError == "function" && v("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", r), typeof e.getSnapshotBeforeUpdate == "function" && v("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", r);
        var c = n.state;
        c && (typeof c != "object" || gt(c)) && v("%s.state: must be set to an object or null", r), typeof n.getChildContext == "function" && typeof e.childContextTypes != "object" && v("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", r);
      }
    }
    function Sl(n, e) {
      var t = e.state;
      if (typeof e.componentWillMount == "function") {
        if (e.componentWillMount.__suppressDeprecationWarning !== !0) {
          var r = Be(n) || "Unknown";
          la[r] || (q(
            // keep this warning in sync with ReactStrictModeWarning.js
            `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
            r
          ), la[r] = !0);
        }
        e.componentWillMount();
      }
      typeof e.UNSAFE_componentWillMount == "function" && e.UNSAFE_componentWillMount(), t !== e.state && (v("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Be(n) || "Component"), Pi.enqueueReplaceState(e, e.state, null));
    }
    function Ya(n, e, t, r) {
      if (n.queue !== null && n.queue.length > 0) {
        var o = n.queue, l = n.replace;
        if (n.queue = null, n.replace = !1, l && o.length === 1)
          e.state = o[0];
        else {
          for (var c = l ? o[0] : e.state, p = !0, y = l ? 1 : 0; y < o.length; y++) {
            var k = o[y], D = typeof k == "function" ? k.call(e, c, t, r) : k;
            D != null && (p ? (p = !1, c = ar({}, c, D)) : ar(c, D));
          }
          e.state = c;
        }
      } else
        n.queue = null;
    }
    function ko(n, e, t, r) {
      yl(n, e, t);
      var o = n.state !== void 0 ? n.state : null;
      n.updater = Pi, n.props = t, n.state = o;
      var l = {
        queue: [],
        replace: !1
      };
      Na(n, l);
      var c = e.contextType;
      if (typeof c == "object" && c !== null ? n.context = Zn(c) : n.context = r, n.state === t) {
        var p = Be(e) || "Component";
        ca.has(p) || (ca.add(p), v("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", p));
      }
      var y = e.getDerivedStateFromProps;
      typeof y == "function" && (n.state = ml(n, e, y, o, t)), typeof e.getDerivedStateFromProps != "function" && typeof n.getSnapshotBeforeUpdate != "function" && (typeof n.UNSAFE_componentWillMount == "function" || typeof n.componentWillMount == "function") && (Sl(e, n), Ya(l, n, t, r));
    }
    var bl = {
      id: 1,
      overflow: ""
    };
    function wl(n) {
      var e = n.overflow, t = n.id, r = t & ~kl(t);
      return r.toString(32) + e;
    }
    function Ga(n, e, t) {
      var r = n.id, o = n.overflow, l = da(r) - 1, c = r & ~(1 << l), p = t + 1, y = da(e) + l;
      if (y > 30) {
        var k = l - l % 5, D = (1 << k) - 1, L = (c & D).toString(32), W = c >> k, te = l - k, Ee = da(e) + te, wt = p << te, Ln = wt | W, Bn = L + o;
        return {
          id: 1 << Ee | Ln,
          overflow: Bn
        };
      } else {
        var ln = p << l, no = ln | c, Kl = o;
        return {
          id: 1 << y | no,
          overflow: Kl
        };
      }
    }
    function da(n) {
      return 32 - xl(n);
    }
    function kl(n) {
      return 1 << da(n) - 1;
    }
    var xl = Math.clz32 ? Math.clz32 : Xa, Cl = Math.log, rn = Math.LN2;
    function Xa(n) {
      var e = n >>> 0;
      return e === 0 ? 32 : 31 - (Cl(e) / rn | 0) | 0;
    }
    function pa(n, e) {
      return n === e && (n !== 0 || 1 / n === 1 / e) || n !== n && e !== e;
    }
    var Me = typeof Object.is == "function" ? Object.is : pa, ir = null, Qn = null, Pn = null, ke = null, Sn = !1, ha = !1, lr = 0, sr = null, Nr = 0, El = 25, Pr = !1, bn;
    function Fn() {
      if (ir === null)
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return Pr && v("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), ir;
    }
    function Tl(n, e) {
      if (e === null)
        return v("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", bn), !1;
      n.length !== e.length && v(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, bn, "[" + n.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var t = 0; t < e.length && t < n.length; t++)
        if (!Me(n[t], e[t]))
          return !1;
      return !0;
    }
    function Za() {
      if (Nr > 0)
        throw new Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function xo() {
      return ke === null ? Pn === null ? (Sn = !1, Pn = ke = Za()) : (Sn = !0, ke = Pn) : ke.next === null ? (Sn = !1, ke = ke.next = Za()) : (Sn = !0, ke = ke.next), ke;
    }
    function Rl(n, e) {
      ir = e, Qn = n, Pr = !1, lr = 0;
    }
    function _l(n, e, t, r) {
      for (; ha; )
        ha = !1, lr = 0, Nr += 1, ke = null, t = n(e, r);
      return Ja(), t;
    }
    function va() {
      var n = lr !== 0;
      return n;
    }
    function Ja() {
      Pr = !1, ir = null, Qn = null, ha = !1, Pn = null, Nr = 0, sr = null, ke = null;
    }
    function Ai(n) {
      return Pr && v("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), Zn(n);
    }
    function Di(n) {
      return bn = "useContext", Fn(), Zn(n);
    }
    function Qa(n, e) {
      return typeof e == "function" ? e(n) : e;
    }
    function Il(n) {
      return bn = "useState", Oi(
        Qa,
        // useReducer has a special case to support lazy useState initializers
        n
      );
    }
    function Oi(n, e, t) {
      if (n !== Qa && (bn = "useReducer"), ir = Fn(), ke = xo(), Sn) {
        var r = ke.queue, o = r.dispatch;
        if (sr !== null) {
          var l = sr.get(r);
          if (l !== void 0) {
            sr.delete(r);
            var c = ke.memoizedState, p = l;
            do {
              var y = p.action;
              Pr = !0, c = n(c, y), Pr = !1, p = p.next;
            } while (p !== null);
            return ke.memoizedState = c, [c, o];
          }
        }
        return [ke.memoizedState, o];
      } else {
        Pr = !0;
        var k;
        n === Qa ? k = typeof e == "function" ? e() : e : k = t !== void 0 ? t(e) : e, Pr = !1, ke.memoizedState = k;
        var D = ke.queue = {
          last: null,
          dispatch: null
        }, L = D.dispatch = Al.bind(null, ir, D);
        return [ke.memoizedState, L];
      }
    }
    function Mi(n, e) {
      ir = Fn(), ke = xo();
      var t = e === void 0 ? null : e;
      if (ke !== null) {
        var r = ke.memoizedState;
        if (r !== null && t !== null) {
          var o = r[1];
          if (Tl(t, o))
            return r[0];
        }
      }
      Pr = !0;
      var l = n();
      return Pr = !1, ke.memoizedState = [l, t], l;
    }
    function Pl(n) {
      ir = Fn(), ke = xo();
      var e = ke.memoizedState;
      if (e === null) {
        var t = {
          current: n
        };
        return Object.seal(t), ke.memoizedState = t, t;
      } else
        return e;
    }
    function Fl(n, e) {
      bn = "useLayoutEffect", v("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Al(n, e, t) {
      if (Nr >= El)
        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (n === ir) {
        ha = !0;
        var r = {
          action: t,
          next: null
        };
        sr === null && (sr = /* @__PURE__ */ new Map());
        var o = sr.get(e);
        if (o === void 0)
          sr.set(e, r);
        else {
          for (var l = o; l.next !== null; )
            l = l.next;
          l.next = r;
        }
      }
    }
    function Dl(n, e) {
      return Mi(function() {
        return n;
      }, e);
    }
    function Ol(n, e, t) {
      return Fn(), e(n._source);
    }
    function Ml(n, e, t) {
      if (t === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      return t();
    }
    function ga(n) {
      return Fn(), n;
    }
    function Li() {
      throw new Error("startTransition cannot be called during server rendering.");
    }
    function Ka() {
      return Fn(), [!1, Li];
    }
    function Bi() {
      var n = Qn, e = wl(n.treeContext), t = Co;
      if (t === null)
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
      var r = lr++;
      return At(t, e, r);
    }
    function ma() {
    }
    var ya = {
      readContext: Ai,
      useContext: Di,
      useMemo: Mi,
      useReducer: Oi,
      useRef: Pl,
      useState: Il,
      useInsertionEffect: ma,
      useLayoutEffect: Fl,
      useCallback: Dl,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: ma,
      // Effects are not run in the server environment.
      useEffect: ma,
      // Debugging effect
      useDebugValue: ma,
      useDeferredValue: ga,
      useTransition: Ka,
      useId: Bi,
      // Subscriptions are not setup in a server environment.
      useMutableSource: Ol,
      useSyncExternalStore: Ml
    }, Co = null;
    function Sa(n) {
      Co = n;
    }
    function Kn(n) {
      try {
        var e = "", t = n;
        do {
          switch (t.tag) {
            case 0:
              e += Rn(t.type, null, null);
              break;
            case 1:
              e += za(t.type, null, null);
              break;
            case 2:
              e += ki(t.type, null, null);
              break;
          }
          t = t.parent;
        } while (t);
        return e;
      } catch (r) {
        return `
Error generating stack: ` + r.message + `
` + r.stack;
      }
    }
    var ba = Q.ReactCurrentDispatcher, wa = Q.ReactDebugCurrentFrame, ka = 0, qn = 1, qa = 2, An = 3, Ui = 4, Ll = 0, eo = 1, to = 2, Bl = 12800;
    function Ul(n) {
      return console.error(n), null;
    }
    function Dn() {
    }
    function xa(n, e, t, r, o, l, c, p, y) {
      var k = [], D = /* @__PURE__ */ new Set(), L = {
        destination: null,
        responseState: e,
        progressiveChunkSize: r === void 0 ? Bl : r,
        status: Ll,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: D,
        pingedTasks: k,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: o === void 0 ? Ul : o,
        onAllReady: l === void 0 ? Dn : l,
        onShellReady: c === void 0 ? Dn : c,
        onShellError: p === void 0 ? Dn : p,
        onFatalError: y === void 0 ? Dn : y
      }, W = Eo(
        L,
        0,
        null,
        t,
        // Root segments are never embedded in Text on either edge
        !1,
        !1
      );
      W.parentFlushed = !0;
      var te = On(L, n, null, W, D, ra, na, bl);
      return k.push(te), L;
    }
    function nn(n, e) {
      var t = n.pingedTasks;
      t.push(e), t.length === 1 && pt(function() {
        return ci(n);
      });
    }
    function ei(n, e) {
      return {
        id: Rr,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        forceClientRender: !1,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: e,
        errorDigest: null
      };
    }
    function On(n, e, t, r, o, l, c, p) {
      n.allPendingTasks++, t === null ? n.pendingRootTasks++ : t.pendingTasks++;
      var y = {
        node: e,
        ping: function() {
          return nn(n, y);
        },
        blockedBoundary: t,
        blockedSegment: r,
        abortSet: o,
        legacyContext: l,
        context: c,
        treeContext: p
      };
      return y.componentStack = null, o.add(y), y;
    }
    function Eo(n, e, t, r, o, l) {
      return {
        status: ka,
        id: -1,
        // lazily assigned later
        index: e,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: r,
        boundary: t,
        lastPushedText: o,
        textEmbedded: l
      };
    }
    var on = null;
    function Vr() {
      return on === null || on.componentStack === null ? "" : Kn(on.componentStack);
    }
    function an(n, e) {
      n.componentStack = {
        tag: 0,
        parent: n.componentStack,
        type: e
      };
    }
    function Ca(n, e) {
      n.componentStack = {
        tag: 1,
        parent: n.componentStack,
        type: e
      };
    }
    function To(n, e) {
      n.componentStack = {
        tag: 2,
        parent: n.componentStack,
        type: e
      };
    }
    function Fr(n) {
      n.componentStack === null ? v("Unexpectedly popped too many stack frames. This is a bug in React.") : n.componentStack = n.componentStack.parent;
    }
    var Ro = null;
    function ti(n, e) {
      {
        var t;
        typeof e == "string" ? t = e : e && typeof e.message == "string" ? t = e.message : t = String(e);
        var r = Ro || Vr();
        Ro = null, n.errorMessage = t, n.errorComponentStack = r;
      }
    }
    function _o(n, e) {
      var t = n.onError(e);
      if (t != null && typeof t != "string")
        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof t + '" instead');
      return t;
    }
    function Io(n, e) {
      var t = n.onShellError;
      t(e);
      var r = n.onFatalError;
      r(e), n.destination !== null ? (n.status = to, Ie(n.destination, e)) : (n.status = eo, n.fatalError = e);
    }
    function ji(n, e, t) {
      an(e, "Suspense");
      var r = e.blockedBoundary, o = e.blockedSegment, l = t.fallback, c = t.children, p = /* @__PURE__ */ new Set(), y = ei(n, p), k = o.chunks.length, D = Eo(
        n,
        k,
        y,
        o.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      o.children.push(D), o.lastPushedText = !1;
      var L = Eo(
        n,
        0,
        null,
        o.formatContext,
        // boundaries never require text embedding at their edges because comment nodes bound them
        !1,
        !1
      );
      L.parentFlushed = !0, e.blockedBoundary = y, e.blockedSegment = L;
      try {
        if (ro(n, e, c), st(L.chunks, n.responseState, L.lastPushedText, L.textEmbedded), L.status = qn, Mn(y, L), y.pendingTasks === 0) {
          Fr(e);
          return;
        }
      } catch (te) {
        L.status = Ui, y.forceClientRender = !0, y.errorDigest = _o(n, te), ti(y, te);
      } finally {
        e.blockedBoundary = r, e.blockedSegment = o;
      }
      var W = On(n, l, r, D, p, e.legacyContext, e.context, e.treeContext);
      W.componentStack = e.componentStack, n.pingedTasks.push(W), Fr(e);
    }
    function jl(n, e, t, r) {
      an(e, t);
      var o = e.blockedSegment, l = qr(o.chunks, t, r, n.responseState, o.formatContext);
      o.lastPushedText = !1;
      var c = o.formatContext;
      o.formatContext = mr(c, t, r), ro(n, e, l), o.formatContext = c, f(o.chunks, t), o.lastPushedText = !1, Fr(e);
    }
    function Hi(n) {
      return n.prototype && n.prototype.isReactComponent;
    }
    function Po(n, e, t, r, o) {
      var l = {};
      Rl(e, l);
      var c = t(r, o);
      return _l(t, r, c, o);
    }
    function ri(n, e, t, r, o) {
      var l = t.render();
      t.props !== o && (ii || v("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Be(r) || "a component"), ii = !0);
      {
        var c = r.childContextTypes;
        if (c != null) {
          var p = e.legacyContext, y = Wa(t, r, p, c);
          e.legacyContext = y, Mt(n, e, l), e.legacyContext = p;
          return;
        }
      }
      Mt(n, e, l);
    }
    function zi(n, e, t, r) {
      To(e, t);
      var o = gn(t, e.legacyContext), l = Fi(t, r, o);
      ko(l, t, r, o), ri(n, e, l, t, r), Fr(e);
    }
    var ni = {}, Fo = {}, oi = {}, ai = {}, ii = !1, Wi = {}, $i = !1, li = !1, Ni = !1;
    function Hl(n, e, t, r) {
      var o;
      if (o = gn(t, e.legacyContext), Ca(e, t), t.prototype && typeof t.prototype.render == "function") {
        var l = Be(t) || "Unknown";
        ni[l] || (v("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", l, l), ni[l] = !0);
      }
      var c = Po(n, e, t, r, o), p = va();
      if (typeof c == "object" && c !== null && typeof c.render == "function" && c.$$typeof === void 0) {
        var y = Be(t) || "Unknown";
        Fo[y] || (v("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", y, y, y), Fo[y] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof c == "object" && c !== null && typeof c.render == "function" && c.$$typeof === void 0
      ) {
        {
          var k = Be(t) || "Unknown";
          Fo[k] || (v("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", k, k, k), Fo[k] = !0);
        }
        ko(c, t, r, o), ri(n, e, c, t, r);
      } else if (zl(t), p) {
        var D = e.treeContext, L = 1, W = 0;
        e.treeContext = Ga(D, L, W);
        try {
          Mt(n, e, c);
        } finally {
          e.treeContext = D;
        }
      } else
        Mt(n, e, c);
      Fr(e);
    }
    function zl(n) {
      {
        if (n && n.childContextTypes && v("%s(...): childContextTypes cannot be defined on a function component.", n.displayName || n.name || "Component"), n.defaultProps !== void 0) {
          var e = Be(n) || "Unknown";
          Wi[e] || (v("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", e), Wi[e] = !0);
        }
        if (typeof n.getDerivedStateFromProps == "function") {
          var t = Be(n) || "Unknown";
          ai[t] || (v("%s: Function components do not support getDerivedStateFromProps.", t), ai[t] = !0);
        }
        if (typeof n.contextType == "object" && n.contextType !== null) {
          var r = Be(n) || "Unknown";
          oi[r] || (v("%s: Function components do not support contextType.", r), oi[r] = !0);
        }
      }
    }
    function Vi(n, e) {
      if (n && n.defaultProps) {
        var t = ar({}, e), r = n.defaultProps;
        for (var o in r)
          t[o] === void 0 && (t[o] = r[o]);
        return t;
      }
      return e;
    }
    function Wl(n, e, t, r, o) {
      Ca(e, t.render);
      var l = Po(n, e, t.render, r, o), c = va();
      if (c) {
        var p = e.treeContext, y = 1, k = 0;
        e.treeContext = Ga(p, y, k);
        try {
          Mt(n, e, l);
        } finally {
          e.treeContext = p;
        }
      } else
        Mt(n, e, l);
      Fr(e);
    }
    function si(n, e, t, r, o) {
      var l = t.type, c = Vi(l, r);
      Ea(n, e, l, c, o);
    }
    function $l(n, e, t, r) {
      t._context === void 0 ? t !== t.Consumer && (Ni || (Ni = !0, v("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : t = t._context;
      var o = r.children;
      typeof o != "function" && v("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
      var l = Zn(t), c = o(l);
      Mt(n, e, c);
    }
    function ur(n, e, t, r) {
      var o = t._context, l = r.value, c = r.children, p;
      p = e.context, e.context = $a(o, l), Mt(n, e, c), e.context = gl(o), p !== e.context && v("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
    }
    function Nl(n, e, t, r, o) {
      an(e, "Lazy");
      var l = t._payload, c = t._init, p = c(l), y = Vi(p, r);
      Ea(n, e, p, y, o), Fr(e);
    }
    function Ea(n, e, t, r, o) {
      if (typeof t == "function")
        if (Hi(t)) {
          zi(n, e, t, r);
          return;
        } else {
          Hl(n, e, t, r);
          return;
        }
      if (typeof t == "string") {
        jl(n, e, t, r);
        return;
      }
      switch (t) {
        case pl:
        case dl:
        case Xo:
        case Zo:
        case Go: {
          Mt(n, e, r.children);
          return;
        }
        case Pa: {
          an(e, "SuspenseList"), Mt(n, e, r.children), Fr(e);
          return;
        }
        case yi:
          throw new Error("ReactDOMServer does not yet support scope components.");
        case Ia: {
          ji(n, e, r);
          return;
        }
      }
      if (typeof t == "object" && t !== null)
        switch (t.$$typeof) {
          case Yn: {
            Wl(n, e, t, r, o);
            return;
          }
          case Fa: {
            si(n, e, t, r, o);
            return;
          }
          case lo: {
            ur(n, e, t, r);
            return;
          }
          case so: {
            $l(n, e, t, r);
            return;
          }
          case Jo: {
            Nl(n, e, t, r);
            return;
          }
        }
      var l = "";
      throw (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (l += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (t == null ? t : typeof t) + "." + l));
    }
    function Vl(n, e) {
      typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
      n[Symbol.toStringTag] === "Generator" && ($i || v("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), $i = !0), n.entries === e && (li || v("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), li = !0);
    }
    function Mt(n, e, t) {
      try {
        return Yl(n, e, t);
      } catch (r) {
        throw typeof r == "object" && r !== null && typeof r.then == "function" || (Ro = Ro !== null ? Ro : Vr()), r;
      }
    }
    function Yl(n, e, t) {
      if (e.node = t, typeof t == "object" && t !== null) {
        switch (t.$$typeof) {
          case mi: {
            var r = t, o = r.type, l = r.props, c = r.ref;
            Ea(n, e, o, l, c);
            return;
          }
          case Yo:
            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
          case Jo: {
            var p = t, y = p._payload, k = p._init, D;
            try {
              D = k(y);
            } catch (ln) {
              throw typeof ln == "object" && ln !== null && typeof ln.then == "function" && an(e, "Lazy"), ln;
            }
            Mt(n, e, D);
            return;
          }
        }
        if (gt(t)) {
          Yi(n, e, t);
          return;
        }
        var L = uo(t);
        if (L) {
          Vl(t, L);
          var W = L.call(t);
          if (W) {
            var te = W.next();
            if (!te.done) {
              var Ee = [];
              do
                Ee.push(te.value), te = W.next();
              while (!te.done);
              Yi(n, e, Ee);
              return;
            }
            return;
          }
        }
        var wt = Object.prototype.toString.call(t);
        throw new Error("Objects are not valid as a React child (found: " + (wt === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : wt) + "). If you meant to render a collection of children, use an array instead.");
      }
      if (typeof t == "string") {
        var Ln = e.blockedSegment;
        Ln.lastPushedText = Ne(e.blockedSegment.chunks, t, n.responseState, Ln.lastPushedText);
        return;
      }
      if (typeof t == "number") {
        var Bn = e.blockedSegment;
        Bn.lastPushedText = Ne(e.blockedSegment.chunks, "" + t, n.responseState, Bn.lastPushedText);
        return;
      }
      typeof t == "function" && v("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function Yi(n, e, t) {
      for (var r = t.length, o = 0; o < r; o++) {
        var l = e.treeContext;
        e.treeContext = Ga(l, r, o);
        try {
          ro(n, e, t[o]);
        } finally {
          e.treeContext = l;
        }
      }
    }
    function Gi(n, e, t) {
      var r = e.blockedSegment, o = r.chunks.length, l = Eo(
        n,
        o,
        null,
        r.formatContext,
        // Adopt the parent segment's leading text embed
        r.lastPushedText,
        // Assume we are text embedded at the trailing edge
        !0
      );
      r.children.push(l), r.lastPushedText = !1;
      var c = On(n, e.node, e.blockedBoundary, l, e.abortSet, e.legacyContext, e.context, e.treeContext);
      e.componentStack !== null && (c.componentStack = e.componentStack.parent);
      var p = c.ping;
      t.then(p, p);
    }
    function ro(n, e, t) {
      var r = e.blockedSegment.formatContext, o = e.legacyContext, l = e.context, c = null;
      c = e.componentStack;
      try {
        return Mt(n, e, t);
      } catch (p) {
        if (Ja(), typeof p == "object" && p !== null && typeof p.then == "function") {
          Gi(n, e, p), e.blockedSegment.formatContext = r, e.legacyContext = o, e.context = l, yn(l), e.componentStack = c;
          return;
        } else
          throw e.blockedSegment.formatContext = r, e.legacyContext = o, e.context = l, yn(l), e.componentStack = c, p;
      }
    }
    function Xi(n, e, t, r) {
      var o = _o(n, r);
      if (e === null ? Io(n, r) : (e.pendingTasks--, e.forceClientRender || (e.forceClientRender = !0, e.errorDigest = o, ti(e, r), e.parentFlushed && n.clientRenderedBoundaries.push(e))), n.allPendingTasks--, n.allPendingTasks === 0) {
        var l = n.onAllReady;
        l();
      }
    }
    function Gl(n) {
      var e = this, t = n.blockedBoundary, r = n.blockedSegment;
      r.status = An, Ao(e, t, r);
    }
    function ui(n, e, t) {
      var r = n.blockedBoundary, o = n.blockedSegment;
      if (o.status = An, r === null)
        e.allPendingTasks--, e.status !== to && (e.status = to, e.destination !== null && ae(e.destination));
      else {
        if (r.pendingTasks--, !r.forceClientRender) {
          r.forceClientRender = !0;
          var l = t === void 0 ? new Error("The render was aborted by the server without a reason.") : t;
          r.errorDigest = e.onError(l);
          {
            var c = "The server did not finish this Suspense boundary: ";
            l && typeof l.message == "string" ? l = c + l.message : l = c + String(l);
            var p = on;
            on = n;
            try {
              ti(r, l);
            } finally {
              on = p;
            }
          }
          r.parentFlushed && e.clientRenderedBoundaries.push(r);
        }
        if (r.fallbackAbortableTasks.forEach(function(k) {
          return ui(k, e, t);
        }), r.fallbackAbortableTasks.clear(), e.allPendingTasks--, e.allPendingTasks === 0) {
          var y = e.onAllReady;
          y();
        }
      }
    }
    function Mn(n, e) {
      if (e.chunks.length === 0 && e.children.length === 1 && e.children[0].boundary === null) {
        var t = e.children[0];
        t.id = e.id, t.parentFlushed = !0, t.status === qn && Mn(n, t);
      } else {
        var r = n.completedSegments;
        r.push(e);
      }
    }
    function Ao(n, e, t) {
      if (e === null) {
        if (t.parentFlushed) {
          if (n.completedRootSegment !== null)
            throw new Error("There can only be one root segment. This is a bug in React.");
          n.completedRootSegment = t;
        }
        if (n.pendingRootTasks--, n.pendingRootTasks === 0) {
          n.onShellError = Dn;
          var r = n.onShellReady;
          r();
        }
      } else if (e.pendingTasks--, !e.forceClientRender) {
        if (e.pendingTasks === 0)
          t.parentFlushed && t.status === qn && Mn(e, t), e.parentFlushed && n.completedBoundaries.push(e), e.fallbackAbortableTasks.forEach(Gl, n), e.fallbackAbortableTasks.clear();
        else if (t.parentFlushed && t.status === qn) {
          Mn(e, t);
          var o = e.completedSegments;
          o.length === 1 && e.parentFlushed && n.partialBoundaries.push(e);
        }
      }
      if (n.allPendingTasks--, n.allPendingTasks === 0) {
        var l = n.onAllReady;
        l();
      }
    }
    function Xl(n, e) {
      var t = e.blockedSegment;
      if (t.status === ka) {
        yn(e.context);
        var r = null;
        r = on, on = e;
        try {
          Mt(n, e, e.node), st(t.chunks, n.responseState, t.lastPushedText, t.textEmbedded), e.abortSet.delete(e), t.status = qn, Ao(n, e.blockedBoundary, t);
        } catch (l) {
          if (Ja(), typeof l == "object" && l !== null && typeof l.then == "function") {
            var o = e.ping;
            l.then(o, o);
          } else
            e.abortSet.delete(e), t.status = Ui, Xi(n, e.blockedBoundary, t, l);
        } finally {
          on = r;
        }
      }
    }
    function ci(n) {
      if (n.status !== to) {
        var e = Ri(), t = ba.current;
        ba.current = ya;
        var r;
        r = wa.getCurrentStack, wa.getCurrentStack = Vr;
        var o = Co;
        Sa(n.responseState);
        try {
          var l = n.pingedTasks, c;
          for (c = 0; c < l.length; c++) {
            var p = l[c];
            Xl(n, p);
          }
          l.splice(0, c), n.destination !== null && fi(n, n.destination);
        } catch (y) {
          _o(n, y), Io(n, y);
        } finally {
          Sa(o), ba.current = t, wa.getCurrentStack = r, t === ya && yn(e);
        }
      }
    }
    function Do(n, e, t) {
      switch (t.parentFlushed = !0, t.status) {
        case ka: {
          var r = t.id = n.nextSegmentId++;
          return t.lastPushedText = !1, t.textEmbedded = !1, H(e, n.responseState, r);
        }
        case qn: {
          t.status = qa;
          for (var o = !0, l = t.chunks, c = 0, p = t.children, y = 0; y < p.length; y++) {
            for (var k = p[y]; c < k.index; c++)
              B(e, l[c]);
            o = Ta(n, e, k);
          }
          for (; c < l.length - 1; c++)
            B(e, l[c]);
          return c < l.length && (o = pe(e, l[c])), o;
        }
        default:
          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
      }
    }
    function Ta(n, e, t) {
      var r = t.boundary;
      if (r === null)
        return Do(n, e, t);
      if (r.parentFlushed = !0, r.forceClientRender)
        return bt(e, n.responseState, r.errorDigest, r.errorMessage, r.errorComponentStack), Do(n, e, t), Hn(e, n.responseState);
      if (r.pendingTasks > 0) {
        r.rootSegmentID = n.nextSegmentId++, r.completedSegments.length > 0 && n.partialBoundaries.push(r);
        var o = r.id = yt(n.responseState);
        return tn(e, n.responseState, o), Do(n, e, t), vn(e, n.responseState);
      } else {
        if (r.byteSize > n.progressiveChunkSize)
          return r.rootSegmentID = n.nextSegmentId++, n.completedBoundaries.push(r), tn(e, n.responseState, r.id), Do(n, e, t), vn(e, n.responseState);
        hn(e, n.responseState);
        var l = r.completedSegments;
        if (l.length !== 1)
          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
        var c = l[0];
        return Ta(n, e, c), En(e, n.responseState);
      }
    }
    function Zi(n, e, t) {
      return fl(e, n.responseState, t.id, t.errorDigest, t.errorMessage, t.errorComponentStack);
    }
    function Ra(n, e, t) {
      return se(e, n.responseState, t.formatContext, t.id), Ta(n, e, t), De(e, t.formatContext);
    }
    function Ji(n, e, t) {
      for (var r = t.completedSegments, o = 0; o < r.length; o++) {
        var l = r[o];
        Qi(n, e, t, l);
      }
      return r.length = 0, vi(e, n.responseState, t.id, t.rootSegmentID);
    }
    function Zl(n, e, t) {
      for (var r = t.completedSegments, o = 0; o < r.length; o++) {
        var l = r[o];
        if (!Qi(n, e, t, l))
          return o++, r.splice(0, o), !1;
      }
      return r.splice(0, o), !0;
    }
    function Qi(n, e, t, r) {
      if (r.status === qa)
        return !0;
      var o = r.id;
      if (o === -1) {
        var l = r.id = t.rootSegmentID;
        if (l === -1)
          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
        return Ra(n, e, r);
      } else
        return Ra(n, e, r), ol(e, n.responseState, o);
    }
    function fi(n, e) {
      et();
      try {
        var t = n.completedRootSegment;
        t !== null && n.pendingRootTasks === 0 && (Ta(n, e, t), n.completedRootSegment = null, S(e, n.responseState));
        var r = n.clientRenderedBoundaries, o;
        for (o = 0; o < r.length; o++) {
          var l = r[o];
          Zi(n, e, l);
        }
        r.splice(0, o);
        var c = n.completedBoundaries;
        for (o = 0; o < c.length; o++) {
          var p = c[o];
          Ji(n, e, p);
        }
        c.splice(0, o), ct(e), et(e);
        var y = n.partialBoundaries;
        for (o = 0; o < y.length; o++) {
          var k = y[o];
          if (!Zl(n, e, k)) {
            n.destination = null, o++, y.splice(0, o);
            return;
          }
        }
        y.splice(0, o);
        var D = n.completedBoundaries;
        for (o = 0; o < D.length; o++) {
          var L = D[o];
          Ji(n, e, L);
        }
        D.splice(0, o);
      } finally {
        ct(e), n.allPendingTasks === 0 && n.pingedTasks.length === 0 && n.clientRenderedBoundaries.length === 0 && n.completedBoundaries.length === 0 && (n.abortableTasks.size !== 0 && v("There was still abortable task at the root when we closed. This is a bug in React."), ae(e));
      }
    }
    function Ki(n) {
      pt(function() {
        return ci(n);
      });
    }
    function Jl(n, e) {
      if (n.status === eo) {
        n.status = to, Ie(e, n.fatalError);
        return;
      }
      if (n.status !== to && n.destination === null) {
        n.destination = e;
        try {
          fi(n, e);
        } catch (t) {
          _o(n, t), Io(n, t);
        }
      }
    }
    function qi(n, e) {
      try {
        var t = n.abortableTasks;
        t.forEach(function(r) {
          return ui(r, n, e);
        }), t.clear(), n.destination !== null && fi(n, n.destination);
      } catch (r) {
        _o(n, r), Io(n, r);
      }
    }
    function Ql(n, e) {
      return new Promise(function(t, r) {
        var o, l, c = new Promise(function(W, te) {
          l = W, o = te;
        });
        function p() {
          var W = new ReadableStream(
            {
              type: "bytes",
              pull: function(te) {
                Jl(k, te);
              },
              cancel: function(te) {
                qi(k);
              }
            },
            // $FlowFixMe size() methods are not allowed on byte streams.
            {
              highWaterMark: 0
            }
          );
          W.allReady = c, t(W);
        }
        function y(W) {
          c.catch(function() {
          }), r(W);
        }
        var k = xa(n, fn(e ? e.identifierPrefix : void 0, e ? e.nonce : void 0, e ? e.bootstrapScriptContent : void 0, e ? e.bootstrapScripts : void 0, e ? e.bootstrapModules : void 0), tr(e ? e.namespaceURI : void 0), e ? e.progressiveChunkSize : void 0, e ? e.onError : void 0, l, p, y, o);
        if (e && e.signal) {
          var D = e.signal, L = function() {
            qi(k, D.reason), D.removeEventListener("abort", L);
          };
          D.addEventListener("abort", L);
        }
        Ki(k);
      });
    }
    rl.renderToReadableStream = Ql, rl.version = R;
  }()), rl;
}
var Lo, es;
process.env.NODE_ENV === "production" ? (Lo = ds(), es = ps()) : (Lo = hs(), es = vs());
Bo.version = Lo.version;
Bo.renderToString = Lo.renderToString;
Bo.renderToStaticMarkup = Lo.renderToStaticMarkup;
Bo.renderToNodeStream = Lo.renderToNodeStream;
Bo.renderToStaticNodeStream = Lo.renderToStaticNodeStream;
Bo.renderToReadableStream = es.renderToReadableStream;
function gs(X, R) {
  const Q = RegExp(X, "g");
  return (q) => {
    if (typeof q != "string")
      throw new TypeError(`expected an argument of type string, but got ${typeof q}`);
    return q.match(Q) ? q.replace(Q, R) : q;
  };
}
const ms = gs(/[A-Z]/, (X) => `-${X.toLowerCase()}`);
function ys(X, R = ms) {
  if (!X || typeof X != "object" || Array.isArray(X))
    throw new TypeError(`expected an argument of type object, but got ${typeof X}`);
  return Object.keys(X).map((Q) => `${R(Q)}: ${X[Q]};`).join(`
`);
}
const Ss = {
  acceptCharset: "accept-charset",
  accessKey: "accesskey",
  allowFullScreen: "allowfullscreen",
  autoCapitalize: "autocapitalize",
  autoComplete: "autocomplete",
  autoCorrect: "autocorrect",
  autoFocus: "autofocus",
  autoPlay: "autoplay",
  autoSave: "autosave",
  cellPadding: "cellpadding",
  cellSpacing: "cellspacing",
  charSet: "charset",
  className: "class",
  classID: "classid",
  colSpan: "colspan",
  contentEditable: "contenteditable",
  contextMenu: "contextmenu",
  controlsList: "controlslist",
  crossOrigin: "crossorigin",
  dangerouslySetInnerHTML: "dangerouslysetinnerhtml",
  dateTime: "datetime",
  defaultChecked: "defaultchecked",
  defaultValue: "defaultvalue",
  disablePictureInPicture: "disablepictureinpicture",
  disableRemotePlayback: "disableremoteplayback",
  encType: "enctype",
  enterKeyHint: "enterkeyhint",
  fetchPriority: "fetchpriority",
  htmlFor: "for",
  formMethod: "formmethod",
  formAction: "formaction",
  formEncType: "formenctype",
  formNoValidate: "formnovalidate",
  formTarget: "formtarget",
  frameBorder: "frameborder",
  hrefLang: "hreflang",
  httpEquiv: "http-equiv",
  imageSizes: "imagesizes",
  imageSrcSet: "imagesrcset",
  inputMode: "inputmode",
  itemID: "itemid",
  itemProp: "itemprop",
  itemRef: "itemref",
  itemScope: "itemscope",
  itemType: "itemtype",
  keyParams: "keyparams",
  keyType: "keytype",
  marginWidth: "marginwidth",
  marginHeight: "marginheight",
  maxLength: "maxlength",
  mediaGroup: "mediagroup",
  noModule: "nomodule",
  noValidate: "novalidate",
  playsInline: "playsinline",
  radioGroup: "radiogroup",
  readOnly: "readonly",
  referrerPolicy: "referrerpolicy",
  rowSpan: "rowspan",
  spellCheck: "spellcheck",
  srcDoc: "srcdoc",
  srcLang: "srclang",
  srcSet: "srcset",
  tabIndex: "tabindex",
  useMap: "usemap",
  accentHeight: "accent-height",
  alignmentBaseline: "alignment-baseline",
  arabicForm: "arabic-form",
  attributeName: "attributename",
  attributeType: "attributetype",
  autoReverse: "autoreverse",
  baseFrequency: "basefrequency",
  baselineShift: "baseline-shift",
  baseProfile: "baseprofile",
  calcMode: "calcmode",
  capHeight: "cap-height",
  clipPath: "clip-path",
  clipPathUnits: "clippathunits",
  clipRule: "clip-rule",
  colorInterpolation: "color-interpolation",
  colorInterpolationFilters: "color-interpolation-filters",
  colorProfile: "color-profile",
  colorRendering: "color-rendering",
  contentScriptType: "contentscripttype",
  contentStyleType: "contentstyletype",
  diffuseConstant: "diffuseconstant",
  dominantBaseline: "dominant-baseline",
  enableBackground: "enable-background",
  externalResourcesRequired: "externalresourcesrequired",
  fillOpacity: "fill-opacity",
  fillRule: "fill-rule",
  filterRes: "filterres",
  filterUnits: "filterunits",
  floodOpacity: "flood-opacity",
  floodColor: "flood-color",
  fontFamily: "font-family",
  fontSize: "font-size",
  fontSizeAdjust: "font-size-adjust",
  fontStretch: "font-stretch",
  fontStyle: "font-style",
  fontVariant: "font-variant",
  fontWeight: "font-weight",
  glyphName: "glyph-name",
  glyphOrientationHorizontal: "glyph-orientation-horizontal",
  glyphOrientationVertical: "glyph-orientation-vertical",
  gradientTransform: "gradienttransform",
  gradientUnits: "gradientunits",
  horizAdvX: "horiz-adv-x",
  horizOriginX: "horiz-origin-x",
  imageRendering: "image-rendering",
  kernelMatrix: "kernelmatrix",
  kernelUnitLength: "kernelunitlength",
  keyPoints: "keypoints",
  keySplines: "keysplines",
  keyTimes: "keytimes",
  lengthAdjust: "lengthadjust",
  letterSpacing: "letter-spacing",
  lightingColor: "lighting-color",
  limitingConeAngle: "limitingconeangle",
  markerEnd: "marker-end",
  markerHeight: "markerheight",
  markerMid: "marker-mid",
  markerStart: "marker-start",
  markerUnits: "markerunits",
  markerWidth: "markerwidth",
  maskContentUnits: "maskcontentunits",
  maskUnits: "maskunits",
  numOctaves: "numoctaves",
  overlinePosition: "overline-position",
  overlineThickness: "overline-thickness",
  paintOrder: "paint-order",
  panose1: "panose-1",
  pathLength: "pathlength",
  patternContentUnits: "patterncontentunits",
  patternTransform: "patterntransform",
  patternUnits: "patternunits",
  pointerEvents: "pointer-events",
  pointsAtX: "pointsatx",
  pointsAtY: "pointsaty",
  pointsAtZ: "pointsatz",
  preserveAlpha: "preservealpha",
  preserveAspectRatio: "preserveaspectratio",
  primitiveUnits: "primitiveunits",
  refX: "refx",
  refY: "refy",
  renderingIntent: "rendering-intent",
  repeatCount: "repeatcount",
  repeatDur: "repeatdur",
  requiredExtensions: "requiredextensions",
  requiredFeatures: "requiredfeatures",
  shapeRendering: "shape-rendering",
  slot: "slot",
  specularConstant: "specularconstant",
  specularExponent: "specularexponent",
  spreadMethod: "spreadmethod",
  startOffset: "startoffset",
  stdDeviation: "stddeviation",
  stitchTiles: "stitchtiles",
  stopColor: "stop-color",
  stopOpacity: "stop-opacity",
  strikethroughPosition: "strikethrough-position",
  strikethroughThickness: "strikethrough-thickness",
  strokeDasharray: "stroke-dasharray",
  strokeDashoffset: "stroke-dashoffset",
  strokeLinecap: "stroke-linecap",
  strokeLinejoin: "stroke-linejoin",
  strokeMiterlimit: "stroke-miterlimit",
  strokeWidth: "stroke-width",
  strokeOpacity: "stroke-opacity",
  suppressContentEditableWarning: "suppresscontenteditablewarning",
  suppressHydrationWarning: "suppresshydrationwarning",
  surfaceScale: "surfacescale",
  systemLanguage: "systemlanguage",
  tableValues: "tablevalues",
  targetX: "targetx",
  targetY: "targety",
  textAnchor: "text-anchor",
  textDecoration: "text-decoration",
  textLength: "textlength",
  textRendering: "text-rendering",
  transformOrigin: "transform-origin",
  underlinePosition: "underline-position",
  underlineThickness: "underline-thickness",
  unicodeBidi: "unicode-bidi",
  unicodeRange: "unicode-range",
  unitsPerEm: "units-per-em",
  vectorEffect: "vector-effect",
  vertAdvY: "vert-adv-y",
  vertOriginX: "vert-origin-x",
  vertOriginY: "vert-origin-y",
  wordSpacing: "word-spacing",
  writingMode: "writing-mode",
  xChannelSelector: "xchannelselector",
  xHeight: "x-height",
  xlinkActuate: "xlink:actuate",
  xlinkArcrole: "xlink:arcrole",
  xlinkHref: "xlink:href",
  xlinkRole: "xlink:role",
  xlinkShow: "xlink:show",
  xlinkTitle: "xlink:title",
  xlinkType: "xlink:type",
  xmlBase: "xml:base",
  xmlLang: "xml:lang",
  xmlnsXlink: "xmlns:xlink",
  yChannelSelector: "ychannelselector",
  zoomAndPan: "zoomandpan"
}, bs = "[react-output-target]";
function ws(X) {
  return typeof X == "string" || typeof X == "number" || typeof X == "boolean";
}
const ks = (X) => async ({ children: R, ...Q } = {}) => {
  if (!("process" in globalThis) || typeof window < "u")
    throw new Error("`createComponentForServerSideRendering` can only be run on the server");
  let q = "";
  for (const [ae, Ue] of Object.entries(Q)) {
    let z = ws(Ue) ? `"${Ue}"` : void 0;
    if (ae === "style" && typeof Ue == "object" && (z = `"${ys(Ue).replaceAll(`
`, " ")}"`), !z)
      continue;
    const M = Ss[ae] || X.properties[ae] || ae;
    q += ` ${M}=${z}`;
  }
  let v = "";
  const ue = `<${X.tagName}${q} suppressHydrationWarning="true">`;
  try {
    const ae = await ls(R);
    v = Bo.renderToString(ae);
  } catch (ae) {
    const Ue = ae instanceof Error ? ae : new Error("Unknown error");
    console.warn(
      `${bs} Failed to serialize light DOM for ${ue.slice(0, -1)} />: ${Ue.message} - this may impact the hydration of the component`
    );
  }
  const pt = `${ue}${v}</${X.tagName}>`, { html: xe } = await X.renderToString(pt, {
    fullDocument: !1,
    serializeShadowRoot: !0,
    prettyHtml: !0
  });
  if (!xe)
    throw new Error("No HTML returned from renderToString");
  const _ = xe.split(`
`), F = "<!--r.1-->", et = _[1].includes('shadowrootmode="open"');
  let B;
  et && (B = _.slice(2, _.indexOf("  </template>")).join(`
`).trim());
  const { default: pe } = await import("html-react-parser"), ct = () => pe(xe, {
    transform(ae, Ue) {
      if ("name" in Ue && Ue.name === X.tagName) {
        const z = ae.props, M = `${X.tagName}`;
        if (!et) {
          const { children: Ie, ...tt } = z || {}, Pe = _.slice(1, -1).join(`
`).trim().replace(new RegExp("(?<=>)\\s+(?=<)", "g"), "");
          return /* @__PURE__ */ el.createElement(M, { ...tt, suppressHydrationWarning: !0, dangerouslySetInnerHTML: { __html: Pe } });
        }
        return /* @__PURE__ */ el.createElement(M, { ...z, suppressHydrationWarning: !0 }, /* @__PURE__ */ el.createElement(
          "template",
          {
            shadowrootmode: "open",
            suppressHydrationWarning: !0,
            dangerouslySetInnerHTML: { __html: F + B }
          }
        ), R);
      }
    }
  });
  return /* @__PURE__ */ el.createElement(ct, null);
};
async function ls(X) {
  if (!(typeof X > "u"))
    return typeof X == "string" ? X : !X || !Array.isArray(X) ? [] : Promise.all(
      X.map(async (R) => {
        if (typeof R == "string")
          return R;
        const Q = {
          ...R.props,
          children: typeof R.props.children == "string" ? R.props.children : await ls(R.props.children)
        };
        let q = typeof R.type == "function" ? await R.type(R.props) : R.type;
        return q._payload && "then" in q._payload && (q = {
          ...q,
          _payload: await q._payload
        }), typeof (q == null ? void 0 : q._payload) == "function" && (q = {
          ...q,
          $$typeof: Symbol("react.element"),
          _payload: await q._payload(R.props)
        }, typeof q._payload.type == "function") ? q._payload.type(R.props) : {
          ...R,
          type: q,
          props: Q
        };
      })
    );
}
export {
  ks as createComponentForServerSideRendering
};
